export const slotsData = {
  trending: {
    aeroTD: {
      href: "/casino/aggapturbogames-aero",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Aero.webp",
      alt: "Aero",
      name: "Aero",
    },
    BallAndBallTD: {
      href: "/casino/aggapturbogames-ball-and-ball",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Ball&Ball.webp",
      alt: "Ball & Ball",
      name: "Ball & Ball",
    },
    crashXTD: {
      href: "/casino/aggapturbogames-crash-x",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrashX.webp",
      alt: "Crash X",
      name: "Crash X",
    },
    FruitTowersTD: {
      href: "/casino/aggapturbogames-fruit-towers",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/FruitTowers.webp",
      alt: "Fruit Towers",
      name: "Fruit Towers",
    },
    HiLoTD: {
      href: "/casino/aggapturbogames-hi-lo",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Hi-Lo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
    },
    ScratchyBigTD: {
      href: "/casino/aggaphacksawgaming-scratchy-big",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ScratchyBig.webp",
      alt: "Scratchy Big",
      name: "Scratchy Big",
    },
    KingTreasureTD: {
      href: "/casino/aggaphacksawgaming-king-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KingTreasure.webp",
      alt: "King Treasure",
      name: "King Treasure",
    },
    QueenTreasureTD: {
      href: "/casino/aggaphacksawgaming-queen-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/QueenTreasure.webp",
      alt: "Queen Treasure",
      name: "Queen Treasure",
    },
    CashPoolTD: {
      href: "/casino/aggaphacksawgaming-cash-pool",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cashpool.webp",
      alt: "Cash Pool",
      name: "Cash Pool",
    },
    GoldRushTD: {
      href: "/casino/aggaphacksawgaming-gold-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoldRush.webp",
      alt: "Gold Rush",
      name: "Gold Rush",
    },
    LuckyShotTD: {
      href: "/casino/aggaphacksawgaming-lucky-shot",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyShot.webp",
      alt: "Lucky Shot",
      name: "Lucky Shot",
    },
  },

  netent: {
    asgardianstones: {
      href: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/AsgardianStones.webp",
      alt: "Asgardian Stones",
      name: "Asgardian Stones",
    },
    SecretsOfAtlantis: {
      href: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/SecretsOfAtlantis.webp",
      alt: "Secrets of Atlantis",
      name: "Secrets of Atlantis",
    },
    SteamTower: {
      href: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/SteamTower.webp",
      alt: "Steam Tower",
      name: "Steam Tower",
    },
    DivinieFortuneMegaways: {
      href: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/DivineFortuneMegaways.webp",
      alt: "Divine Fortune Megaways",
      name: "Divine Fortune Megaways",
    },
    FruitShopMegaways: {
      href: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/FruitShopMegaways.webp",
      alt: "Fruit Shop Megaways",
      name: "Fruit Shop Megaways",
    },
    GorillaKingdom: {
      href: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/GorillaKingdom.webp",
      alt: "Gorilla Kingdom",
      name: "Gorilla Kingdom",
    },
    AlohaChristmas: {
      href: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/AlohaChristmas.webp",
      alt: "Aloha! Christmas",
      name: "Aloha! Christmas",
    },
    AlohaClusterPays: {
      href: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/AlohaClusterPays.webp",
      alt: "Aloha! Cluster Pays",
      name: "Aloha! Cluster Pays",
    },
    WildWildWestTheGreatTrainHeist: {
      href: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/WildWildWestTheGreatTrainHeist.webp",
      alt: "Wild Wild West: The Great Train Heist",
      name: "Wild Wild West: The Great Train Heist",
    },
    TwinSpinMegaways: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/TwinSpinMegaways.webp",
      alt: "Twin Spin Megaways",
      name: "Twin Spin Megaways",
    },
    TurnYourFortune: {
      href: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/TurnYourFortune.webp",
      alt: "Turn Your Fortune",
      name: "Turn Your Fortune",
    },
    PyramidQuestForImmortality: {
      href: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/PyramidQuestForImmortality.webp",
      alt: "Pyramid: Quest for Immortality",
      name: "Pyramid: Quest for Immortality",
    },
    PiggyRiches: {
      href: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/PiggyRiches.webp",
      alt: "Piggy Riches",
      name: "Piggy Riches",
    },
    DarkKingForbiddenRiches: {
      href: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/DarkKingForbiddenRiches.webp",
      alt: "Dark King: Forbidden Riches",
      name: "Dark King: Forbidden Riches",
    },
    JingleSpin: {
      href: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/JingleSpin.webp",
      alt: "Jingle Spin",
      name: "Jingle Spin",
    },
    JackHammer: {
      href: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/JackHammer.webp",
      alt: "Jack Hammer",
      name: "Jack Hammer",
    },
    DeadorAlive: {
      href: "/casino/ezgne-dead-or-alive",
      code: "1100085",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/DeadOrAlive.webp",
      alt: "Dead or Alive",
      name: "Dead or Alive",
    },
    DeadorAlive2: {
      href: "/casino/ezgne-dead-or-alive-2",
      code: "1100087",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/DeadOrAlive2.webp",
      alt: "Dead or Alive 2",
      name: "Dead or Alive 2",
    },
    JackandtheBeanstalk: {
      href: "/casino/ezgne-jack-and-the-beanstalk",
      code: "1100086",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/JackAndTheBeanstalk.webp",
      alt: "Jack and the Beanstalk",
      name: "Jack and the Beanstalk",
    },
    ElementsTheAwakening: {
      href: "/casino/ezgne-elements-the-awakening",
      code: "1100091",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/ElementsTheAwakening.webp",
      alt: "Elements: The Awakening",
      name: "Elements: The Awakening",
    },
    FinnandtheSwirlySpin: {
      href: "/casino/ezgne-finn-and-the-swirly-spin",
      code: "1100093",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/FinnAndTheSwirlySpin.webp",
      alt: "Finn and the Swirly Spin",
      name: "Finn and the Swirly Spin",
    },
    FruitShop: {
      href: "/casino/ezgne-fruit-shop",
      code: "1100095",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/FruitShop.webp",
      alt: "Fruit Shop",
      name: "Fruit Shop",
    },
    DeadorAlive2FeatureBuy: {
      href: "/casino/ezgne-dead-or-alive-2-feature-buy",
      code: "1100100",
      casino: "ezugi",
      provider: "NetEnt",
      homeUrl: "/Slots",
      imgUrl: "./images/slots/new/netent/DeadOrAlive2FeatureBuy.webp",
      alt: "Dead or Alive 2 Feature Buy",
      name: "Dead or Alive 2 Feature Buy",
    },
  },

  redtiger: {
    DragonsLuck: {
      href: "/casino/ezgrt-dragons-luck",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DragonsLuck.webp",
      alt: "Dragon's Luck",
      name: "Dragon's Luck",
    },
    DragonsLuckPowerReels: {
      href: "/casino/ezgrt-dragons-luck-power-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckPowerReels.webp",
      alt: "Dragon's Luck Power Reels",
      name: "Dragon's Luck Power Reels",
    },
    Nights10001: {
      href: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/10001Nights.webp",
      alt: "10,001 Nights",
      name: "10,001 Nights",
    },
    GodOfWealth: {
      href: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GodOfWealth.webp",
      alt: "God Of Wealth",
      name: "God Of Wealth",
    },
    PiratesPlentyBattleforGold: {
      href: "/casino/ezgrt-pirates-plenty-battle-for-gold",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/PiratesPlentyBattleforGold.webp",
      alt: "Pirates' Plenty Battle for Gold",
      name: "Pirates' Plenty Battle for Gold",
    },
    ChineseTreasures: {
      href: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ChineseTreasures.webp",
      alt: "Chinese Treasures",
      name: "Chinese Treasures",
    },
    FortuneHouse: {
      href: "/casino/ezgrt-fortune-house",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/FortuneHouse.webp",
      alt: "Fortune House",
      name: "Fortune House",
    },
    DragonsFire: {
      href: "/casino/ezgrt-dragons-fire",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DragonsFire.webp",
      alt: "Dragon's Fire",
      name: "Dragon's Fire",
    },
    MagicGate: {
      href: "/casino/ezgrt-magic-gate",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MagicGate.webp",
      alt: "Magic Gate",
      name: "Magic Gate",
    },
    LuckyFortuneCat: {
      href: "/casino/ezgrt-lucky-fortune-cat",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/LuckyFortuneCat.webp",
      alt: "Lucky Fortune Cat",
      name: "Lucky Fortune Cat",
    },
    DragonsLuckDeluxe: {
      href: "/casino/ezgrt-dragons-luck-deluxe",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckDeluxe.webp",
      alt: "Dragon's Luck Deluxe",
      name: "Dragon's Luck Deluxe",
    },
    EpicJourney: {
      href: "/casino/ezgrt-epic-journey",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/EpicJourney.webp",
      alt: "Epic Journey",
      name: "Epic Journey",
    },
    PhoenixFirePowerReels: {
      href: "/casino/ezgrt-phoenix-fire-power-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/PhoenixFirePowerReels.webp",
      alt: "Phoenix Fire Power Reels",
      name: "Phoenix Fire Power Reels",
    },
    GoldenTemple: {
      href: "/casino/ezgrt-golden-temple",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GoldenTemple.webp",
      alt: "Golden Temple",
      name: "Golden Temple",
    },
    PiratesPlenty: {
      href: "/casino/ezgrt-pirates-plenty",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/PiratesPlenty.webp",
      alt: "Pirates' Plenty",
      name: "Pirates' Plenty",
    },
    GoldenOffer: {
      href: "/casino/ezgrt-golden-offer",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GoldenOffer.webp",
      alt: "Golden Offer",
      name: "Golden Offer",
    },
    RAsLegend: {
      href: "/casino/ezgrt-ras-legend",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/RAsLegend.webp",
      alt: "RA's Legend",
      name: "RA's Legend",
    },
    GonzosQuestMegaways: {
      href: "/casino/ezgrt-gonzos-quest-megaways",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GonzosQuestMegaways.webp",
      alt: "Gonzo's Quest Megaways",
      name: "Gonzo's Quest Megaways",
    },
    RainbowJackpots: {
      href: "/casino/ezgrt-rainbow-jackpots",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpots.webp",
      alt: "Rainbow Jackpots",
      name: "Rainbow Jackpots",
    },
    MegaPyramid: {
      href: "/casino/ezgrt-mega-pyramid",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MegaPyramid.webp",
      alt: "Mega Pyramid",
      name: "Mega Pyramid",
    },
    WarOfGods: {
      href: "/casino/ezgrt-war-of-gods",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WarOfGods.webp",
      alt: "War Of Gods",
      name: "War Of Gods",
    },
    Strike777: {
      href: "/casino/ezgrt-777-strike",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/777Strike.webp",
      alt: "777 Strike",
      name: "777 Strike",
    },
    AncientsBlessing: {
      href: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/AncientsBlessing.webp",
      alt: "Ancients Blessing",
      name: "Ancients Blessing",
    },
    AurumCodex: {
      href: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/AurumCodex.webp",
      alt: "Aurum Codex",
      name: "Aurum Codex",
    },
    BettyBorisandBoo: {
      href: "/casino/ezgrt-betty-boris-and-boo",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/BettyBorisandBoo.webp",
      alt: "Betty, Boris and Boo",
      name: "Betty, Boris and Boo",
    },
    ZeusLightningPowerReels: {
      href: "/casino/ezgrt-zeus-lightning-power-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ZeusLightningPowerReels.webp",
      alt: "Zeus Lightning Power Reels",
      name: "Zeus Lightning Power Reels",
    },
    WingsofRa: {
      href: "/casino/ezgrt-wings-of-ra",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WingsofRa.webp",
      alt: "Wings of Ra",
      name: "Wings of Ra",
    },
    TreasureMine: {
      href: "/casino/ezgrt-treasure-mine",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/TreasureMine.webp",
      alt: "Treasure Mine",
      name: "Treasure Mine",
    },
    ThorsVengeance: {
      href: "/casino/ezgrt-thors-vengeance",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ThorsVengeance.webp",
      alt: "Thor's Vengeance",
      name: "Thor's Vengeance",
    },
    RegalStreak: {
      href: "/casino/ezgrt-regal-streak",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/RegalStreak.webp",
      alt: "Regal Streak",
      name: "Regal Streak",
    },
    RegalBeasts: {
      href: "/casino/ezgrt-regal-beasts",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/RegalBeasts.webp",
      alt: "Regal Beasts",
      name: "Regal Beasts",
    },
    ReelKingMega: {
      href: "/casino/ezgrt-reel-king-mega",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ReelKingMega.webp",
      alt: "Reel King Mega",
      name: "Reel King Mega",
    },
    ReelKeeper: {
      href: "/casino/ezgrt-reel-keeper",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ReelKeeper.webp",
      alt: "Reel Keeper",
      name: "Reel Keeper",
    },
    RainbowJackpotsPowerLines: {
      href: "/casino/ezgrt-rainbow-jackpots-power-lines",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpotsPowerLines.webp",
      alt: "Rainbow Jackpots Power Lines",
      name: "Rainbow Jackpots Power Lines",
    },
    MysteryReels: {
      href: "/casino/ezgrt-mystery-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MysteryReels.webp",
      alt: "Mystery Reels",
      name: "Mystery Reels",
    },
    PiggyRichesMegaways: {
      href: "/casino/ezgrt-piggy-riches-megaways",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/PiggyRichesMegaways.webp",
      alt: "Piggy Riches Megaways",
      name: "Piggy Riches Megaways",
    },
    JingleBells: {
      href: "/casino/ezgrt-jingle-bells",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/JingleBells.webp",
      alt: "Jingle Bells",
      name: "Jingle Bells",
    },
    JackinaPot: {
      href: "/casino/ezgrt-jack-in-a-pot",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/JackinaPot.webp",
      alt: "Jack in a Pot",
      name: "Jack in a Pot",
    },
    FiveStar: {
      href: "/casino/ezgrt-five-star",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/FiveStar.webp",
      alt: "Five Star",
      name: "Five Star",
    },
    BountyRaid: {
      href: "/casino/ezgrt-bounty-raid",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/BountyRaid.webp",
      alt: "Bounty Raid",
      name: "Bounty Raid",
    },
    CashUltimate: {
      href: "/casino/ezgrt-cash-ultimate",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/CashUltimate.webp",
      alt: "Cash Ultimate",
      name: "Cash Ultimate",
    },
    CashVolt: {
      href: "/casino/ezgrt-cash-volt",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/CashVolt.webp",
      alt: "Cash Volt",
      name: "Cash Volt",
    },
    DynamiteRiches: {
      href: "/casino/ezgrt-dynamite-riches",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DynamiteRiches.webp",
      alt: "Dynamite Riches",
      name: "Dynamite Riches",
    },
    DiamondBlitz: {
      href: "/casino/ezgrt-diamond-blitz",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DiamondBlitz.webp",
      alt: "Diamond Blitz",
      name: "Diamond Blitz",
    },
    DragonsFireMegaways: {
      href: "/casino/ezgrt-dragons-fire-megaways",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DragonsFireMegaways.webp",
      alt: "Dragon's Fire Megaways",
      name: "Dragon's Fire Megaways",
    },
    Squad4: {
      href: "/casino/ezgrt-4-squad",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/4Squad.webp",
      alt: "4 Squad",
      name: "4 Squad",
    },
    AgentRoyale: {
      href: "/casino/ezgrt-agent-royale",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/AgentRoyale.webp",
      alt: "Agent Royale",
      name: "Agent Royale",
    },
    Families5: {
      href: "/casino/ezgrt-5-families",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/5Families.webp",
      alt: "5 Families",
      name: "5 Families",
    },
    ArcadeBomb: {
      href: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ArcadeBomb.webp",
      alt: "Arcade Bomb",
      name: "Arcade Bomb",
    },
    CinderellasBall: {
      href: "/casino/ezgrt-cinderellas-ball",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/CinderellasBall.webp",
      alt: "Cinderella`s Ball",
      name: "Cinderella`s Ball",
    },
    Atlantis: {
      href: "/casino/ezgrt-atlantis",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/Atlantis.webp",
      alt: "Atlantis",
      name: "Atlantis",
    },
    AztecSpins: {
      href: "/casino/ezgrt-aztec-spins",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/AztecSpins.webp",
      alt: "Aztec Spins",
      name: "Aztec Spins",
    },
    ClashoftheBeasts: {
      href: "/casino/ezgrt-clash-of-the-beasts",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ClashoftheBeasts.webp",
      alt: "Clash of the Beasts",
      name: "Clash of the Beasts",
    },
    CirquedelaFortune: {
      href: "/casino/ezgrt-cirque-de-la-fortune",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/CirquedelaFortune.webp",
      alt: "Cirque de la Fortune",
      name: "Cirque de la Fortune",
    },
    CrazyGenie: {
      href: "/casino/ezgrt-crazy-genie",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/CrazyGenie.webp",
      alt: "Crazy Genie",
      name: "Crazy Genie",
    },
    CrystalMirror: {
      href: "/casino/ezgrt-crystal-mirror",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/CrystalMirror.webp",
      alt: "Crystal Mirror",
      name: "Crystal Mirror",
    },
    DevilsNumber: {
      href: "/casino/ezgrt-devils-number",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DevilsNumber.webp",
      alt: "Devil`s Number",
      name: "Devil`s Number",
    },
    DaVincisMystery: {
      href: "/casino/ezgrt-da-vincis-mystery",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DaVincisMystery.webp",
      alt: "Da Vinci`s Mystery",
      name: "Da Vinci`s Mystery",
    },
    DiceDiceDice: {
      href: "/casino/ezgrt-dice-dice-dice",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/DiceDiceDice.webp",
      alt: "Dice Dice Dice",
      name: "Dice Dice Dice",
    },
    FiveStarsPowerReels: {
      href: "/casino/ezgrt-five-stars-power-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/FiveStarsPowerReels.webp",
      alt: "Five Stars Power Reels",
      name: "Five Stars Power Reels",
    },
    GemsGoneWild: {
      href: "/casino/ezgrt-gems-gone-wild",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWild.webp",
      alt: "Gems Gone Wild",
      name: "Gems Gone Wild",
    },
    GemsGoneWildPowerReels: {
      href: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWildPowerReels.webp",
      alt: "Gems Gone Wild Power Reels",
      name: "Gems Gone Wild Power Reels",
    },
    GoldenCryptex: {
      href: "/casino/ezgrt-golden-cryptex",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GoldenCryptex.webp",
      alt: "Golden Cryptex",
      name: "Golden Cryptex",
    },
    GoldenLeprechaunMegaways: {
      href: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GoldenLeprechaunMegaways.webp",
      alt: "Golden Leprechaun Megaways",
      name: "Golden Leprechaun Megaways",
    },
    GrandWheel: {
      href: "/casino/ezgrt-grand-wheel",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GrandWheel.webp",
      alt: "Grand Wheel",
      name: "Grand Wheel",
    },
    GoldenTsar: {
      href: "/casino/ezgrt-golden-tsar",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/GoldenTsar.webp",
      alt: "Golden Tsar",
      name: "Golden Tsar",
    },
    HoardofPoseidon: {
      href: "/casino/ezgrt-hoard-of-poseidon",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/HoardofPoseidon.webp",
      alt: "Hoard of Poseidon",
      name: "Hoard of Poseidon",
    },
    JewelScarabs: {
      href: "/casino/ezgrt-jewel-scarabs",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/JewelScarabs.webp",
      alt: "Jewel Scarabs",
      name: "Jewel Scarabs",
    },
    LegendofAthena: {
      href: "/casino/ezgrt-legend-of-athena",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/LegendofAthena.webp",
      alt: "Legend of Athena",
      name: "Legend of Athena",
    },
    JingleBellsPowerReels: {
      href: "/casino/ezgrt-jingle-bells-power-reels",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/JingleBellsPowerReels.webp",
      alt: "Jingle Bells Power Reels",
      name: "Jingle Bells Power Reels",
    },
    LuckyHalloween: {
      href: "/casino/ezgrt-lucky-halloween",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/LuckyHalloween.webp",
      alt: "Lucky Halloween",
      name: "Lucky Halloween",
    },
    LuckyLittleDevil: {
      href: "/casino/ezgrt-lucky-little-devil",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/LuckyLittleDevil.webp",
      alt: "Lucky Little Devil",
      name: "Lucky Little Devil",
    },
    LuckyValentine: {
      href: "/casino/ezgrt-lucky-valentine",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/LuckyValentine.webp",
      alt: "Lucky Valentine",
      name: "Lucky Valentine",
    },
    LuckyWizard: {
      href: "/casino/ezgrt-lucky-wizard",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/LuckyWizard.webp",
      alt: "Lucky Wizard",
      name: "Lucky Wizard",
    },
    Masquerade: {
      href: "/casino/ezgrt-masquerade",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/Masquerade.webp",
      alt: "Masquerade",
      name: "Masquerade",
    },
    MayanGods: {
      href: "/casino/ezgrt-mayan-gods",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MayanGods.webp",
      alt: "Mayan Gods",
      name: "Mayan Gods",
    },
    MegaDragon: {
      href: "/casino/ezgrt-mega-dragon",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MegaDragon.webp",
      alt: "Mega Dragon",
      name: "Mega Dragon",
    },
    MegaJade: {
      href: "/casino/ezgrt-mega-jade",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MegaJade.webp",
      alt: "Mega Jade",
      name: "Mega Jade",
    },
    MegaRise: {
      href: "/casino/ezgrt-mega-rise",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MegaRise.webp",
      alt: "Mega Rise",
      name: "Mega Rise",
    },
    MultiplierRiches: {
      href: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MultiplierRiches.webp",
      alt: "Multiplier Riches",
      name: "Multiplier Riches",
    },
    MysteryReelsMegaways: {
      href: "/casino/ezgrt-mystery-reels-megaways",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/MysteryReelsMegaways.webp",
      alt: "Mystery Reels Megaways",
      name: "Mystery Reels Megaways",
    },
    NinjaWays: {
      href: "/casino/ezgrt-ninja-ways",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
      alt: "Ninja Ways",
      name: "Ninja Ways",
    },
    PathofDestiny: {
      href: "/casino/ezgrt-path-of-destiny",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/PathofDestiny.webp",
      alt: "Path of Destiny",
      name: "Path of Destiny",
    },
    PersianFortune: {
      href: "/casino/ezgrt-persian-fortune",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/PersianFortune.webp",
      alt: "Persian Fortune",
      name: "Persian Fortune",
    },
    ReelHeist: {
      href: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ReelHeist.webp",
      alt: "Reel Heist",
      name: "Reel Heist",
    },
    RobinHoodsWildForest: {
      href: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/RobinHoodsWildForest.webp",
      alt: "Robin Hood`s Wild Forest",
      name: "Robin Hood`s Wild Forest",
    },
    SnowWildAndThe7Features: {
      href: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/SnowWildAndThe7Features.webp",
      alt: "Snow Wild And The 7 Features",
      name: "Snow Wild And The 7 Features",
    },
    SylvanSpirits: {
      href: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/SylvanSpirits.webp",
      alt: "Sylvan Spirits",
      name: "Sylvan Spirits",
    },
    TheGreatestTrainRobbery: {
      href: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/TheGreatestTrainRobbery.webp",
      alt: "The Greatest Train Robbery",
      name: "The Greatest Train Robbery",
    },
    TheWildHatter: {
      href: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/TheWildHatter.webp",
      alt: "The Wild Hatter",
      name: "The Wild Hatter",
    },
    ThorsLightning: {
      href: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/ThorsLightning.webp",
      alt: "Thor`s Lightning",
      name: "Thor`s Lightning",
    },
    TikiFruits: {
      href: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/TikiFruits.webp",
      alt: "Tiki Fruits",
      name: "Tiki Fruits",
    },
    VaultCracker: {
      href: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/VaultCracker.webp",
      alt: "Vault Cracker",
      name: "Vault Cracker",
    },
    TotemLightning: {
      href: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/TotemLightning.webp",
      alt: "Totem Lightning",
      name: "Totem Lightning",
    },
    WellofWishes: {
      href: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WellofWishes.webp",
      alt: "Well of Wishes",
      name: "Well of Wishes",
    },
    VaultofAnubis: {
      href: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/VaultofAnubis.webp",
      alt: "Vault of Anubis",
      name: "Vault of Anubis",
    },
    WildOClock: {
      href: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WildOClock.webp",
      alt: "Wild O`Clock",
      name: "Wild O`Clock",
    },
    WildCatsMultiline: {
      href: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WildCatsMultiline.webp",
      alt: "Wild Cats Multiline",
      name: "Wild Cats Multiline",
    },
    YucatansMystery: {
      href: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/YucatansMystery.webp",
      alt: "Yucatan`s Mystery",
      name: "Yucatan`s Mystery",
    },
    WildWildChest: {
      href: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WildWildChest.webp",
      alt: "Wild Wild Chest",
      name: "Wild Wild Chest",
    },
    WinEscalator: {
      href: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      provider: "RedTiger",
      homeUrl: "/slots-games",
      imgUrl: "./images/slots/new/redtiger/WinEscalator.webp",
      alt: "Win Escalator",
      name: "Win Escalator",
    },

    // CloverCraze: {
    //   href: "/casino/qtechredtiger-clover-craze",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Clover Craze",
    //   name: "Clover Craze",
    // },
    // AliBabasLuck: {
    //   href: "/casino/qtechredtiger-ali-babas-luck",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ali Baba's Luck",
    //   name: "Ali Baba's Luck",
    // },
    // VaultCrackerMEGAWAYS: {
    //   href: "/casino/qtechredtiger-vault-cracker-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Vault Cracker MEGAWAYS",
    //   name: "Vault Cracker MEGAWAYS",
    // },
    // EpicTreasure: {
    //   href: "/casino/qtechredtiger-epic-treasure",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Epic Treasure",
    //   name: "Epic Treasure",
    // },
    // Spins80s: {
    //   href: "/casino/qtechredtiger-80s-spins",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "80's Spins",
    //   name: "80's Spins",
    // },
    // LeprechaunsMagicMEGAWAYS: {
    //   href: "/casino/qtechredtiger-leprechauns-magic-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Leprechaun's Magic MEGAWAYS",
    //   name: "Leprechaun's Magic MEGAWAYS",
    // },
    // DreamDestiny: {
    //   href: "/casino/qtechredtiger-dream-destiny",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dream Destiny",
    //   name: "Dream Destiny",
    // },
    // ChineseWilds: {
    //   href: "/casino/qtechredtiger-chinese-wilds",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Chinese Wilds",
    //   name: "Chinese Wilds",
    // },
    // GoldenLamps: {
    //   href: "/casino/qtechredtiger-golden-lamps",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Lamps",
    //   name: "Golden Lamps",
    // },
    // GoldenToad: {
    //   href: "/casino/qtechredtiger-golden-toad",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Toad",
    //   name: "Golden Toad",
    // },
    // MacauRacing: {
    //   href: "/casino/qtechredtiger-macau-racing",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Macau Racing",
    //   name: "Macau Racing",
    // },
    // RedHotSlot: {
    //   href: "/casino/qtechredtiger-red-hot-slot",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Red Hot Slot",
    //   name: "Red Hot Slot",
    // },
    // AsianFortune: {
    //   href: "/casino/qtechredtiger-asian-fortune",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Asian Fortune",
    //   name: "Asian Fortune",
    // },
    // DragonPearl: {
    //   href: "/casino/qtechredtiger-dragon-pearl",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon Pearl",
    //   name: "Dragon Pearl",
    // },
    // JellyMultihops: {
    //   href: "/casino/qtechredtiger-jelly-multihops",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jelly Multihops",
    //   name: "Jelly Multihops",
    // },
    // LeprechaunsMagic: {
    //   href: "/casino/qtechredtiger-leprechauns-magic",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Leprechaun's Magic",
    //   name: "Leprechaun's Magic",
    // },
    // Astros: {
    //   href: "/casino/qtechredtiger-astros",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Astros",
    //   name: "Astros",
    // },
    // ElephantTreasure: {
    //   href: "/casino/qtechredtiger-elephant-treasure",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Elephant Treasure",
    //   name: "Elephant Treasure",
    // },
    // LuckyCarnival: {
    //   href: "/casino/qtechredtiger-lucky-carnival",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Carnival",
    //   name: "Lucky Carnival",
    // },
    // CasinoSpin: {
    //   href: "/casino/qtechredtiger-casino-spin",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Casino Spin",
    //   name: "Casino Spin",
    // },
    // CobraQueen: {
    //   href: "/casino/qtechredtiger-cobra-queen",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cobra Queen",
    //   name: "Cobra Queen",
    // },
    // AliBabasLuckMEGAWAYS: {
    //   href: "/casino/qtechredtiger-ali-babas-luck-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ali Baba's Luck MEGAWAYS",
    //   name: "Ali Baba's Luck MEGAWAYS",
    // },
    // AmazonIslandMEGAWAYS: {
    //   href: "/casino/qtechredtiger-amazon-island-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Amazon Island MEGAWAYS",
    //   name: "Amazon Island MEGAWAYS",
    // },
    // WantedWildz: {
    //   href: "/casino/qtechredtiger-wanted-wildz",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wanted Wildz",
    //   name: "Wanted Wildz",
    // },
    // LeprechaunsMagicPOWERREELS: {
    //   href: "/casino/qtechredtiger-leprechauns-magic-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Leprechaun's Magic POWER REELS",
    //   name: "Leprechaun's Magic POWER REELS",
    // },
    // CottonGangAffair: {
    //   href: "/casino/qtechredtiger-cotton-gang-affair",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cotton Gang Affair",
    //   name: "Cotton Gang Affair",
    // },
    // AliBabasLuckPOWERREELS: {
    //   href: "/casino/qtechredtiger-ali-babas-luck-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ali Baba's Luck POWER REELS",
    //   name: "Ali Baba's Luck POWER REELS",
    // },
    // SeaBoatAdventure: {
    //   href: "/casino/qtechredtiger-sea-boat-adventure",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sea Boat Adventure",
    //   name: "Sea Boat Adventure",
    // },
    // ChristmasMULTIHOPS: {
    //   href: "/casino/qtechredtiger-christmas-multihops",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Christmas MULTIHOPS",
    //   name: "Christmas MULTIHOPS",
    // },
    // ChristmasMorning: {
    //   href: "/casino/qtechredtiger-christmas-morning",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Christmas Morning",
    //   name: "Christmas Morning",
    // },
    // SteamSquad: {
    //   href: "/casino/qtechredtiger-steam-squad",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Steam Squad",
    //   name: "Steam Squad",
    // },
    // GigaBlast: {
    //   href: "/casino/qtechredtiger-giga-blast",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Giga Blast",
    //   name: "Giga Blast",
    // },
    // SugarliciousEveryWay: {
    //   href: "/casino/qtechredtiger-sugarlicious-everyway",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sugarlicious EveryWay",
    //   name: "Sugarlicious EveryWay",
    // },
    // SpookyCarnival: {
    //   href: "/casino/qtechredtiger-spooky-carnival",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Spooky Carnival",
    //   name: "Spooky Carnival",
    // },
    // DragonsMirror: {
    //   href: "/casino/qtechredtiger-dragons-mirror",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon’s Mirror",
    //   name: "Dragon’s Mirror",
    // },
    // SirensRiches: {
    //   href: "/casino/qtechredtiger-sirens-riches",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sirens’ Riches",
    //   name: "Sirens’ Riches",
    // },
    // YearRoundRichesClusterbuster: {
    //   href: "/casino/qtechredtiger-year-round-riches-clusterbuster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Year-Round Riches Clusterbuster",
    //   name: "Year-Round Riches Clusterbuster",
    // },
    // GoddessoftheMoon: {
    //   href: "/casino/qtechredtiger-goddess-of-the-moon",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Goddess of the Moon",
    //   name: "Goddess of the Moon",
    // },
    // HanselAndGretelCandyhouse: {
    //   href: "/casino/qtechredtiger-hansel-and-gretel-candyhouse",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Hansel & Gretel Candyhouse",
    //   name: "Hansel & Gretel Candyhouse",
    // },
    // SugarMonster: {
    //   href: "/casino/qtechredtiger-sugar-monster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sugar Monster",
    //   name: "Sugar Monster",
    // },
    // BountyRaid2: {
    //   href: "/casino/qtechredtiger-bounty-raid-2",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Bounty Raid 2",
    //   name: "Bounty Raid 2",
    // },
    // MonstersUnchained: {
    //   href: "/casino/qtechredtiger-monsters-unchained",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Monsters Unchained",
    //   name: "Monsters Unchained",
    // },
    // HereKittyKitty: {
    //   href: "/casino/qtechredtiger-here-kitty-kitty",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Here Kitty Kitty",
    //   name: "Here Kitty Kitty",
    // },
    // LondonTube: {
    //   href: "/casino/qtechredtiger-london-tube",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "London Tube",
    //   name: "London Tube",
    // },
    // CyberAttack: {
    //   href: "/casino/qtechredtiger-cyber-attack",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cyber Attack",
    //   name: "Cyber Attack",
    // },
    // MagicTricks: {
    //   href: "/casino/qtechredtiger-magic-tricks",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Magic Tricks",
    //   name: "Magic Tricks",
    // },
    // Astronaut: {
    //   href: "/casino/qtechredtiger-astronaut",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Astronaut",
    //   name: "Astronaut",
    // },
    // GemsInfernoMegaways: {
    //   href: "/casino/qtechredtiger-gems-inferno-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gems Inferno Megaways",
    //   name: "Gems Inferno Megaways",
    // },
    // Squad4Qt: {
    //   href: "/casino/qtechredtiger-4-squad",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "4 Squad",
    //   name: "4 Squad",
    // },
    // Families5Qt: {
    //   href: "/casino/qtechredtiger-5-families",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "5 Families",
    //   name: "5 Families",
    // },
    // Hour24GrandPrix: {
    //   href: "/casino/qtechredtiger-24-hour-grand-prix",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "24 Hour Grand Prix",
    //   name: "24 Hour Grand Prix",
    // },
    // Strike777Qt: {
    //   href: "/casino/qtechredtiger-777-strike",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "777 Strike",
    //   name: "777 Strike",
    // },
    // Sky1942Warrior: {
    //   href: "/casino/qtechredtiger-1942-sky-warrior",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "1942: Sky Warrior",
    //   name: "1942: Sky Warrior",
    // },
    // Nights10001Qt: {
    //   href: "/casino/qtechredtiger-10001-nights",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "10001 Nights",
    //   name: "10001 Nights",
    // },
    // Nights10001Megaways: {
    //   href: "/casino/qtechredtiger-10001-nights-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "10001 Nights Megaways",
    //   name: "10001 Nights Megaways",
    // },
    // AgentRoyaleQt: {
    //   href: "/casino/qtechredtiger-agent-royale",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Agent Royale",
    //   name: "Agent Royale",
    // },
    // AgeofAkkadia: {
    //   href: "/casino/qtechredtiger-age-of-akkadia",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Age of Akkadia",
    //   name: "Age of Akkadia",
    // },
    // AlexanderTheGreatWorldConqueror: {
    //   href: "/casino/qtechredtiger-alexander-the-great-world-conqueror",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Alexander The Great World Conqueror",
    //   name: "Alexander The Great World Conqueror",
    // },
    // AncientsBlessingQt: {
    //   href: "/casino/qtechredtiger-ancients-blessing",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ancients' Blessing",
    //   name: "Ancients' Blessing",
    // },
    // AncientDisco: {
    //   href: "/casino/qtechredtiger-ancient-disco",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ancient Disco",
    //   name: "Ancient Disco",
    // },
    // AncientScript: {
    //   href: "/casino/qtechredtiger-ancient-script",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ancient Script",
    //   name: "Ancient Script",
    // },
    // ApacheWay: {
    //   href: "/casino/qtechredtiger-apache-way",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Apache Way",
    //   name: "Apache Way",
    // },
    // ArcadeBombQt: {
    //   href: "/casino/qtechredtiger-arcade-bomb",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Arcade Bomb",
    //   name: "Arcade Bomb",
    // },
    // AthensMegaways: {
    //   href: "/casino/qtechredtiger-athens-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Athens Megaways",
    //   name: "Athens Megaways",
    // },
    // AtlantisQt: {
    //   href: "/casino/qtechredtiger-atlantis",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Atlantis",
    //   name: "Atlantis",
    // },
    // AurumCodexQt: {
    //   href: "/casino/qtechredtiger-aurum-codex",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Aurum Codex",
    //   name: "Aurum Codex",
    // },
    // AztecSpinsQt: {
    //   href: "/casino/qtechredtiger-aztec-spins",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Aztec Spins",
    //   name: "Aztec Spins",
    // },
    // BassBoss: {
    //   href: "/casino/qtechredtiger-bass-boss",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Bass Boss",
    //   name: "Bass Boss",
    // },
    // BettyBorisandBooQt: {
    //   href: "/casino/qtechredtiger-betty-boris-and-boo",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Betty Boris and Boo",
    //   name: "Betty Boris and Boo",
    // },
    // BigCatRescueMegaways: {
    //   href: "/casino/qtechredtiger-big-cat-rescue-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Big Cat Rescue Megaways",
    //   name: "Big Cat Rescue Megaways",
    // },
    // BlazingClusters: {
    //   href: "/casino/qtechredtiger-blazing-clusters",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Blazing Clusters",
    //   name: "Blazing Clusters",
    // },
    // BlobstersClusterbuster: {
    //   href: "/casino/qtechredtiger-blobsters-clusterbuster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Blobsters Clusterbuster",
    //   name: "Blobsters Clusterbuster",
    // },
    // BloodSuckersMegaways: {
    //   href: "/casino/qtechredtiger-blood-suckers-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Blood Suckers Megaways",
    //   name: "Blood Suckers Megaways",
    // },
    // BlueDiamond: {
    //   href: "/casino/qtechredtiger-blue-diamond",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Blue Diamond",
    //   name: "Blue Diamond",
    // },
    // Bombuster: {
    //   href: "/casino/qtechredtiger-bombuster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Bombuster",
    //   name: "Bombuster",
    // },
    // BountyRaidQt: {
    //   href: "/casino/qtechredtiger-bounty-raid",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Bounty Raid",
    //   name: "Bounty Raid",
    // },
    // BuffaloManiaMegaways: {
    //   href: "/casino/qtechredtiger-buffalo-mania-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Buffalo Mania Megaways",
    //   name: "Buffalo Mania Megaways",
    // },
    // BugsysBar: {
    //   href: "/casino/qtechredtiger-bugsys-bar",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Bugsy’s Bar",
    //   name: "Bugsy’s Bar",
    // },
    // BullsRunWild: {
    //   href: "/casino/qtechredtiger-bulls-run-wild",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Bulls Run Wild",
    //   name: "Bulls Run Wild",
    // },
    // CaiShen168: {
    //   href: "/casino/qtechredtiger-cai-shen-168",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cai Shen 168",
    //   name: "Cai Shen 168",
    // },
    // CakeAndIceCream: {
    //   href: "/casino/qtechredtiger-cake-and-ice-cream",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cake & Ice Cream",
    //   name: "Cake & Ice Cream",
    // },
    // CashorNothing: {
    //   href: "/casino/qtechredtiger-cash-or-nothing",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cash or Nothing",
    //   name: "Cash or Nothing",
    // },
    // CashUltimateQt: {
    //   href: "/casino/qtechredtiger-cash-ultimate",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cash Ultimate",
    //   name: "Cash Ultimate",
    // },
    // CashVoltQt: {
    //   href: "/casino/qtechredtiger-cash-volt",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cash Volt",
    //   name: "Cash Volt",
    // },
    // ChineseTreasuresQt: {
    //   href: "/casino/qtechredtiger-chinese-treasures",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Chinese Treasures",
    //   name: "Chinese Treasures",
    // },
    // CinderellasBallQt: {
    //   href: "/casino/qtechredtiger-cinderellas-ball",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cinderella's Ball",
    //   name: "Cinderella's Ball",
    // },
    // CirquedеlaFortune: {
    //   href: "/casino/qtechredtiger-cirque-de-la-fortune",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cirque dе la Fortune",
    //   name: "Cirque dе la Fortune",
    // },
    // ClashoftheBeastsQt: {
    //   href: "/casino/qtechredtiger-clash-of-the-beasts",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Clash of the Beasts",
    //   name: "Clash of the Beasts",
    // },
    // CrazyGenieQt: {
    //   href: "/casino/qtechredtiger-crazy-genie",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Crazy Genie",
    //   name: "Crazy Genie",
    // },
    // CrystalMirrorQt: {
    //   href: "/casino/qtechredtiger-crystal-mirror",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Crystal Mirror",
    //   name: "Crystal Mirror",
    // },
    // DevilsNumberQt: {
    //   href: "/casino/qtechredtiger-devils-number",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Devil's Number",
    //   name: "Devil's Number",
    // },
    // DiamondBlitzQt: {
    //   href: "/casino/qtechredtiger-diamond-blitz",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Diamond Blitz",
    //   name: "Diamond Blitz",
    // },
    // DiamondRoyale: {
    //   href: "/casino/qtechredtiger-diamond-royale",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Diamond Royale",
    //   name: "Diamond Royale",
    // },
    // DiceDiceDiceQt: {
    //   href: "/casino/qtechredtiger-dice-dice-dice",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dice Dice Dice",
    //   name: "Dice Dice Dice",
    // },
    // DivineWays: {
    //   href: "/casino/qtechredtiger-divine-ways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Divine Ways",
    //   name: "Divine Ways",
    // },
    // DoggyRichesMegaways: {
    //   href: "/casino/qtechredtiger-doggy-riches-megawaystm",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Doggy Riches Megaways™",
    //   name: "Doggy Riches Megaways™",
    // },
    // DraculaAwakening: {
    //   href: "/casino/qtechredtiger-dracula-awakening",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dracula Awakening",
    //   name: "Dracula Awakening",
    // },
    // DragonsClusterbuster: {
    //   href: "/casino/qtechredtiger-dragons-clusterbuster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragons Clusterbuster",
    //   name: "Dragons Clusterbuster",
    // },
    // DragonsFireQt: {
    //   href: "/casino/qtechredtiger-dragons-fire",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon's Fire",
    //   name: "Dragon's Fire",
    // },
    // DragonsFireINFINIREELS: {
    //   href: "/casino/qtechredtiger-dragons-fire-infinireels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon's Fire INFINIREELS",
    //   name: "Dragon's Fire INFINIREELS",
    // },
    // DragonKingLegendoftheSeas: {
    //   href: "/casino/qtechredtiger-dragon-king-legend-of-the-seas",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon King: Legend of the Seas",
    //   name: "Dragon King: Legend of the Seas",
    // },
    // DragonsLuckQt: {
    //   href: "/casino/qtechredtiger-dragons-luck",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon's Luck",
    //   name: "Dragon's Luck",
    // },
    // DragonsLuckDeluxeQt: {
    //   href: "/casino/qtechredtiger-dragons-luck-deluxe",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon's Luck Deluxe",
    //   name: "Dragon's Luck Deluxe",
    // },
    // DragonsLuckMegaWays: {
    //   href: "/casino/qtechredtiger-dragons-luck-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon's Luck MegaWays",
    //   name: "Dragon's Luck MegaWays",
    // },
    // DragonsLuckPowerReelsQt: {
    //   href: "/casino/qtechredtiger-dragons-luck-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragon's Luck Power Reels",
    //   name: "Dragon's Luck Power Reels",
    // },
    // DynamiteRichesQt: {
    //   href: "/casino/qtechredtiger-dynamite-riches",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dynamite Riches",
    //   name: "Dynamite Riches",
    // },
    // DynamiteRichesMegaways: {
    //   href: "/casino/qtechredtiger-dynamite-riches-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dynamite Riches Megaways",
    //   name: "Dynamite Riches Megaways",
    // },
    // EgyptMegaways: {
    //   href: "/casino/qtechredtiger-egypt-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Egypt Megaways",
    //   name: "Egypt Megaways",
    // },
    // ElvenMagic: {
    //   href: "/casino/qtechredtiger-elven-magic",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Elven Magic",
    //   name: "Elven Magic",
    // },
    // EmeraldDiamond: {
    //   href: "/casino/qtechredtiger-emerald-diamond",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Emerald Diamond",
    //   name: "Emerald Diamond",
    // },
    // EpicJourneyQt: {
    //   href: "/casino/qtechredtiger-epic-journey",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Epic Journey",
    //   name: "Epic Journey",
    // },
    // EsqueletoMariachi: {
    //   href: "/casino/qtechredtiger-esqueleto-mariachi",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Esqueleto Mariachi",
    //   name: "Esqueleto Mariachi",
    // },
    // FaFaBabies: {
    //   href: "/casino/qtechredtiger-fa-fa-babies",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fa Fa Babies",
    //   name: "Fa Fa Babies",
    // },
    // FlamingFox: {
    //   href: "/casino/qtechredtiger-flaming-fox",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Flaming Fox",
    //   name: "Flaming Fox",
    // },
    // FiveStarQt: {
    //   href: "/casino/qtechredtiger-five-star",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Five Star",
    //   name: "Five Star",
    // },
    // FiveStarPowerReels: {
    //   href: "/casino/qtechredtiger-five-star-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Five Star Power Reels",
    //   name: "Five Star Power Reels",
    // },
    // Flodder: {
    //   href: "/casino/qtechredtiger-flodder",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Flodder",
    //   name: "Flodder",
    // },
    // Forever7s: {
    //   href: "/casino/qtechredtiger-forever-7s",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Forever 7's",
    //   name: "Forever 7's",
    // },
    // FortuneCharm: {
    //   href: "/casino/qtechredtiger-fortune-charm",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fortune Charm",
    //   name: "Fortune Charm",
    // },
    // FortuneFest: {
    //   href: "/casino/qtechredtiger-fortune-fest",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fortune Fest",
    //   name: "Fortune Fest",
    // },
    // FortuneHouseQt: {
    //   href: "/casino/qtechredtiger-fortune-house",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fortune House",
    //   name: "Fortune House",
    // },
    // FruitBlox: {
    //   href: "/casino/qtechredtiger-fruit-blox",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fruit Blox",
    //   name: "Fruit Blox",
    // },
    // FruitSnap: {
    //   href: "/casino/qtechredtiger-fruit-snap",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fruit Snap",
    //   name: "Fruit Snap",
    // },
    // GemsGoneWildQt: {
    //   href: "/casino/qtechredtiger-gems-gone-wild",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gems Gone Wild",
    //   name: "Gems Gone Wild",
    // },
    // GemsGoneWildPowerReelsQt: {
    //   href: "/casino/qtechredtiger-gems-gone-wild-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gems Gone Wild Power Reels",
    //   name: "Gems Gone Wild Power Reels",
    // },
    // Gemtastic: {
    //   href: "/casino/qtechredtiger-gemtastic",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gemtastic",
    //   name: "Gemtastic",
    // },
    // GenieNights: {
    //   href: "/casino/qtechredtiger-genie-nights",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Genie Nights",
    //   name: "Genie Nights",
    // },
    // GettheGoldINFINIREELS: {
    //   href: "/casino/qtechredtiger-get-the-gold-infinireelstm",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Get the Gold INFINIREELS™",
    //   name: "Get the Gold INFINIREELS™",
    // },
    // GodsofTroy: {
    //   href: "/casino/qtechredtiger-gods-of-troy",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gods of Troy",
    //   name: "Gods of Troy",
    // },
    // GoldStar: {
    //   href: "/casino/qtechredtiger-gold-star",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gold Star",
    //   name: "Gold Star",
    // },
    // GodofWealth: {
    //   href: "/casino/qtechredtiger-god-of-wealth",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "God of Wealth",
    //   name: "God of Wealth",
    // },
    // GoldenCryptexQt: {
    //   href: "/casino/qtechredtiger-golden-cryptex",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Cryptex",
    //   name: "Golden Cryptex",
    // },
    // GoldenOfferQt: {
    //   href: "/casino/qtechredtiger-golden-offer",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Offer",
    //   name: "Golden Offer",
    // },
    // GoldenLotus: {
    //   href: "/casino/qtechredtiger-golden-lotus",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Lotus",
    //   name: "Golden Lotus",
    // },
    // GoldenTempleQt: {
    //   href: "/casino/qtechredtiger-golden-temple",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Temple",
    //   name: "Golden Temple",
    // },
    // GoldenTsarQt: {
    //   href: "/casino/qtechredtiger-golden-tsar",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Golden Tsar",
    //   name: "Golden Tsar",
    // },
    // GonzitasQuest: {
    //   href: "/casino/qtechredtiger-gonzitas-quest",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gonzita’s Quest",
    //   name: "Gonzita’s Quest",
    // },
    // GonzosQuestMegawaysQt: {
    //   href: "/casino/qtechredtiger-gonzos-questtm-megawaystm",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gonzo's Quest™ Megaways™",
    //   name: "Gonzo's Quest™ Megaways™",
    // },
    // GoodLuckClusterbuster: {
    //   href: "/casino/qtechredtiger-good-luck-clusterbuster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Good Luck Clusterbuster",
    //   name: "Good Luck Clusterbuster",
    // },
    // GrandWheelQt: {
    //   href: "/casino/qtechredtiger-grand-wheel",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Grand Wheel",
    //   name: "Grand Wheel",
    // },
    // GreatGold: {
    //   href: "/casino/qtechredtiger-great-gold",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Great Gold",
    //   name: "Great Gold",
    // },
    // HammerGods: {
    //   href: "/casino/qtechredtiger-hammer-gods",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Hammer Gods",
    //   name: "Hammer Gods",
    // },
    // HappyApples: {
    //   href: "/casino/qtechredtiger-happy-apples",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Happy Apples",
    //   name: "Happy Apples",
    // },
    // HarleCoin: {
    //   href: "/casino/qtechredtiger-harlecoin",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "HarleCoin",
    //   name: "HarleCoin",
    // },
    // HoardofPoseidonQt: {
    //   href: "/casino/qtechredtiger-hoard-of-poseidon",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Hoard of Poseidon",
    //   name: "Hoard of Poseidon",
    // },
    // HotHotChilliPot: {
    //   href: "/casino/qtechredtiger-hot-hot-chilli-pot",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Hot Hot Chilli Pot",
    //   name: "Hot Hot Chilli Pot",
    // },
    // Hustling: {
    //   href: "/casino/qtechredtiger-hustling",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Hustling",
    //   name: "Hustling",
    // },
    // ImperialPalace: {
    //   href: "/casino/qtechredtiger-imperial-palace",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Imperial Palace",
    //   name: "Imperial Palace",
    // },
    // IntheRabbitHole: {
    //   href: "/casino/qtechredtiger-in-the-rabbit-hole",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "In the Rabbit Hole",
    //   name: "In the Rabbit Hole",
    // },
    // JackInAPot: {
    //   href: "/casino/qtechredtiger-jack-in-a-pot",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jack In A Pot",
    //   name: "Jack In A Pot",
    // },
    // JackpotQuest: {
    //   href: "/casino/qtechredtiger-jackpot-quest",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jackpot Quest",
    //   name: "Jackpot Quest",
    // },
    // JadeCharms: {
    //   href: "/casino/qtechredtiger-jade-charms",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jade Charms",
    //   name: "Jade Charms",
    // },
    // JesterSpins: {
    //   href: "/casino/qtechredtiger-jester-spins",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jester Spins",
    //   name: "Jester Spins",
    // },
    // JewelScarabsQt: {
    //   href: "/casino/qtechredtiger-jewel-scarabs",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jewel Scarabs",
    //   name: "Jewel Scarabs",
    // },
    // JingleBellsQt: {
    //   href: "/casino/qtechredtiger-jingle-bells",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jingle Bells",
    //   name: "Jingle Bells",
    // },
    // JingleBellsPowerReelsQt: {
    //   href: "/casino/qtechredtiger-jingle-bells-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jingle Bells Power Reels",
    //   name: "Jingle Bells Power Reels",
    // },
    // JingleWaysMegaways: {
    //   href: "/casino/qtechredtiger-jingle-ways-megawaystm",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Jingle Ways Megaways™",
    //   name: "Jingle Ways Megaways™",
    // },
    // JoeExotic: {
    //   href: "/casino/qtechredtiger-joe-exotic",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Joe Exotic",
    //   name: "Joe Exotic",
    // },
    // KnightsOfAvalon: {
    //   href: "/casino/qtechredtiger-knights-of-avalon",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Knights Of Avalon",
    //   name: "Knights Of Avalon",
    // },
    // LaserFruit: {
    //   href: "/casino/qtechredtiger-laser-fruit",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Laser Fruit",
    //   name: "Laser Fruit",
    // },
    // LastChanceSaloon: {
    //   href: "/casino/qtechredtiger-last-chance-saloon",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Last Chance Saloon",
    //   name: "Last Chance Saloon",
    // },
    // LegendOfAthena: {
    //   href: "/casino/qtechredtiger-legend-of-athena",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Legend Of Athena",
    //   name: "Legend Of Athena",
    // },
    // LegendaryExcalibur: {
    //   href: "/casino/qtechredtiger-legendary-excalibur",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Legendary Excalibur",
    //   name: "Legendary Excalibur",
    // },
    // LionDance: {
    //   href: "/casino/qtechredtiger-lion-dance",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lion Dance",
    //   name: "Lion Dance",
    // },
    // LionsHoard: {
    //   href: "/casino/qtechredtiger-lions-hoard",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lion's Hoard",
    //   name: "Lion's Hoard",
    // },
    // LuckyEaster: {
    //   href: "/casino/qtechredtiger-lucky-easter",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Easter",
    //   name: "Lucky Easter",
    // },
    // LuckyFortuneCatQt: {
    //   href: "/casino/qtechredtiger-lucky-fortune-cat",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Fortune Cat",
    //   name: "Lucky Fortune Cat",
    // },
    // LuckyFridays: {
    //   href: "/casino/qtechredtiger-lucky-fridays",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Fridays",
    //   name: "Lucky Fridays",
    // },
    // LuckyHalloweenQt: {
    //   href: "/casino/qtechredtiger-lucky-halloween",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Halloween",
    //   name: "Lucky Halloween",
    // },
    // LuckyOktoberfest: {
    //   href: "/casino/qtechredtiger-lucky-oktoberfest",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Oktoberfest",
    //   name: "Lucky Oktoberfest",
    // },
    // LuckyValentineQt: {
    //   href: "/casino/qtechredtiger-lucky-valentine",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Valentine",
    //   name: "Lucky Valentine",
    // },
    // LuckyWizardQt: {
    //   href: "/casino/qtechredtiger-lucky-wizard",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Lucky Wizard",
    //   name: "Lucky Wizard",
    // },
    // MagicGateQt: {
    //   href: "/casino/qtechredtiger-magic-gate",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Magic Gate",
    //   name: "Magic Gate",
    // },
    // MagicPowersMegaways: {
    //   href: "/casino/qtechredtiger-magic-powers-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Magic Powers Megaways",
    //   name: "Magic Powers Megaways",
    // },
    // MajesticMysteriesPowerReels: {
    //   href: "/casino/qtechredtiger-majestic-mysteries-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Majestic Mysteries Power Reels",
    //   name: "Majestic Mysteries Power Reels",
    // },
    // MasqueradeQt: {
    //   href: "/casino/qtechredtiger-masquerade",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Masquerade",
    //   name: "Masquerade",
    // },
    // MayanGodsQt: {
    //   href: "/casino/qtechredtiger-mayan-gods",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mayan Gods",
    //   name: "Mayan Gods",
    // },
    // Mayhem: {
    //   href: "/casino/qtechredtiger-mayhem",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mayhem",
    //   name: "Mayhem",
    // },
    // MegaDragonQt: {
    //   href: "/casino/qtechredtiger-mega-dragon",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mega Dragon",
    //   name: "Mega Dragon",
    // },
    // MegaJadeQt: {
    //   href: "/casino/qtechredtiger-mega-jade",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mega Jade",
    //   name: "Mega Jade",
    // },
    // MegaPyramidQt: {
    //   href: "/casino/qtechredtiger-mega-pyramid",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mega Pyramid",
    //   name: "Mega Pyramid",
    // },
    // MegaRiseQt: {
    //   href: "/casino/qtechredtiger-mega-rise",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mega Rise",
    //   name: "Mega Rise",
    // },
    // MultiplierRichesQt: {
    //   href: "/casino/qtechredtiger-multiplier-riches",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Multiplier Riches",
    //   name: "Multiplier Riches",
    // },
    // MysteryReelsQt: {
    //   href: "/casino/qtechredtiger-mystery-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mystery Reels",
    //   name: "Mystery Reels",
    // },
    // MysteryReelsDeluxe: {
    //   href: "/casino/qtechredtiger-mystery-reels-deluxe",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mystery Reels Deluxe",
    //   name: "Mystery Reels Deluxe",
    // },
    // MysteryReelsMegaWaysQt: {
    //   href: "/casino/qtechredtiger-mystery-reels-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mystery Reels MegaWays",
    //   name: "Mystery Reels MegaWays",
    // },
    // MysticStaxx: {
    //   href: "/casino/qtechredtiger-mystic-staxx",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mystic Staxx",
    //   name: "Mystic Staxx",
    // },
    // MysticWheel: {
    //   href: "/casino/qtechredtiger-mystic-wheel",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Mystic Wheel",
    //   name: "Mystic Wheel",
    // },
    // NarcosMexico: {
    //   href: "/casino/qtechredtiger-narcos-mexico",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Narcos Mexico",
    //   name: "Narcos Mexico",
    // },
    // NeonLinks: {
    //   href: "/casino/qtechredtiger-neon-links",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Neon Links",
    //   name: "Neon Links",
    // },
    // NFTMegaways: {
    //   href: "/casino/qtechredtiger-nft-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "NFT Megaways",
    //   name: "NFT Megaways",
    // },
    // NightRoller: {
    //   href: "/casino/qtechredtiger-night-roller",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Night Roller",
    //   name: "Night Roller",
    // },
    // NinjaWaysQt: {
    //   href: "/casino/qtechredtiger-ninja-ways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ninja Ways",
    //   name: "Ninja Ways",
    // },
    // OceanFortune: {
    //   href: "/casino/qtechredtiger-ocean-fortune",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ocean Fortune",
    //   name: "Ocean Fortune",
    // },
    // PathofDestinyQt: {
    //   href: "/casino/qtechredtiger-path-of-destiny",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Path of Destiny",
    //   name: "Path of Destiny",
    // },
    // PeggySweets: {
    //   href: "/casino/qtechredtiger-peggy-sweets",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Peggy Sweets",
    //   name: "Peggy Sweets",
    // },
    // PersianFortuneQt: {
    //   href: "/casino/qtechredtiger-persian-fortune",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Persian Fortune",
    //   name: "Persian Fortune",
    // },
    // Phoenix: {
    //   href: "/casino/qtechredtiger-phoenix",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Phoenix",
    //   name: "Phoenix",
    // },
    // PhoenixFirePowerReelsQt: {
    //   href: "/casino/qtechredtiger-phoenix-fire-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Phoenix Fire Power Reels",
    //   name: "Phoenix Fire Power Reels",
    // },
    // PiggyPirates: {
    //   href: "/casino/qtechredtiger-piggy-pirates",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Piggy Pirates",
    //   name: "Piggy Pirates",
    // },
    // PiggyRichesMegawaysQt: {
    //   href: "/casino/qtechredtiger-piggy-riches-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Piggy Riches Megaways",
    //   name: "Piggy Riches Megaways",
    // },
    // PinatasAndPonies: {
    //   href: "/casino/qtechredtiger-pinatas-and-ponies",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Pinatas & Ponies",
    //   name: "Pinatas & Ponies",
    // },
    // PiratesPlentyBattleForGold: {
    //   href: "/casino/qtechredtiger-pirates-plenty-battle-for-gold",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Pirates' Plenty Battle For Gold",
    //   name: "Pirates' Plenty Battle For Gold",
    // },
    // PiratesPlentyMegaWays: {
    //   href: "/casino/qtechredtiger-pirates-plenty-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Pirates Plenty MegaWays",
    //   name: "Pirates Plenty MegaWays",
    // },
    // PrimateKing: {
    //   href: "/casino/qtechredtiger-primate-king",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Primate King",
    //   name: "Primate King",
    // },
    // PussnBoots: {
    //   href: "/casino/qtechredtiger-pussn-boots",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Puss'n Boots",
    //   name: "Puss'n Boots",
    // },
    // RainbowJackpotsQt: {
    //   href: "/casino/qtechredtiger-rainbow-jackpots",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Rainbow Jackpots",
    //   name: "Rainbow Jackpots",
    // },
    // RainbowJackpotsPowerLinesQt: {
    //   href: "/casino/qtechredtiger-rainbow-jackpots-power-lines",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Rainbow Jackpots Power Lines",
    //   name: "Rainbow Jackpots Power Lines",
    // },
    // RasLegend: {
    //   href: "/casino/qtechredtiger-ras-legend",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ra's Legend",
    //   name: "Ra's Legend",
    // },
    // Reactor: {
    //   href: "/casino/qtechredtiger-reactor",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Reactor",
    //   name: "Reactor",
    // },
    // ReptizillionsPowerReels: {
    //   href: "/casino/qtechredtiger-reptizillions-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Reptizillions Power Reels",
    //   name: "Reptizillions Power Reels",
    // },
    // RedDiamond: {
    //   href: "/casino/qtechredtiger-red-diamond",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Red Diamond",
    //   name: "Red Diamond",
    // },
    // RedHotBBQ: {
    //   href: "/casino/qtechredtiger-red-hot-bbq",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Red Hot BBQ",
    //   name: "Red Hot BBQ",
    // },
    // ReelHeistQt: {
    //   href: "/casino/qtechredtiger-reel-heist",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Reel Heist",
    //   name: "Reel Heist",
    // },
    // ReelKeeperQt: {
    //   href: "/casino/qtechredtiger-reel-keeper",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Reel Keeper",
    //   name: "Reel Keeper",
    // },
    // ReelKeeperPowerReels: {
    //   href: "/casino/qtechredtiger-reel-keeper-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Reel Keeper Power Reels",
    //   name: "Reel Keeper Power Reels",
    // },
    // RegalBeastsQt: {
    //   href: "/casino/qtechredtiger-regal-beasts",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Regal Beasts",
    //   name: "Regal Beasts",
    // },
    // RegalStreakQt: {
    //   href: "/casino/qtechredtiger-regal-streak",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Regal Streak",
    //   name: "Regal Streak",
    // },
    // RiddleoftheSphinx: {
    //   href: "/casino/qtechredtiger-riddle-of-the-sphinx",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Riddle of the Sphinx",
    //   name: "Riddle of the Sphinx",
    // },
    // RisqueMegaways: {
    //   href: "/casino/qtechredtiger-risque-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Risque Megaways",
    //   name: "Risque Megaways",
    // },
    // RobinHoodsWildForestQt: {
    //   href: "/casino/qtechredtiger-robin-hoods-wild-forest",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Robin Hood’s Wild Forest",
    //   name: "Robin Hood’s Wild Forest",
    // },
    // RocketMen: {
    //   href: "/casino/qtechredtiger-rocket-men",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Rocket Men",
    //   name: "Rocket Men",
    // },
    // RocknLock: {
    //   href: "/casino/qtechredtiger-rocknlock",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Rock’n’Lock",
    //   name: "Rock’n’Lock",
    // },
    // RoyalGems: {
    //   href: "/casino/qtechredtiger-royal-gems",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Royal Gems",
    //   name: "Royal Gems",
    // },
    // SantaSpins: {
    //   href: "/casino/qtechredtiger-santa-spins",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Santa Spins",
    //   name: "Santa Spins",
    // },
    // ShadowSociety: {
    //   href: "/casino/qtechredtiger-shadow-society",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Shadow Society",
    //   name: "Shadow Society",
    // },
    // ShahMat: {
    //   href: "/casino/qtechredtiger-shah-mat",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Shah Mat",
    //   name: "Shah Mat",
    // },
    // SheepGoneWild: {
    //   href: "/casino/qtechredtiger-sheep-gone-wild",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sheep Gone Wild",
    //   name: "Sheep Gone Wild",
    // },
    // SnowWildandthe7FeaturesQt: {
    //   href: "/casino/qtechredtiger-snow-wild-and-the-7-features",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Snow Wild and the 7 Features",
    //   name: "Snow Wild and the 7 Features",
    // },
    // SpinTown: {
    //   href: "/casino/qtechredtiger-spin-town",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Spin Town",
    //   name: "Spin Town",
    // },
    // Stage888: {
    //   href: "/casino/qtechredtiger-stage-888",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Stage 888",
    //   name: "Stage 888",
    // },
    // StolenTreasures: {
    //   href: "/casino/qtechredtiger-stolen-treasures",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Stolen Treasures",
    //   name: "Stolen Treasures",
    // },
    // SumoSpins: {
    //   href: "/casino/qtechredtiger-sumo-spins",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sumo Spins",
    //   name: "Sumo Spins",
    // },
    // SylvanSpiritsQt: {
    //   href: "/casino/qtechredtiger-sylvan-spirits",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sylvan Spirits",
    //   name: "Sylvan Spirits",
    // },
    // TenElements: {
    //   href: "/casino/qtechredtiger-ten-elements",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ten Elements",
    //   name: "Ten Elements",
    // },
    // TheEqualizer: {
    //   href: "/casino/qtechredtiger-the-equalizer",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "The Equalizer",
    //   name: "The Equalizer",
    // },
    // TheGreatestTrainRobberyQt: {
    //   href: "/casino/qtechredtiger-the-greatest-train-robbery",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "The Greatest Train Robbery",
    //   name: "The Greatest Train Robbery",
    // },
    // TheWildHatterQt: {
    //   href: "/casino/qtechredtiger-the-wild-hatter",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "The Wild Hatter",
    //   name: "The Wild Hatter",
    // },
    // TheWisecrackerLightning: {
    //   href: "/casino/qtechredtiger-the-wisecracker-lightning",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "The Wisecracker Lightning",
    //   name: "The Wisecracker Lightning",
    // },
    // ThorsLightningQt: {
    //   href: "/casino/qtechredtiger-thors-lightning",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Thors Lightning",
    //   name: "Thors Lightning",
    // },
    // ThorsVengeanceQt: {
    //   href: "/casino/qtechredtiger-thors-vengeance",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Thor’s Vengeance",
    //   name: "Thor’s Vengeance",
    // },
    // TransylvaniaNightofBlood: {
    //   href: "/casino/qtechredtiger-transylvania-night-of-blood",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Transylvania: Night of Blood",
    //   name: "Transylvania: Night of Blood",
    // },
    // TreasureMineQt: {
    //   href: "/casino/qtechredtiger-treasure-mine",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Treasure Mine",
    //   name: "Treasure Mine",
    // },
    // TreasureMinePowerReels: {
    //   href: "/casino/qtechredtiger-treasure-mine-power-reelstm",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Treasure Mine Power Reels™",
    //   name: "Treasure Mine Power Reels™",
    // },
    // ThreeKingdoms: {
    //   href: "/casino/qtechredtiger-three-kingdoms",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Three Kingdoms",
    //   name: "Three Kingdoms",
    // },
    // ThreeMusketeers: {
    //   href: "/casino/qtechredtiger-three-musketeers",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Three Musketeers",
    //   name: "Three Musketeers",
    // },
    // TikiFruitsQt: {
    //   href: "/casino/qtechredtiger-tiki-fruits",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Tiki Fruits",
    //   name: "Tiki Fruits",
    // },
    // TikiFruitsTotemFrenzy: {
    //   href: "/casino/qtechredtiger-tiki-fruits-totem-frenzy",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Tiki Fruits Totem Frenzy",
    //   name: "Tiki Fruits Totem Frenzy",
    // },
    // TricksandTreats: {
    //   href: "/casino/qtechredtiger-tricks-and-treats",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Tricks and Treats",
    //   name: "Tricks and Treats",
    // },
    // Trillionaire: {
    //   href: "/casino/qtechredtiger-trillionaire",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Trillionaire",
    //   name: "Trillionaire",
    // },
    // TotemLightningQt: {
    //   href: "/casino/qtechredtiger-totem-lightning",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Totem Lightning",
    //   name: "Totem Lightning",
    // },
    // TotemLightningPowerReels: {
    //   href: "/casino/qtechredtiger-totem-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Totem Lightning Power Reels",
    //   name: "Totem Lightning Power Reels",
    // },
    // VaultCrackerQt: {
    //   href: "/casino/qtechredtiger-vault-cracker",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Vault Cracker",
    //   name: "Vault Cracker",
    // },
    // VaultofAnubisQt: {
    //   href: "/casino/qtechredtiger-vault-of-anubis",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Vault of Anubis",
    //   name: "Vault of Anubis",
    // },
    // VickyVentura: {
    //   href: "/casino/qtechredtiger-vicky-ventura",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Vicky Ventura",
    //   name: "Vicky Ventura",
    // },
    // ViralSpiral: {
    //   href: "/casino/qtechredtiger-viral-spiral",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Viral Spiral",
    //   name: "Viral Spiral",
    // },
    // WarofGods: {
    //   href: "/casino/qtechredtiger-war-of-gods",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "War of Gods",
    //   name: "War of Gods",
    // },
    // WellofWildsMegaways: {
    //   href: "/casino/qtechredtiger-well-of-wilds-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Well of Wilds Megaways",
    //   name: "Well of Wilds Megaways",
    // },
    // WhattheFoxMegaways: {
    //   href: "/casino/qtechredtiger-what-the-fox-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "What the Fox Megaways",
    //   name: "What the Fox Megaways",
    // },
    // WildCircus: {
    //   href: "/casino/qtechredtiger-wild-circus",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Circus",
    //   name: "Wild Circus",
    // },
    // WildElements: {
    //   href: "/casino/qtechredtiger-wild-elements",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Elements",
    //   name: "Wild Elements",
    // },
    // WildFight: {
    //   href: "/casino/qtechredtiger-wild-fight",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Fight",
    //   name: "Wild Fight",
    // },
    // WildHotChilliReels: {
    //   href: "/casino/qtechredtiger-wild-hot-chilli-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Hot Chilli Reels",
    //   name: "Wild Hot Chilli Reels",
    // },
    // WildNords: {
    //   href: "/casino/qtechredtiger-wild-nords",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Nords",
    //   name: "Wild Nords",
    // },
    // WildOClockQt: {
    //   href: "/casino/qtechredtiger-wild-oclock",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild O'Clock",
    //   name: "Wild O'Clock",
    // },
    // WildSpartans: {
    //   href: "/casino/qtechredtiger-wild-spartans",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Spartans",
    //   name: "Wild Spartans",
    // },
    // WildTundra: {
    //   href: "/casino/qtechredtiger-wild-tundra",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Tundra",
    //   name: "Wild Tundra",
    // },
    // WildWildChestQt: {
    //   href: "/casino/qtechredtiger-wild-wild-chest",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Wild Chest",
    //   name: "Wild Wild Chest",
    // },
    // WinEscalatorQt: {
    //   href: "/casino/qtechredtiger-win-escalator",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Win Escalator",
    //   name: "Win Escalator",
    // },
    // WingsofRaQt: {
    //   href: "/casino/qtechredtiger-wings-of-ra",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wings of Ra",
    //   name: "Wings of Ra",
    // },
    // WinterWonders: {
    //   href: "/casino/qtechredtiger-winter-wonders",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Winter Wonders",
    //   name: "Winter Wonders",
    // },
    // Wolfkin: {
    //   href: "/casino/qtechredtiger-wolfkin",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wolfkin",
    //   name: "Wolfkin",
    // },
    // WrigleysWorld: {
    //   href: "/casino/qtechredtiger-wrigleys-world",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wrigley's World",
    //   name: "Wrigley's World",
    // },
    // YucatansMysteryQt: {
    //   href: "/casino/qtechredtiger-yucatans-mystery",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Yucatan's Mystery",
    //   name: "Yucatan's Mystery",
    // },
    // ZaidasFortune: {
    //   href: "/casino/qtechredtiger-zaidas-fortune",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Zaida's Fortune",
    //   name: "Zaida's Fortune",
    // },
    // ZeusLightningPowerReelsQt: {
    //   href: "/casino/qtechredtiger-zeus-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Zeus Lightning Power Reels",
    //   name: "Zeus Lightning Power Reels",
    // },
    // ZillardKing: {
    //   href: "/casino/qtechredtiger-zillard-king",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Zillard King",
    //   name: "Zillard King",
    // },
    // BaccaratPuntoBanco: {
    //   href: "/casino/qtechredtiger-baccarat-punto-banco",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Baccarat Punto Banco",
    //   name: "Baccarat Punto Banco",
    // },
    // ClassicBlackjack: {
    //   href: "/casino/qtechredtiger-classic-blackjack",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Classic Blackjack",
    //   name: "Classic Blackjack",
    // },
    // EuropeanRoulette: {
    //   href: "/casino/qtechredtiger-european-roulette",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "European Roulette",
    //   name: "European Roulette",
    // },
    // Super777Strike: {
    //   href: "/casino/qtechredtiger-777-super-strike-u9121",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "777 Super Strike",
    //   name: "777 Super Strike",
    // },
    // MidnightThirst: {
    //   href: "/casino/qtechredtiger-midnight-thirst-u4090",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Midnight Thirst",
    //   name: "Midnight Thirst",
    // },
    // RedlineRush: {
    //   href: "/casino/qtechredtiger-redline-rush-u4402",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Redline Rush",
    //   name: "Redline Rush",
    // },
    // TheWildKiss: {
    //   href: "/casino/qtechredtiger-the-wild-kiss-u7621",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "The Wild Kiss",
    //   name: "The Wild Kiss",
    // },
    // SakuraMasks: {
    //   href: "/casino/qtechredtiger-sakura-masks-u6994",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sakura Masks",
    //   name: "Sakura Masks",
    // },
    // PlaywiththeDevil: {
    //   href: "/casino/qtechredtiger-play-with-the-devil-u2796",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Play with the Devil",
    //   name: "Play with the Devil",
    // },
    // Fishtastic: {
    //   href: "/casino/qtechredtiger-fishtastic-u5863",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fishtastic",
    //   name: "Fishtastic",
    // },
    // JudgementDayMegaways: {
    //   href: "/casino/qtechredtiger-judgement-day-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Judgement Day Megaways",
    //   name: "Judgement Day Megaways",
    // },
    // EgyptClusterbuster: {
    //   href: "/casino/qtechredtiger-egypt-clusterbuster",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Egypt Clusterbuster",
    //   name: "Egypt Clusterbuster",
    // },
    // RomanEmperors: {
    //   href: "/casino/qtechredtiger-roman-emperors",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Roman Emperors",
    //   name: "Roman Emperors",
    // },
    // TurtleParadise: {
    //   href: "/casino/qtechredtiger-turtle-paradise",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Turtle Paradise",
    //   name: "Turtle Paradise",
    // },
    // GlowDig: {
    //   href: "/casino/qtechredtiger-glow-dig",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Glow Dig",
    //   name: "Glow Dig",
    // },
    // DiamondBlitz2: {
    //   href: "/casino/qtechredtiger-diamond-blitz-2",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Diamond Blitz 2",
    //   name: "Diamond Blitz 2",
    // },
    // FaFaBabies2: {
    //   href: "/casino/qtechredtiger-fa-fa-babies-2",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fa Fa Babies 2",
    //   name: "Fa Fa Babies 2",
    // },
    // BuffaloCollector: {
    //   href: "/casino/qtechredtiger-buffalo-collector",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Buffalo Collector",
    //   name: "Buffalo Collector",
    // },
    // UltraRich: {
    //   href: "/casino/qtechredtiger-ultra-rich",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Ultra Rich",
    //   name: "Ultra Rich",
    // },
    // EpicTreasure2: {
    //   href: "/casino/qtechredtiger-epic-treasure-2",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Epic Treasure 2",
    //   name: "Epic Treasure 2",
    // },
    // PurrPower: {
    //   href: "/casino/qtechredtiger-purr-power",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Purr Power",
    //   name: "Purr Power",
    // },
    // EmperorofIndia: {
    //   href: "/casino/qtechredtiger-emperor-of-india",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Emperor of India",
    //   name: "Emperor of India",
    // },
    // PiggyRiches2Megaways: {
    //   href: "/casino/qtechredtiger-piggy-riches-2-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Piggy Riches 2 Megaways",
    //   name: "Piggy Riches 2 Megaways",
    // },
    // CannonballCash: {
    //   href: "/casino/qtechredtiger-cannonball-cash",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cannonball Cash",
    //   name: "Cannonball Cash",
    // },
    // RainbowJackpotsMegaways: {
    //   href: "/casino/qtechredtiger-rainbow-jackpots-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Rainbow Jackpots Megaways",
    //   name: "Rainbow Jackpots Megaways",
    // },
    // SwordStomp: {
    //   href: "/casino/qtechredtiger-sword-stomp",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sword Stomp",
    //   name: "Sword Stomp",
    // },
    // FruitFlash: {
    //   href: "/casino/qtechredtiger-fruit-flash",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Fruit Flash",
    //   name: "Fruit Flash",
    // },
    // VikingsLegacyEveryway: {
    //   href: "/casino/qtechredtiger-vikings-legacy-everyway",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Viking’s Legacy Everyway",
    //   name: "Viking’s Legacy Everyway",
    // },
    // GoldMineMistress: {
    //   href: "/casino/qtechredtiger-gold-mine-mistress",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gold Mine Mistress",
    //   name: "Gold Mine Mistress",
    // },
    // PrimateKingMegaways: {
    //   href: "/casino/qtechredtiger-primate-king-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Primate King Megaways",
    //   name: "Primate King Megaways",
    // },
    // DontHitPLZ: {
    //   href: "/casino/qtechredtiger-dont-hit-plz",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Don’t Hit PLZ",
    //   name: "Don’t Hit PLZ",
    // },
    // MidnightRomance: {
    //   href: "/casino/qtechredtiger-midnight-romance",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Midnight Romance",
    //   name: "Midnight Romance",
    // },
    // DesertLegendsSpins: {
    //   href: "/casino/qtechredtiger-desert-legends-spins",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Desert Legends Spins",
    //   name: "Desert Legends Spins",
    // },
    // DrFrancashsteinMULTIHOPS: {
    //   href: "/casino/qtechredtiger-dr-francashstein-multihops",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dr. Francashstein MULTIHOPS",
    //   name: "Dr. Francashstein MULTIHOPS",
    // },
    // SavannahPride: {
    //   href: "/casino/qtechredtiger-savannah-pride",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Savannah Pride",
    //   name: "Savannah Pride",
    // },
    // LosMuertosLocos: {
    //   href: "/casino/qtechredtiger-los-muertos-locos",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Los Muertos Locos",
    //   name: "Los Muertos Locos",
    // },
    // MoonSpell: {
    //   href: "/casino/qtechredtiger-moon-spell",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Moon Spell",
    //   name: "Moon Spell",
    // },
    // ZeusLightningMegaways: {
    //   href: "/casino/qtechredtiger-zeus-lightning-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Zeus Lightning Megaways",
    //   name: "Zeus Lightning Megaways",
    // },
    // TheGoodTheBadandTheRich: {
    //   href: "/casino/qtechredtiger-the-good-the-bad-and-the-rich",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "The Good, The Bad and The Rich",
    //   name: "The Good, The Bad and The Rich",
    // },
    // SeaBoatAdventureMegaways: {
    //   href: "/casino/qtechredtiger-sea-boat-adventure-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Sea Boat Adventure Megaways",
    //   name: "Sea Boat Adventure Megaways",
    // },
    // DiamondDoggies: {
    //   href: "/casino/qtechredtiger-diamond-doggies",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Diamond Doggies",
    //   name: "Diamond Doggies",
    // },
    // GladiatorWays: {
    //   href: "/casino/qtechredtiger-gladiator-ways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Gladiator Ways",
    //   name: "Gladiator Ways",
    // },
    // DearSanta: {
    //   href: "/casino/qtechredtiger-dear-santa",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dear Santa",
    //   name: "Dear Santa",
    // },
    // WingsofRaMegaways: {
    //   href: "/casino/qtechredtiger-wings-of-ra-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wings of Ra Megaways",
    //   name: "Wings of Ra Megaways",
    // },
    // WildHotChilliReels2: {
    //   href: "/casino/qtechredtiger-wild-hot-chilli-reels-2",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wild Hot Chilli Reels 2",
    //   name: "Wild Hot Chilli Reels 2",
    // },
    // CashExplorer: {
    //   href: "/casino/qtechredtiger-cash-explorer",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Cash Explorer",
    //   name: "Cash Explorer",
    // },
    // DragonsLock: {
    //   href: "/casino/qtechredtiger-dragons-lock",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Dragons’ Lock",
    //   name: "Dragons’ Lock",
    // },
    // Luck7s: {
    //   href: "/casino/qtechredtiger-7s-luck",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "7’s Luck",
    //   name: "7’s Luck",
    // },
    // WolfStacksMegaways: {
    //   href: "/casino/qtechredtiger-wolf-stacks-megaways",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Wolf Stacks Megaways",
    //   name: "Wolf Stacks Megaways",
    // },
    // TrophyFish: {
    //   href: "/casino/qtechredtiger-trophy-fish",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "RedTiger",
    //   homeUrl: "/slots-games",
    //   imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
    //   alt: "Trophy Fish",
    //   name: "Trophy Fish",
    // },
  },

  jili: {
    Coin3Treasures: {
      href: "/casino/aggapjiligaming-3-coin-treasures",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/3-coin-treasures.webp",
      alt: "3 coin treasures",
      name: "3 coin treasures",
    },
    Lucky3Piggy: {
      href: "/casino/aggapjiligaming-3-lucky-piggy",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/3-lucky-piggy.webp",
      alt: "3 lucky piggy",
      name: "3 lucky piggy",
    },
    Pot3Dragons: {
      href: "/casino/aggapjiligaming-3-pot-dragons",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/3-pot-dragons.webp",
      alt: "3 pot dragons",
      name: "3 pot dragons",
    },
    AgentAce: {
      href: "/casino/aggapjiligaming-agent-ace",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/agent-ace.webp",
      alt: "agent ace",
      name: "agent ace",
    },
    AliBaba: {
      href: "/casino/aggapjiligaming-ali-baba",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/ali-baba.webp",
      alt: "ali baba",
      name: "ali baba",
    },
    ArenaFighter: {
      href: "/casino/aggapjiligaming-arena-fighter",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/arena-fighter.webp",
      alt: "arena fighter",
      name: "arena fighter",
    },
    AztecPriestess: {
      href: "/casino/aggapjiligaming-aztec-priestess",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/aztec-priestess.webp",
      alt: "aztec priestess",
      name: "aztec priestess",
    },
    BanglaBeauty: {
      href: "/casino/aggapjiligaming-bangla-beauty",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/bangla-beauty.webp",
      alt: "bangla beauty",
      name: "bangla beauty",
    },
    BaoBoonChin: {
      href: "/casino/aggapjiligaming-bao-boon-chin",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/bao-boon-chin.webp",
      alt: "bao boon chin",
      name: "bao boon chin",
    },
    BoneFortune: {
      href: "/casino/aggapjiligaming-bone-fortune",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/bone-fortune.webp",
      alt: "bone fortune",
      name: "bone fortune",
    },
    BonusHunter: {
      href: "/casino/aggapjiligaming-bonus-hunter",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/bonus-hunter.webp",
      alt: "bonus h1unter",
      name: "bonus hunter",
    },
    BookOfGold: {
      href: "/casino/aggapjiligaming-book-of-gold",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/book-of-gold.webp",
      alt: "book of gold",
      name: "book of gold",
    },
    BoxingKing: {
      href: "/casino/aggapjiligaming-boxing-king",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/boxing-king.webp",
      alt: "boxing king",
      name: "boxing king",
    },
    BubbleBeauty: {
      href: "/casino/aggapjiligaming-bubble-beauty",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/bubble-beauty.webp",
      alt: "bubble beauty",
      name: "bubble beauty",
    },
    CargeBuffalo: {
      href: "/casino/aggapjiligaming-charge-buffalo",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/charge-buffalo.webp",
      alt: "charge buffalo",
      name: "charge buffalo",
    },
    ChargeBuffaloAscent: {
      href: "/casino/aggapjiligaming-charge-buffalo-ascent",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/charge-buffalo-ascent.webp",
      alt: "charge buffalo ascent",
      name: "charge buffalo ascent",
    },
    Chinshihuang: {
      href: "/casino/aggapjiligaming-chin-shi-huang",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/chin-shi-huang.webp",
      alt: "",
      name: "Chin Shi Huang",
    },
    CrazyFafafa: {
      href: "/casino/aggapjiligaming-crazy-fafafa",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/crazy-fafafa.webp",
      alt: "crazy fafafa",
      name: "crazy fafafa",
    },
    CrazyHunter: {
      href: "/casino/aggapjiligaming-crazy-hunter",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/crazy-hunter.webp",
      alt: "crazy hunter",
      name: "crazy hunter",
    },
    Crazy777: {
      href: "/casino/aggapjiligaming-crazy777",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/crazy777.webp",
      alt: "",
      name: "Crazy777",
    },
    CricketKing18: {
      href: "/casino/aggapjiligaming-cricket-king-18",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/cricket-king-18.webp",
      alt: "cricket king 18",
      name: "cricket king 18",
    },
    CricketSah75: {
      href: "/casino/aggapjiligaming-cricket-sah-75",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/cricket-sah-75.webp",
      alt: "cricket sah 75",
      name: "cricket sah 75",
    },
    Dabanggg: {
      href: "/casino/aggapjiligaming-dabanggg",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/dabanggg.webp",
      alt: "dabanggg",
      name: "dabanggg",
    },
    DevilFire2: {
      href: "/casino/aggapjiligaming-devil-fire-2",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/devil-fire-2.webp",
      alt: "devil fire 2",
      name: "devil fire 2",
    },
    DiamondParty: {
      href: "/casino/aggapjiligaming-diamondparty",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/diamond-party.webp",
      alt: "diamond party",
      name: "diamond party",
    },
    DragonTreasure: {
      href: "/casino/aggapjiligaming-dragon-treasure",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/dragon-treasure.webp",
      alt: "dragon treasure",
      name: "dragon treasure",
    },
    EgyptsGlow: {
      href: "/casino/aggapjiligaming-egypts-glow",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/egypts-glow.webp",
      alt: "egypt's glow",
      name: "egypt's glow",
    },
    FaFaFa: {
      href: "/casino/aggapjiligaming-fa-fa-fa",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fa-fa-fa.webp",
      alt: "fa fa fa",
      name: "fa fa fa",
    },
    Fengshen: {
      href: "/casino/aggapjiligaming-fengshen",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fengshen.webp",
      alt: "fengshen",
      name: "fengshen",
    },
    FortuneGems: {
      href: "/casino/aggapjiligaming-fortune-gems",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fortune-gems.webp",
      alt: "fortune gems",
      name: "fortune gems",
    },
    FortuneGems2: {
      href: "/casino/aggapjiligaming-fortune-gems-2",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fortune-gems-2.webp",
      alt: "fortune gems 2",
      name: "fortune gems 2",
    },
    FortuneGems3: {
      href: "/casino/aggapjiligaming-fortune-gems-3",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fortune-gems-3.webp",
      alt: "fortune gems 3",
      name: "fortune gems 3",
    },
    FortuneMonkey: {
      href: "/casino/aggapjiligaming-fortune-monkey",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fortune-monkey.webp",
      alt: "fortune monkey",
      name: "fortune monkey",
    },
    FortuneTree: {
      href: "/casino/aggapjiligaming-fortune-tree",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/fortune-tree.webp",
      alt: "",
      name: "Fortune Tree",
    },
    GemParty: {
      href: "/casino/aggapjiligaming-gem-party",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/gem-party.webp",
      alt: "",
      name: "Gem Party",
    },
    GodOfMartial: {
      href: "/casino/aggapjiligaming-god-of-martial",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/god-of-martial.webp",
      alt: "",
      name: "God Of Martial",
    },
    GoldRush: {
      href: "/casino/aggapjiligaming-gold-rush",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/gold-rush.webp",
      alt: "gold rush",
      name: "gold rush",
    },
    GoldenBank: {
      href: "/casino/aggapjiligaming-crazy-golden-bank",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/golden-bank.webp",
      alt: "golden bank",
      name: "golden bank",
    },
    GoldenEmpire: {
      href: "/casino/aggapjiligaming-golden-empire",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/golden-empire.webp",
      alt: "golden empire",
      name: "golden empire",
    },
    GoldenJoker: {
      href: "/casino/aggapjiligaming-golden-joker",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/golden-joker.webp",
      alt: "golden joker",
      name: "golden joker",
    },
    GoldenQueen: {
      href: "/casino/aggapjiligaming-golden-queen",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/golden-queen.webp",
      alt: "golden queen",
      name: "golden queen",
    },
    GoldenTemple: {
      href: "/casino/aggapjiligaming-golden-temple",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/golden-temple.webp",
      alt: "golden temple",
      name: "golden temple",
    },
    HappyTaxi: {
      href: "/casino/aggapjiligaming-happy-taxi",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/happy-taxi.webp",
      alt: "happy taxi",
      name: "happy taxi",
    },
    HawaiiBeauty: {
      href: "/casino/aggapjiligaming-hawaii-beauty",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/hawaii-beauty.webp",
      alt: "hawaii beauty",
      name: "hawaii beauty",
    },
    HotChili: {
      href: "/casino/aggapjiligaming-hot-chilli",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/hot-chilli.webp",
      alt: "Hot Chilli",
      name: "Hot Chilli",
    },
    HyperBrust: {
      href: "/casino/aggapjiligaming-hyper-burst",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/hyper-burst.webp",
      alt: "Hyper Burst",
      name: "Hyper Burst",
    },
    JiliCaishen: {
      href: "/casino/aggapjiligaming-jili-caishen",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/jili-caishen.webp",
      alt: "jili caishen",
      name: "jili caishen",
    },
    JungleKing: {
      href: "/casino/aggapjiligaming-jungle-king",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/jungle-king.webp",
      alt: "jungle king",
      name: "jungle king",
    },
    KingArthur: {
      href: "/casino/aggapjiligaming-king-arthur",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/king-arthur.webp",
      alt: "king arthur",
      name: "king arthur",
    },
    LegacyOfEgypt: {
      href: "/casino/aggapjiligaming-legacy-of-egypt",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/legacy-of-egypt.webp",
      alt: "legacy of egypt",
      name: "legacy of egypt",
    },
    LuckyBall: {
      href: "/casino/aggapjiligaming-lucky-ball",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/lucky-ball.webp",
      alt: "lucky ball",
      name: "lucky ball",
    },
    LuckyComing: {
      href: "/casino/aggapjiligaming-lucky-coming",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/lucky-coming.webp",
      alt: "lucky coming",
      name: "lucky coming",
    },
    MagicLamp: {
      href: "/casino/aggapjiligaming-magic-lamp",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/magic-lamp.webp",
      alt: "magic lamp",
      name: "magic lamp",
    },
    MasterTiger: {
      href: "/casino/aggapjiligaming-master-tiger",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/master-tiger.webp",
      alt: "master tiger",
      name: "master tiger",
    },
    MayanEmpire: {
      href: "/casino/aggapjiligaming-mayan-empire",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/mayan-empire.webp",
      alt: "mayan empire",
      name: "mayan empire",
    },
    Medusa: {
      href: "/casino/aggapjiligaming-medusa",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/medusa.webp",
      alt: "medusa",
      name: "medusa",
    },
    MegaAce: {
      href: "/casino/aggapjiligaming-mega-ace",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/mega-ace.webp",
      alt: "mega ace",
      name: "mega ace",
    },
    MoneyComing: {
      href: "/casino/aggapjiligaming-money-coming",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/money-coming.webp",
      alt: "money coming",
      name: "money coming",
    },
    MoneyComingExpandedBets: {
      href: "/casino/aggapjiligaming-money-coming-expand-bets",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/money-coming-expanded-bets.webp",
      alt: "money coming expanded bets",
      name: "money coming expanded bets",
    },
    MonkeyParty: {
      href: "/casino/aggapjiligaming-monkey-party",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/monkey-party.webp",
      alt: "monkey party",
      name: "monkey party",
    },
    NekoFortune: {
      href: "/casino/aggapjiligaming-neko-fortune",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/neko-fortune.webp",
      alt: "neko fortune",
      name: "neko fortune",
    },
    NightCity: {
      href: "/casino/aggapjiligaming-night-city",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/night-city.webp",
      alt: "night city",
      name: "night city",
    },
    PartyNight: {
      href: "/casino/aggapjiligaming-party-night",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/party-night.webp",
      alt: "party night",
      name: "party night",
    },
    PartyStar: {
      href: "/casino/aggapjiligaming-party-star",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/party-star.webp",
      alt: "party star",
      name: "party star",
    },
    PharaohTreasure: {
      href: "/casino/aggapjiligaming-pharaoh-treasure",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/pharaoh-treasure.webp",
      alt: "pharaoh treasure",
      name: "pharaoh treasure",
    },
    PirateQueen: {
      href: "/casino/aggapjiligaming-pirate-queen",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/pirate-queen.webp",
      alt: "pirate queen",
      name: "pirate queen",
    },
    Poseidon: {
      href: "/casino/aggapjiligaming-poseidon",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/poseidon.webp",
      alt: "poseidon",
      name: "poseidon",
    },
    PotionWizard: {
      href: "/casino/aggapjiligaming-potion-wizard",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/potion-wizard.webp",
      alt: "potion wizard",
      name: "potion wizard",
    },
    RomaX: {
      href: "/casino/aggapjiligaming-romax",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/roma-x.webp",
      alt: "romax",
      name: "romax",
    },
    Samba: {
      href: "/casino/aggapjiligaming-samba",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/samba.webp",
      alt: "samba",
      name: "samba",
    },
    SecretTreasure: {
      href: "/casino/aggapjiligaming-secret-treasure",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/secret-treasure.webp",
      alt: "secret treasure",
      name: "secret treasure",
    },
    ShanghaiBeauty: {
      href: "/casino/aggapjiligaming-shanghai-beauty",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/shanghai-beauty.webp",
      alt: "Shanghai Beauty",
      name: "Shanghai Beauty",
    },
    SinCity: {
      href: "/casino/aggapjiligaming-sin-city",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/sin-city.webp",
      alt: "sin city",
      name: "sin city",
    },
    SuperAce: {
      href: "/casino/aggapjiligaming-super-ace",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/super-ace.webp",
      alt: "super ace",
      name: "super ace",
    },
    SuperAceDeluxe: {
      href: "/casino/aggapjiligaming-super-ace-deluxe",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/super-ace-deluxe.webp",
      alt: "super ace deluxe",
      name: "super ace deluxe",
    },
    SuperRich: {
      href: "/casino/aggapjiligaming-super-rich",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/super-rich.webp",
      alt: "super rich",
      name: "super rich",
    },
    SweetLand: {
      href: "/casino/aggapjiligaming-sweet-land",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/sweet-land.webp",
      alt: "sweet land",
      name: "sweet land",
    },
    ThorX: {
      href: "/casino/aggapjiligaming-thor-x",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/thor-x.webp",
      alt: "thor x",
      name: "thor x",
    },
    TrialOfPhoenix: {
      href: "/casino/aggapjiligaming-trial-of-phoenix",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/trial-of-phoenix.webp",
      alt: "trial of phoenix",
      name: "trial of phoenix",
    },
    TwinWins: {
      href: "/casino/aggapjiligaming-twin-wins",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/twin-wins.webp",
      alt: "twin wins",
      name: "twin wins",
    },
    WarOfDragons: {
      href: "/casino/aggapjiligaming-war-of-dragons",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/war-of-dragons.webp",
      alt: "war of dragons",
      name: "war of dragons",
    },
    WildAce: {
      href: "/casino/aggapjiligaming-wild-ace",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/wild-ace.webp",
      alt: "wild ace",
      name: "wild ace",
    },
    WildRacer: {
      href: "/casino/aggapjiligaming-wild-racer",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/wild-racer.webp",
      alt: "wild racer",
      name: "wild racer",
    },
    WitchesNight: {
      href: "/casino/aggapjiligaming-witches-night",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/witches-night.webp",
      alt: "witches night",
      name: "witches night",
    },
    WorldCup: {
      href: "/casino/aggapjiligaming-world-cup",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/world-cup.webp",
      alt: "world cup",
      name: "world cup",
    },
    Xiyangyang: {
      href: "/casino/aggapjiligaming-xiyangyang",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/xiyangyang.webp",
      alt: "xiyangyang",
      name: "xiyangyang",
    },
    Zeus: {
      href: "/casino/aggapjiligaming-zeus",
      code: "",
      casino: "Slots",
      provider: "Jili",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/jili-games/zeus.webp",
      alt: "zeus",
      name: "zeus",
    },
  },

  hacksaw: {
    SCRATCHPlatinum: {
      href: "/casino/qt-scratch-platinum",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHPlatinum.webp",
      alt: "SCRATCH! Platinum",
      name: "SCRATCH! Platinum",
    },
    SCRATCHGold: {
      href: "/casino/qt-scratch-gold",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHGold.webp",
      alt: "SCRATCH! Gold",
      name: "SCRATCH! Gold",
    },
    SCRATCHSilver: {
      href: "/casino/qt-scratch-silver",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHSilver.webp",
      alt: "SCRATCH! Silver",
      name: "SCRATCH! Silver",
    },
    SCRATCHBronze: {
      href: "/casino/qt-scratch-bronze",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHBronze.webp",
      alt: "SCRATCH! Bronze",
      name: "SCRATCH! Bronze",
    },
    SnowScratcher: {
      href: "/casino/aggaphacksawgaming-snow-scratcher",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SnowScratcher.webp",
      alt: "Snow Scratcher",
      name: "Snow Scratcher",
    },
    SummerScratch: {
      href: "/casino/aggaphacksawgaming-summer-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SummerScratch.webp",
      alt: "Summer Scratch",
      name: "Summer Scratch",
    },
    Express200Scratch: {
      href: "/casino/qt-express-200-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Express200Scratch.webp",
      alt: "Express 200 Scratch",
      name: "Express 200 Scratch",
    },
    ScratchyMini: {
      href: "/casino/aggaphacksawgaming-scratchy-mini",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ScratchyMini.webp",
      alt: "Scratchy Mini",
      name: "Scratchy Mini",
    },
    Scratchy: {
      href: "/casino/aggaphacksawgaming-scratchy",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Scratchy.webp",
      alt: "Scratchy",
      name: "Scratchy",
    },
    ScratchyBig: {
      href: "/casino/aggaphacksawgaming-scratchy-big",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ScratchyBig.webp",
      alt: "Scratchy Big",
      name: "Scratchy Big",
    },
    KingTreasure: {
      href: "/casino/aggaphacksawgaming-king-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KingTreasure.webp",
      alt: "King Treasure",
      name: "King Treasure",
    },
    QueenTreasure: {
      href: "/casino/aggaphacksawgaming-queen-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/QueenTreasure.webp",
      alt: "Queen Treasure",
      name: "Queen Treasure",
    },
    PrinceTreasure: {
      href: "/casino/aggaphacksawgaming-prince-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/PrinceTreasure.webp",
      alt: "Prince Treasure",
      name: "Prince Treasure",
    },
    HappyScratch: {
      href: "/casino/aggaphacksawgaming-happy-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Happyscratch.webp",
      alt: "Happy Scratch",
      name: "Happy Scratch",
    },
    LOVEIsAllYouNeed: {
      href: "/casino/aggaphacksawgaming-love-is-all-you-need",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LoveIsAllYouNeed.webp",
      alt: "LOVE is all you need",
      name: "LOVE is all you need",
    },
    LuckyScratch: {
      href: "/casino/aggaphacksawgaming-lucky-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Luckyscratch.webp",
      alt: "Lucky Scratch",
      name: "Lucky Scratch",
    },
    CashPool: {
      href: "/casino/aggaphacksawgaming-cash-pool",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cashpool.webp",
      alt: "Cash Pool",
      name: "Cash Pool",
    },
    CashScratch: {
      href: "/casino/aggaphacksawgaming-cash-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashScratch.webp",
      alt: "Cash Scratch",
      name: "Cash Scratch",
    },
    ChaosCrewScratch: {
      href: "/casino/aggaphacksawgaming-chaos-crew-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ChaosCrewScratch.webp",
      alt: "Chaos Crew Scratch",
      name: "Chaos Crew Scratch",
    },
    DreamCarUrban: {
      href: "/casino/aggaphacksawgaming-dream-car-urban",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DreamCarUrban.webp",
      alt: "Dream Car Urban",
      name: "Dream Car Urban",
    },
    DreamCarSUV: {
      href: "/casino/aggaphacksawgaming-dream-car-suv",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DreamCarSUV.webp",
      alt: "Dream Car SUV",
      name: "Dream Car SUV",
    },
    DreamCarSpeed: {
      href: "/casino/aggaphacksawgaming-dream-car-speed",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DreamCarSpeed.webp",
      alt: "Dream Car Speed",
      name: "Dream Car Speed",
    },
    EggstraCash: {
      href: "/casino/aggaphacksawgaming-eggstra-cash",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/EggstraCash.webp",
      alt: "Eggstra Cash",
      name: "Eggstra Cash",
    },
    FootballScratch: {
      href: "/casino/aggaphacksawgaming-football-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FootballScratch.webp",
      alt: "Football Scratch",
      name: "Football Scratch",
    },
    GoldRush: {
      href: "/casino/aggaphacksawgaming-gold-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoldRush.webp",
      alt: "Gold Rush",
      name: "Gold Rush",
    },
    RubyRush: {
      href: "/casino/aggaphacksawgaming-ruby-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RubyRush.webp",
      alt: "Ruby Rush",
      name: "Ruby Rush",
    },
    DiamondRush: {
      href: "/casino/aggaphacksawgaming-diamond-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DiamondRush.webp",
      alt: "Diamond Rush",
      name: "Diamond Rush",
    },
    LuckyShot: {
      href: "/casino/aggaphacksawgaming-lucky-shot",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyShot.webp",
      alt: "Lucky Shot",
      name: "Lucky Shot",
    },
    CashVaultI: {
      href: "/casino/aggaphacksawgaming-cash-vault-i",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashVaultI.webp",
      alt: "Cash Vault I",
      name: "Cash Vault I",
    },
    CashVaultII: {
      href: "/casino/aggaphacksawgaming-cash-vault-ii",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashVaultII.webp",
      alt: "Cash Vault II",
      name: "Cash Vault II",
    },
    CrazyDonuts: {
      href: "/casino/aggaphacksawgaming-crazy-donuts",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CrazyDonuts.webp",
      alt: "Crazy Donuts",
      name: "Crazy Donuts",
    },
    LuckyNumbersX8: {
      href: "/casino/aggaphacksawgaming-lucky-numbers-x8",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersX8.webp",
      alt: "Lucky Numbers x8",
      name: "Lucky Numbers x8",
    },
    LuckyNumbersX12: {
      href: "/casino/aggaphacksawgaming-lucky-numbers-x12",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersX12.webp",
      alt: "Lucky Numbers x12",
      name: "Lucky Numbers x12",
    },
    LuckyNumbersX16: {
      href: "/casino/aggaphacksawgaming-lucky-numbers-x16",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersX16.webp",
      alt: "Lucky Numbers x16",
      name: "Lucky Numbers x16",
    },
    LuckyNumbersX20: {
      href: "/casino/aggaphacksawgaming-lucky-numbers-x20",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersx20.webp",
      alt: "Lucky Numbers x20",
      name: "Lucky Numbers x20",
    },
    ItsBananas: {
      href: "/casino/aggaphacksawgaming-its-bananas",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Itsbananas.webp",
      alt: "It's bananas",
      name: "It's bananas",
    },
    DoubleSalary1Year: {
      href: "/casino/qt-double-salary-1-year",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DoubleSalary1Year.webp",
      alt: "Double Salary - 1 Year",
      name: "Double Salary - 1 Year",
    },
    ShaveTheBeard: {
      href: "/casino/aggaphacksawgaming-shave-the-beard",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ShaveTheBeard.webp",
      alt: "Shave the Beard",
      name: "Shave the Beard",
    },
    CutTheGrass: {
      href: "/casino/aggaphacksawgaming-cut-the-grass",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CutTheGrass.webp",
      alt: "Cut the Grass",
      name: "Cut the Grass",
    },
    Scratchem: {
      href: "/casino/qt-scratchem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Scratchem.webp",
      alt: "Scratch’em",
      name: "Scratch’em",
    },
    KoiCash: {
      href: "/casino/aggaphacksawgaming-koi-cash",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KoiCash.webp",
      alt: "Koi Cash",
      name: "Koi Cash",
    },
    BreakTheIce: {
      href: "/casino/aggaphacksawgaming-break-the-ice",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BreakTheIce.webp",
      alt: "Break the Ice",
      name: "Break the Ice",
    },
    GoldCoins: {
      href: "/casino/aggaphacksawgaming-gold-coins",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoldCoins.webp",
      alt: "Gold Coins",
      name: "Gold Coins",
    },
    FrogsScratch: {
      href: "/casino/aggaphacksawgaming-frogs-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FrogsScratch.webp",
      alt: "Frogs Scratch",
      name: "Frogs Scratch",
    },
    ShaveTheSheep: {
      href: "/casino/aggaphacksawgaming-shave-the-sheep",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ShaveTheSheep.webp",
      alt: "Shave the Sheep",
      name: "Shave the Sheep",
    },
    SpookyScaryScratchy: {
      href: "/casino/aggaphacksawgaming-spooky-scary-scratchy",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SpookyScaryScratchy.webp",
      alt: "Spooky Scary Scratchy",
      name: "Spooky Scary Scratchy",
    },
    ThePerfectScratch: {
      href: "/casino/aggaphacksawgaming-the-perfect-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ThePerfectScratch.webp",
      alt: "The perfect Scratch",
      name: "The perfect Scratch",
    },
    TigerScratch: {
      href: "/casino/aggaphacksawgaming-tiger-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TigerScratch.webp",
      alt: "Tiger Scratch",
      name: "Tiger Scratch",
    },
    RatRiches: {
      href: "/casino/aggaphacksawgaming-rat-riches",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RatRiches.webp",
      alt: "Rat Riches",
      name: "Rat Riches",
    },
    StackEmScratch: {
      href: "/casino/aggaphacksawgaming-stackem-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/StackEmScratch.webp",
      alt: "Stack'Em Scratch",
      name: "Stack'Em Scratch",
    },
    GoPanda: {
      href: "/casino/aggaphacksawgaming-go-panda",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoPanda.webp",
      alt: "Go Panda",
      name: "Go Panda",
    },
    WantedDeadOrAWild: {
      href: "/casino/aggaphacksawgaming-wanted-dead-or-a-wild",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/WantedDeadOrAWild.webp",
      alt: "Wanted Dead or a Wild",
      name: "Wanted Dead or a Wild",
    },
    Wild2Die2: {
      href: "/casino/aggaphacksawgaming-2-wild-2-die",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/2Wild2Die.webp",
      alt: "2 Wild 2 Die",
      name: "2 Wild 2 Die",
    },
    Mines: {
      href: "/casino/aggaphacksawgaming-mines-dare2win",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Mines.webp",
      alt: "Mines",
      name: "Mines",
    },
    Coins: {
      href: "/casino/qt-coins",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Coins.webp",
      alt: "Coins",
      name: "Coins",
    },
    Colors: {
      href: "/casino/aggaphacksawgaming-colors",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Colors.webp",
      alt: "Colors",
      name: "Colors",
    },
    Blocks: {
      href: "/casino/aggaphacksawgaming-blocks",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Blocks.webp",
      alt: "Blocks",
      name: "Blocks",
    },
    Boxes: {
      href: "/casino/qt-boxes",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Boxes.webp",
      alt: "Boxes",
      name: "Boxes",
    },
    HiLo: {
      href: "/casino/aggaphacksawgaming-hi-lo",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HiLo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
    },
    Lines: {
      href: "/casino/aggaphacksawgaming-lines",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Lines.webp",
      alt: "Lines",
      name: "Lines",
    },
    Plinko: {
      href: "/casino/qt-plinko",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Plinko.webp",
      alt: "Plinko",
      name: "Plinko",
    },
    TwentyOne: {
      href: "/casino/aggaphacksawgaming-twenty-one",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TwentyOne.webp",
      alt: "Twenty-One",
      name: "Twenty-One",
    },
    Wheel: {
      href: "/casino/aggaphacksawgaming-wheel",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Wheel.webp",
      alt: "Wheel",
      name: "Wheel",
    },
    XmasDrop: {
      href: "/casino/aggaphacksawgaming-xmas-drop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/XmasDrop.webp",
      alt: "Xmas Drop",
      name: "Xmas Drop",
    },
    DarkSummoning: {
      href: "/casino/aggaphacksawgaming-dark-summoning",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DarkSummoning.webp",
      alt: "Dark Summoning",
      name: "Dark Summoning",
    },
    ImmortalDesire: {
      href: "/casino/aggaphacksawgaming-immortal-desire",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ImmortalDesire.webp",
      alt: "Immortal Desire",
      name: "Immortal Desire",
    },
    EyeOfThePanda: {
      href: "/casino/aggaphacksawgaming-eye-of-the-panda",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/EyeOfThePanda.webp",
      alt: "Eye of the Panda",
      name: "Eye of the Panda",
    },
    ChaosCrewII: {
      href: "/casino/aggaphacksawgaming-chaos-crew-ii",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ChaosCrewII.webp",
      alt: "Chaos Crew II",
      name: "Chaos Crew II",
    },
    BennyTheBeer: {
      href: "/casino/aggaphacksawgaming-benny-the-beer",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BennyTheBeer.webp",
      alt: "Benny the Beer",
      name: "Benny the Beer",
    },
    Densho: {
      href: "/casino/aggaphacksawgaming-densho",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Densho.webp",
      alt: "Densho",
      name: "Densho",
    },
    LeBandit: {
      href: "/casino/aggaphacksawgaming-le-bandit",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LeBandit.webp",
      alt: "Le Bandit",
      name: "Le Bandit",
    },
    RoninStackways: {
      href: "/casino/aggaphacksawgaming-ronin-stackways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RoninStackways.webp",
      alt: "Ronin Stackways",
      name: "Ronin Stackways",
    },
    Dropem: {
      href: "/casino/aggaphacksawgaming-dropem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Dropem.webp",
      alt: "Drop'EM",
      name: "Drop'EM",
    },
    VendingMachine: {
      href: "/casino/aggaphacksawgaming-vending-machine",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/VendingMachine.webp",
      alt: "Vending Machine",
      name: "Vending Machine",
    },
    BeastBelow: {
      href: "/casino/aggaphacksawgaming-beast-below",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BeastBelow.webp",
      alt: "Beast Below",
      name: "Beast Below",
    },
    MightyMasks: {
      href: "/casino/aggaphacksawgaming-mighty-masks",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MightyMasks.webp",
      alt: "Mighty Masks",
      name: "Mighty Masks",
    },
    AlphaEagle: {
      href: "/casino/aggaphacksawgaming-alpha-eagle",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/AlphaEagle.webp",
      alt: "Alpha Eagle",
      name: "Alpha Eagle",
    },
    AztecTwist: {
      href: "/casino/aggaphacksawgaming-aztec-twist",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/AztecTwist.webp",
      alt: "Aztec Twist",
      name: "Aztec Twist",
    },
    Bloodthirst: {
      href: "/casino/aggaphacksawgaming-bloodthirst",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Bloodthirst.webp",
      alt: "Bloodthirst",
      name: "Bloodthirst",
    },
    BookOfTime: {
      href: "/casino/aggaphacksawgaming-book-of-time",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BookOfTime.webp",
      alt: "Book of Time",
      name: "Book of Time",
    },
    BornWild: {
      href: "/casino/aggaphacksawgaming-born-wild",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BornWild.webp",
      alt: "Born Wild",
      name: "Born Wild",
    },
    BreakBones: {
      href: "/casino/aggaphacksawgaming-break-bones",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BreakBones.webp",
      alt: "Break Bones",
      name: "Break Bones",
    },
    BuffaloStackNSync: {
      href: "/casino/aggaphacksawgaming-buffalo-stacknsync",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BuffaloStackNSync.webp",
      alt: "Buffalo Stack'n'Sync",
      name: "Buffalo Stack'n'Sync",
    },
    Cubes: {
      href: "/casino/aggaphacksawgaming-cubes",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cubes.webp",
      alt: "Cubes",
      name: "Cubes",
    },
    Cubes2: {
      href: "/casino/aggaphacksawgaming-cubes-2",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cubes2.webp",
      alt: "Cubes 2",
      name: "Cubes 2",
    },
    CursedSeas: {
      href: "/casino/aggaphacksawgaming-cursed-seas",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CursedSeas.webp",
      alt: "Cursed Seas",
      name: "Cursed Seas",
    },
    CashCompass: {
      href: "/casino/aggaphacksawgaming-cash-compass",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashCompass.webp",
      alt: "Cash Compass",
      name: "Cash Compass",
    },
    CashQuest: {
      href: "/casino/aggaphacksawgaming-cash-quest",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashQuest.webp",
      alt: "Cash Quest",
      name: "Cash Quest",
    },
    ChaosCrew: {
      href: "/casino/aggaphacksawgaming-chaos-crew",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ChaosCrew.webp",
      alt: "Chaos Crew",
      name: "Chaos Crew",
    },
    DorkUnit: {
      href: "/casino/aggaphacksawgaming-dork-unit",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DorkUnit.webp",
      alt: "Dork Unit",
      name: "Dork Unit",
    },
    DoubleRainbow: {
      href: "/casino/aggaphacksawgaming-double-rainbow",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DoubleRainbow.webp",
      alt: "Double Rainbow",
      name: "Double Rainbow",
    },
    FearTheDark: {
      href: "/casino/aggaphacksawgaming-fear-the-dark",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FearTheDark.webp",
      alt: "Fear the Dark",
      name: "Fear the Dark",
    },
    ForestFortune: {
      href: "/casino/aggaphacksawgaming-forest-fortune",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ForestFortune.webp",
      alt: "Forest Fortune",
      name: "Forest Fortune",
    },
    FranksFarm: {
      href: "/casino/aggaphacksawgaming-franks-farm",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FranksFarm.webp",
      alt: "Frank's Farm",
      name: "Frank's Farm",
    },
    FruitDuel: {
      href: "/casino/aggaphacksawgaming-fruit-duel",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FruitDuel.webp",
      alt: "Fruit Duel",
      name: "Fruit Duel",
    },
    Frutz: {
      href: "/casino/aggaphacksawgaming-frutz",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Frutz.webp",
      alt: "Frutz",
      name: "Frutz",
    },
    GladiatorLegends: {
      href: "/casino/aggaphacksawgaming-gladiator-legends",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GladiatorLegends.webp",
      alt: "Gladiator Legends",
      name: "Gladiator Legends",
    },
    GronksGems: {
      href: "/casino/aggaphacksawgaming-gronks-gems",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GronksGems.webp",
      alt: "Gronk's Gems",
      name: "Gronk's Gems",
    },
    HandOfAnubis: {
      href: "/casino/aggaphacksawgaming-hand-of-anubis",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HandOfAnubis.webp",
      alt: "Hand Of Anubis",
      name: "Hand Of Anubis",
    },
    HarvestWilds: {
      href: "/casino/aggaphacksawgaming-harvest-wilds",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HarvestWilds.webp",
      alt: "Harvest Wilds",
      name: "Harvest Wilds",
    },
    HopNpop: {
      href: "/casino/aggaphacksawgaming-hopnpop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HopNpop.webp",
      alt: "Hop'n'pop",
      name: "Hop'n'pop",
    },
    Itero: {
      href: "/casino/aggaphacksawgaming-itero",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Itero.webp",
      alt: "Itero",
      name: "Itero",
    },
    JokerBombs: {
      href: "/casino/aggaphacksawgaming-joker-bombs",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/JokerBombs.webp",
      alt: "Joker Bombs",
      name: "Joker Bombs",
    },
    KeepemCool: {
      href: "/casino/aggaphacksawgaming-keepem-cool",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KeepemCool.webp",
      alt: "Keep'em Cool",
      name: "Keep'em Cool",
    },
    KingCarrot: {
      href: "/casino/aggaphacksawgaming-king-carrot",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KingCarrot.webp",
      alt: "King Carrot",
      name: "King Carrot",
    },
    LetItSnow: {
      href: "/casino/aggaphacksawgaming-let-it-snow",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LetItSnow.webp",
      alt: "Let it Snow",
      name: "Let it Snow",
    },
    MagicPiggy: {
      href: "/casino/aggaphacksawgaming-magic-piggy",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MagicPiggy.webp",
      alt: "Magic Piggy",
      name: "Magic Piggy",
    },
    MayanStackways: {
      href: "/casino/aggaphacksawgaming-mayan-stackways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MayanStackways.webp",
      alt: "Mayan Stackways",
      name: "Mayan Stackways",
    },
    MiamiMultiplier: {
      href: "/casino/qt-miami-multiplier",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MiamiMultiplier.webp",
      alt: "Miami Multiplier",
      name: "Miami Multiplier",
    },
    MysteryMotel: {
      href: "/casino/aggaphacksawgaming-mystery-motel",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MysteryMotel.webp",
      alt: "Mystery Motel",
      name: "Mystery Motel",
    },
    OmNom: {
      href: "/casino/aggaphacksawgaming-omnom",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OmNom.webp",
      alt: "OmNom",
      name: "OmNom",
    },
    OutlawsInc: {
      href: "/casino/aggaphacksawgaming-outlaws-inc",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OutlawsInc.webp",
      alt: "Outlaws Inc",
      name: "Outlaws Inc",
    },
    PugLife: {
      href: "/casino/aggaphacksawgaming-pug-life",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/PugLife.webp",
      alt: "Pug Life",
      name: "Pug Life",
    },
    RIPCity: {
      href: "/casino/aggaphacksawgaming-rip-city",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RIPCity.webp",
      alt: "RIP City",
      name: "RIP City",
    },
    RocketReels: {
      href: "/casino/aggaphacksawgaming-rocket-reels",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RocketReels.webp",
      alt: "Rocket Reels",
      name: "Rocket Reels",
    },
    Rotten: {
      href: "/casino/aggaphacksawgaming-rotten",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Rotten.webp",
      alt: "Rotten",
      name: "Rotten",
    },
    StackEM: {
      href: "/casino/aggaphacksawgaming-stackem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/StackEM.webp",
      alt: "Stack'EM",
      name: "Stack'EM",
    },
    Stickem: {
      href: "/casino/qt-stick-em",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Stickem.webp",
      alt: "Stick ‘em",
      name: "Stick ‘em",
    },
    Stormforged: {
      href: "/casino/aggaphacksawgaming-stormforged",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Stormforged.webp",
      alt: "Stormforged",
      name: "Stormforged",
    },
    TastyTreats: {
      href: "/casino/aggaphacksawgaming-tasty-treats",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TastyTreats.webp",
      alt: "Tasty Treats",
      name: "Tasty Treats",
    },
    TempleOfTorment: {
      href: "/casino/aggaphacksawgaming-temple-of-torment",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TempleOfTorment.webp",
      alt: "Temple of Torment",
      name: "Temple of Torment",
    },
    TheBoweryBoys: {
      href: "/casino/aggaphacksawgaming-the-bowery-boys",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TheBoweryBoys.webp",
      alt: "The Bowery Boys",
      name: "The Bowery Boys",
    },
    TheRespinners: {
      href: "/casino/aggaphacksawgaming-the-respinners",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TheRespinners.webp",
      alt: "The Respinners",
      name: "The Respinners",
    },
    TimeSpinners: {
      href: "/casino/aggaphacksawgaming-time-spinners",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TimeSpinners.webp",
      alt: "Time Spinners",
      name: "Time Spinners",
    },
    ToshiVideoClub: {
      href: "/casino/aggaphacksawgaming-toshi-video-club",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ToshiVideoClub.webp",
      alt: "Toshi Video Club",
      name: "Toshi Video Club",
    },
    UndeadFortune: {
      href: "/casino/aggaphacksawgaming-undead-fortune",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/UndeadFortune.webp",
      alt: "Undead Fortune",
      name: "Undead Fortune",
    },
    WarriorWays: {
      href: "/casino/aggaphacksawgaming-warrior-ways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/WarriorWays.webp",
      alt: "Warrior Ways",
      name: "Warrior Ways",
    },
    Xpander: {
      href: "/casino/aggaphacksawgaming-xpander",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Xpander.webp",
      alt: "Xpander",
      name: "Xpander",
    },
    FeelTheBeat: {
      href: "/casino/aggaphacksawgaming-feel-the-beat",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FeelTheBeat.webp",
      alt: "Feel the Beat",
      name: "Feel the Beat",
    },
    BeamBoys: {
      href: "/casino/aggaphacksawgaming-beam-boys",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BeamBoys.webp",
      alt: "Beam Boys",
      name: "Beam Boys",
    },
    Baccarat: {
      href: "/casino/aggaphacksawgaming-baccarat",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
    },
    FistOfDestruction: {
      href: "/casino/aggaphacksawgaming-fist-of-destruction",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FistOfDestruction.webp",
      alt: "Fist of Destruction",
      name: "Fist of Destruction",
    },
    DawnOfKings: {
      href: "/casino/aggaphacksawgaming-dawn-of-kings",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DawnOfKings.webp",
      alt: "Dawn of Kings",
      name: "Dawn of Kings",
    },
    BouncyBombs: {
      href: "/casino/aggaphacksawgaming-bouncy-bombs",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BouncyBombs.webp",
      alt: "Bouncy Bombs",
      name: "Bouncy Bombs",
    },
    RustyAndCurly: {
      href: "/casino/aggaphacksawgaming-rusty-and-curly",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RustyAndCurly.webp",
      alt: "Rusty and Curly",
      name: "Rusty and Curly",
    },
    // ScratchAMillion: {
    //   href: "/casino/qtechhacksawgaming-scratch-a-million-u8239",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/hacksaw/ScratchAMillion.webp",
    //   alt: "Scratch a Million",
    //   name: "Scratch a Million",
    // },
    // InstaCubes: {
    //   href: "/casino/qtechhacksawgaming-insta-cubes-u4725",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/hacksaw/InstaCubes.webp",
    //   alt: "Insta Cubes",
    //   name: "Insta Cubes",
    // },
    LePharaoh: {
      href: "/casino/aggaphacksawgaming-le-pharaoh",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LePharaoh.webp",
      alt: "Le Pharaoh",
      name: "Le Pharaoh",
    },
    OctoAttack: {
      href: "/casino/aggaphacksawgaming-octo-attack",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OctoAttack.webp",
      alt: "Octo Attack",
      name: "Octo Attack",
    },
    EvilEyes: {
      href: "/casino/aggaphacksawgaming-evil-eyes",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/EvilEyes.webp",
      alt: "Evil Eyes",
      name: "Evil Eyes",
    },
    SpeedCrash: {
      href: "/casino/aggaphacksawgaming-speed-crash",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SpeedCrash.webp",
      alt: "Speed Crash",
      name: "Speed Crash",
    },
    Limbo: {
      href: "/casino/aggaphacksawgaming-limbo",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Limbo.webp",
      alt: "Limbo",
      name: "Limbo",
    },
    DonnyDough: {
      href: "/casino/aggaphacksawgaming-donny-dough",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DonnyDough.webp",
      alt: "Donny Dough",
      name: "Donny Dough",
    },
    DragonsDomain: {
      href: "/casino/aggaphacksawgaming-dragons-domain",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DragonsDomain.webp",
      alt: "Dragon's Domain",
      name: "Dragon's Domain",
    },
    SixSixSix: {
      href: "/casino/aggaphacksawgaming-sixsixsix",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SixSixSix.webp",
      alt: "SixSixSix",
      name: "SixSixSix",
    },
    Dice: {
      href: "/casino/aggaphacksawgaming-dice",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Dice.webp",
      alt: "Dice",
      name: "Dice",
    },
    TaiTheToad: {
      href: "/casino/aggaphacksawgaming-tai-the-toad",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TaiTheToad.webp",
      alt: "Tai the Toad",
      name: "Tai the Toad",
    },
    TwistedLab: {
      href: "/casino/aggaphacksawgaming-twisted-lab",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TwistedLabs.webp",
      alt: "Twisted Lab",
      name: "Twisted Lab",
    },
    ZeZeus: {
      href: "/casino/aggaphacksawgaming-ze-zeus",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ZeZeus.webp",
      alt: "Ze Zeus",
      name: "Ze Zeus",
    },
    CursedCrypt: {
      href: "/casino/aggaphacksawgaming-cursed-crypt",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CursedCrypt.webp",
      alt: "Cursed Crypt",
      name: "Cursed Crypt",
    },
    SlayersInc: {
      href: "/casino/aggaphacksawgaming-slayers-inc",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SlayersInc.webp",
      alt: "Slayers Inc",
      name: "Slayers Inc",
    },
    JellySlice: {
      href: "/casino/aggaphacksawgaming-jelly-slice",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/JellySlice.webp",
      alt: "Jelly Slice",
      name: "Jelly Slice",
    },
    KeepEm: {
      href: "/casino/aggaphacksawgaming-keepem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KeepEm.webp",
      alt: "Keep'Em",
      name: "Keep'Em",
    },
    DivineDrop: {
      href: "/casino/aggaphacksawgaming-divine-drop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DivineDrop.webp",
      alt: "Divine Drop",
      name: "Divine Drop",
    },
    OrbOfDestiny: {
      href: "/casino/aggaphacksawgaming-orb-of-destiny",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OrbOfDestiny.webp",
      alt: "Orb of Destiny",
      name: "Orb of Destiny",
    },
    CashCrew: {
      href: "/casino/aggaphacksawgaming-cash-crew",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashCrew.webp",
      alt: "Cash Crew",
      name: "Cash Crew",
    },
    CloudPrincess: {
      href: "/casino/aggaphacksawgaming-cloud-princess",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CloudPrincess.webp",
      alt: "Cloud Princess",
      name: "Cloud Princess",
    },
    GetTheCheese: {
      href: "/casino/aggaphacksawgaming-get-the-cheese",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GetTheCheese.webp",
      alt: "Get The Cheese",
      name: "Get The Cheese",
    },
    RiseOfYmir: {
      href: "/casino/aggaphacksawgaming-rise-of-ymir",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RiseOfYmir.webp",
      alt: "Rise of Ymir",
      name: "Rise of Ymir",
    },
    WingsOfHorus: {
      href: "/casino/aggaphacksawgaming-wings-of-horus",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/WingsOfHorus.webp",
      alt: "Wings of Horus",
      name: "Wings of Horus",
    },
    DuelAtDawn: {
      href: "/casino/aggaphacksawgaming-duel-at-dawn",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DuelAtDawn.webp",
      alt: "Duel at Dawn",
      name: "Duel at Dawn",
    },
    SnowSlingers: {
      href: "/casino/aggaphacksawgaming-snow-slingers",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SnowSlingers.webp",
      alt: "Snow Slingers",
      name: "Snow Slingers",
    },
    ShaolinMaster: {
      href: "/casino/aggaphacksawgaming-shaolin-master",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ShaolinMaster.webp",
      alt: "Shaolin Master",
      name: "Shaolin Master",
    },
    DonutDivision: {
      href: "/casino/aggaphacksawgaming-donut-division",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DonutDivision.webp",
      alt: "Donut Division",
      name: "Donut Division",
    },
    FireMyLaser: {
      href: "/casino/aggaphacksawgaming-fire-my-laser",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FireMyLaser.webp",
      alt: "Fire My Laser",
      name: "Fire My Laser",
    },
    Klowns: {
      href: "/casino/aggaphacksawgaming-klowns",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Klowns.webp",
      alt: "Klowns",
      name: "Klowns",
    },
    LeViking: {
      href: "/casino/aggaphacksawgaming-le-viking",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LeViking.webp",
      alt: "Le Viking",
      name: "Le Viking",
    },
    PhoenixDuelReels: {
      href: "/casino/aggaphacksawgaming-phoenix-duelreels",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/PhoenixDuelReels.webp",
      alt: "Phoenix DuelReels",
      name: "Phoenix DuelReels",
    },
    MarlinMasters: {
      href: "/casino/aggaphacksawgaming-marlin-masters",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MarlinMasters.webp",
      alt: "Marlin Masters",
      name: "Marlin Masters",
    },
    FRKNBananas: {
      href: "/casino/aggaphacksawgaming-frkn-bananas",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FRKNBananas.webp",
      alt: "FRKN Bananas",
      name: "FRKN Bananas",
    },
    HoundsOfHell: {
      href: "/casino/aggaphacksawgaming-hounds-of-hell",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HoundsOfHell.webp",
      alt: "Hounds of Hell",
      name: "Hounds of Hell",
    },
  },

  turbo: {
    aero: {
      href: "/casino/aggapturbogames-aero",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Aero.webp",
      alt: "Aero",
      name: "Aero",
    },
    BallAndBall: {
      href: "/casino/aggapturbogames-ball-and-ball",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Ball&Ball.webp",
      alt: "Ball & Ball",
      name: "Ball & Ball",
    },
    Bayraktar: {
      href: "/casino/aggapturbogames-bayraktar",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Bayraktar.webp",
      alt: "Bayraktar",
      name: "Bayraktar",
    },
    Bubbles: {
      href: "/casino/aggapturbogames-bubbles",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Bubbles.webp",
      alt: "Bubbles",
      name: "Bubbles",
    },
    crashX: {
      href: "/casino/aggapturbogames-crash-x",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrashX.webp",
      alt: "Crash X",
      name: "Crash X",
    },
    CrashXFootballEdition: {
      href: "/casino/aggapturbogames-crash-x-football-edition",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrashXFootballEdition.webp",
      alt: "Crash X Football Edition",
      name: "Crash X Football Edition",
    },
    DiceTwice: {
      href: "/casino/aggapturbogames-dice-twice",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DiceTwice.webp",
      alt: "Dice Twice",
      name: "Dice Twice",
    },
    DogsStreet: {
      href: "/casino/aggapturbogames-dogs-street",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DogsStreet.webp",
      alt: "Dogs' Street",
      name: "Dogs' Street",
    },
    DoubleRoll: {
      href: "/casino/aggapturbogames-double-roll",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DoubleRoll.webp",
      alt: "Double Roll",
      name: "Double Roll",
    },
    FastFielder: {
      href: "/casino/aggapturbogames-fast-fielder",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/FastFielder.webp",
      alt: "Fast Fielder",
      name: "Fast Fielder",
    },
    FruitTowers: {
      href: "/casino/aggapturbogames-fruit-towers",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/FruitTowers.webp",
      alt: "Fruit Towers",
      name: "Fruit Towers",
    },
    Hamsta: {
      href: "/casino/aggapturbogames-hamsta",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Hamsta.webp",
      alt: "Hamsta",
      name: "Hamsta",
    },
    HiLo: {
      href: "/casino/aggapturbogames-hi-lo",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Hi-Lo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
    },
    JavelinX: {
      href: "/casino/aggapturbogames-javelinx",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/JavelinX.webp",
      alt: "JavelinX",
      name: "JavelinX",
    },
    LimboRider: {
      href: "/casino/aggapturbogames-limbo-rider",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/LimboRider.webp",
      alt: "Limbo Rider",
      name: "Limbo Rider",
    },
    Mines: {
      href: "/casino/aggapturbogames-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Mines.webp",
      alt: "Mines",
      name: "Mines",
    },
    Neko: {
      href: "/casino/aggapturbogames-neko",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Neko.webp",
      alt: "Neko",
      name: "Neko",
    },
    SaveThePrincess: {
      href: "/casino/aggapturbogames-save-the-princess",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/SaveThePrincess.webp",
      alt: "Save the Princess",
      name: "Save the Princess",
    },
    SpinStrike: {
      href: "/casino/aggapturbogames-spin-strike",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/SpinStrike.webp",
      alt: "Spin Strike",
      name: "Spin Strike",
    },
    Stairs: {
      href: "/casino/aggapturbogames-fury-stairs",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Stairs.webp",
      alt: "Stairs",
      name: "Stairs",
    },
    TradingDice: {
      href: "/casino/aggapturbogames-trading-dice",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TradingDice.webp",
      alt: "Trading Dice",
      name: "Trading Dice",
    },
    Towers: {
      href: "/casino/aggapturbogames-towers",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Towers.webp",
      alt: "Towers",
      name: "Towers",
    },
    TurboMines: {
      href: "/casino/aggapturbogames-turbo-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TurboMines.webp",
      alt: "Turbo Mines",
      name: "Turbo Mines",
    },
    TurboPlinko: {
      href: "/casino/aggapturbogames-turbo-plinko",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TurboPlinko.webp",
      alt: "Turbo Plinko",
      name: "Turbo Plinko",
    },
    WicketBlast: {
      href: "/casino/aggapturbogames-wicket-blast",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/WicketBlast.webp",
      alt: "Wicket Blast",
      name: "Wicket Blast",
    },
    MagicKeno: {
      href: "/casino/aggapturbogames-magic-keno",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/MagicKeno.webp",
      alt: "Magic Keno",
      name: "Magic Keno",
    },
    Vortex: {
      href: "/casino/aggapturbogames-vortex",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Vortex.webp",
      alt: "Vortex",
      name: "Vortex",
    },
    Tap1Mines: {
      href: "/casino/aggapturbogames-1tap-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/1TapMines(InstantWin).webp",
      alt: "1Tap Mines",
      name: "1Tap Mines",
    },
    TakeMyPlinko: {
      href: "/casino/aggapturbogames-take-my-plinko",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TakeMyPlinko.webp",
      alt: "Take My Plinko",
      name: "Take My Plinko",
    },
    Tap1MinesIW: {
      href: "/casino/qt-1tap-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/1TapMines.webp",
      alt: "1Tap Mines (Instant Win)",
      name: "1Tap Mines (Instant Win)",
    },
    DiceThrice: {
      href: "/casino/aggapturbogames-dice-thrice",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DiceThrice.webp",
      alt: "Dice Thrice",
      name: "Dice Thrice",
    },
    PumpedX: {
      href: "/casino/aggapturbogames-pumpedx",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/PumpedX.webp",
      alt: "PumpedX",
      name: "PumpedX",
    },
    DonnyKing: {
      href: "/casino/aggapturbogames-donny-king",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DonnyKing.webp",
      alt: "Donny King",
      name: "Donny King",
    },
    CrystalPoker: {
      href: "/casino/aggapturbogames-crystal-poker",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrystalPoker.webp",
      alt: "Crystal Poker",
      name: "Crystal Poker",
    },
    MultiplayerMines: {
      href: "/casino/aggapturbogames-multiplayer-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/MultiplayerMines.webp",
      alt: "Multiplayer Mines",
      name: "Multiplayer Mines",
    },
    BookOfMines: {
      href: "/casino/aggapturbogames-book-of-mines",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/BookOfMines.webp",
      alt: "Book of Mines",
      name: "Book of Mines",
    },
    JewelClicker: {
      href: "/casino/aggapturbogames-jewel-clicker",
      code: "",
      casino: "Slots",
      provider: "TurboGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/JewelClicker.webp",
      alt: "Jewel Clicker",
      name: "Jewel Clicker",
    },
  },

  playNGo: {
    SuperWheel: {
      href: "/casino/aggapplayngo-super-wheel",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SuperWheel.webp",
      alt: "super wheel",
      name: "Super Wheel",
    },
    MoneyWheel: {
      href: "/casino/aggapplayngo-money-wheel",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MoneyWheel.webp",
      alt: "money wheel",
      name: "Money Wheel",
    },
    RainforestMagicBingo: {
      href: "/casino/aggapplayngo-rainforest-magic-bingo",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RainforestMagicBingo.webp",
      alt: "rainforest magic bingo",
      name: "Rainforest Magic Bingo",
    },
    SweetAlchemyBingo: {
      href: "/casino/aggapplayngo-sweet-alchemy-bingo",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SweetAlchemyBingo.webp",
      alt: "sweet alchemy bingo",
      name: "Sweet Alchemy Bingo",
    },
    VikingRunecraftBingo: {
      href: "/casino/aggapplayngo-viking-runecraft-bingo",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/VikingRunecraftBingo.webp",
      alt: "viking runecraft bingo",
      name: "Viking Runecraft Bingo",
    },
    Clown3MontyII: {
      href: "/casino/aggapplayngo-3-clown-monty-ii",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/3ClownMontyII.webp",
      alt: "3 clown monty ii",
      name: "3 Clown Monty II",
    },
    PandasticAdventure: {
      href: "/casino/aggapplayngo-pandastic-adventure",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PandasticAdventure.webp",
      alt: "pandastic adventure",
      name: "Pandastic Adventure",
    },
    TalesOfMithruneSynsFortune: {
      href: "/casino/aggapplayngo-tales-of-mithrune-syns-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TalesofMithruneSynsFortune.webp",
      alt: "tales of mithrune syn's fortune",
      name: "Tales of Mithrune Syn's Fortune",
    },
    VikingRunecraft100: {
      href: "/casino/aggapplayngo-viking-runecraft-100",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/VikingRunecraft100.webp",
      alt: "viking runecraft 100",
      name: "Viking Runecraft 100",
    },
    Gargantoonz: {
      href: "/casino/aggapplayngo-gargantoonz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Gargantoonz.webp",
      alt: "gargantoonz",
      name: "Gargantoonz",
    },
    MegaDonFeedingFrenzy: {
      href: "/casino/aggapplayngo-mega-don-feeding-frenzy",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MegaDonFeedingFrenzy.webp",
      alt: "mega don feeding frenzy",
      name: "Mega Don: Feeding Frenzy",
    },
    InvadingVegasLasChristmas: {
      href: "/casino/aggapplayngo-invading-vegas-las-christmas",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/InvadingVegasLasChristmas.webp",
      alt: "invading vegas las christmas",
      name: "Invading Vegas: Las Christmas",
    },
    LegacyOfDynasties: {
      href: "/casino/aggapplayngo-legacy-of-dynasties",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegacyofDynasties.webp",
      alt: "legacy of dynasties",
      name: "Legacy of Dynasties",
    },
    MonkeyBattlefortheScrolls: {
      href: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MonkeyBattlefortheScrolls.webp",
      alt: "monkey battle for the scrolls",
      name: "Monkey: Battle for the Scrolls",
    },
    SherwoodGold: {
      href: "/casino/aggapplayngo-sherwood-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SherwoodGold.webp",
      alt: "sherwood gold",
      name: "Sherwood Gold",
    },
    RagingRex3: {
      href: "/casino/aggapplayngo-raging-rex-3",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RagingRex3.webp",
      alt: "raging rex 3",
      name: "Raging Rex 3",
    },
    RuffHeist: {
      href: "/casino/aggapplayngo-ruff-heist",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RuffHeist.webp",
      alt: "ruff heist",
      name: "Ruff Heist",
    },
    PiggyBlitz: {
      href: "/casino/aggapplayngo-piggy-blitz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PiggyBlitz.webp",
      alt: "piggy blitz",
      name: "Piggy Blitz",
    },
    ReturnoftheGreenKnight: {
      href: "/casino/aggapplayngo-return-of-the-green-knight",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ReturnoftheGreenKnight.webp",
      alt: "return of the green knight",
      name: "Return of the Green Knight",
    },
    TempleOfProsperity: {
      href: "/casino/aggapplayngo-temple-of-prosperity",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TempleofProsperity.webp",
      alt: "temple of prosperity",
      name: "Temple of Prosperity",
    },
    ScalesOfDead: {
      href: "/casino/aggapplayngo-scales-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ScalesofDead.webp",
      alt: "scales of dead",
      name: "Scales of Dead",
    },
    BoatBonanzaColossalCatch: {
      href: "/casino/aggapplayngo-boat-bonanza-colossal-catch",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BoatBonanzaColossalCatch.webp",
      alt: "boat bonanza colossal catch",
      name: "Boat Bonanza Colossal Catch",
    },
    HoneyRush100: {
      href: "/casino/aggapplayngo-honey-rush-100",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HoneyRush100.webp",
      alt: "honey rush 100",
      name: "Honey Rush 100",
    },
    HugoLegacy: {
      href: "/casino/aggapplayngo-hugo-legacy",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HugoLegacy.webp",
      alt: "hugo legacy",
      name: "Hugo Legacy",
    },
    SweetAlchemy100: {
      href: "/casino/aggapplayngo-sweet-alchemy-100",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SweetAlchemy100.webp",
      alt: "sweet alchemy 100",
      name: "Sweet Alchemy 100",
    },
    ScrollOfSeth: {
      href: "/casino/aggapplayngo-scroll-of-seth",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ScrollofSeth.webp",
      alt: "scroll of seth",
      name: "Scroll of Seth",
    },
    MerlinJourneyOfFlame: {
      href: "/casino/aggapplayngo-merlin-journey-of-flame",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MerlinJourneyofFlame.webp",
      alt: "merlin journey of flame",
      name: "Merlin: Journey of Flame",
    },
    SparkyAndShortsHiddenJoules: {
      href: "/casino/aggapplayngo-sparky-and-shorts-hidden-joules",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SparkyAndShortzHiddenJoules.webp",
      alt: "sparky & shorts hidden joules",
      name: "Sparky & Shorts Hidden Joules",
    },
    FoxMayhem: {
      href: "/casino/aggapplayngo-fox-mayhem",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FoxMayhem.webp",
      alt: "fox mayhem",
      name: "Fox Mayhem",
    },
    RichWildeAndTheAmuletOfDead: {
      href: "/casino/aggapplayngo-rich-wilde-and-the-amulet-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichWildeandtheAmuletofDead.webp",
      alt: "rich wilde and the amulet of dead",
      name: "Rich Wilde and the Amulet of Dead",
    },
    SweetAlchemy2: {
      href: "/casino/aggapplayngo-sweet-alchemy-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SweetAlchemy2.webp",
      alt: "sweet alchemy 2",
      name: "Sweet Alchemy 2",
    },
    RascalRiches: {
      href: "/casino/aggapplayngo-rascal-riches",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RascalRiches.webp",
      alt: "rascal riches",
      name: "Rascal Riches",
    },
    Ternion: {
      href: "/casino/aggapplayngo-ternion",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Ternion.webp",
      alt: "ternion",
      name: "Ternion",
    },
    VikingRunecraftApocalypse: {
      href: "/casino/aggapplayngo-viking-runecraft-apocalypse",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/VikingRunecraftApocalypse.webp",
      alt: "viking runecraft apocalypse",
      name: "Viking Runecraft: Apocalypse",
    },
    Crystal15RosesATaleOfLove: {
      href: "/casino/aggapplayngo-15-crystal-roses-a-tale-of-love",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/15CrystalRosesATaleOfLove.webp",
      alt: "15 crystal roses a tale of love",
      name: "15 Crystal Roses A Tale Of Love",
    },
    Dragon24k: {
      href: "/casino/aggapplayngo-24k-dragon",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/24kDragon.webp",
      alt: "24k dragon",
      name: "24k Dragon",
    },
    Clown3Monty: {
      href: "/casino/aggapplayngo-3-clown-monty",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/3ClownMonty.webp",
      alt: "3 clown monty",
      name: "3 Clown Monty",
    },
    Magic5x: {
      href: "/casino/aggapplayngo-5x-magic",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/5xMagic.webp",
      alt: "5x magic",
      name: "5x Magic",
    },
    Sins7: {
      href: "/casino/aggapplayngo-7-sins",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/7Sins.webp",
      alt: "7 sins",
      name: "7 Sins",
    },
    AceOfSpades: {
      href: "/casino/aggapplayngo-ace-of-spades",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AceofSpades.webp",
      alt: "ace of spades",
      name: "Ace of Spades",
    },
    AgentDestiny: {
      href: "/casino/aggapplayngo-agent-destiny",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AgentDestiny.webp",
      alt: "agent destiny",
      name: "Agent Destiny",
    },
    AgentOfHearts: {
      href: "/casino/aggapplayngo-agent-of-hearts",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AgentofHearts.webp",
      alt: "agent of hearts",
      name: "Agent of Hearts",
    },
    AnimalMadness: {
      href: "/casino/aggapplayngo-animal-madness",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AnimalMadness.webp",
      alt: "animal madness",
      name: "Animal Madness",
    },
    AnkhOfAnubis: {
      href: "/casino/aggapplayngo-ankh-of-anubis",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AnkhofAnubis.webp",
      alt: "ankh of anubis",
      name: "Ankh of Anubis",
    },
    Annihilator: {
      href: "/casino/aggapplayngo-annihilator",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Annihilator.webp",
      alt: "annihilator",
      name: "Annihilator",
    },
    AthenaAscending: {
      href: "/casino/aggapplayngo-athena-ascending",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AthenaAscending.webp",
      alt: "athena ascending",
      name: "Athena Ascending",
    },
    AztecIdols: {
      href: "/casino/aggapplayngo-aztec-idols",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AztecIdols.webp",
      alt: "aztec idols",
      name: "Aztec Idols",
    },
    AztecWarriorPrincess: {
      href: "/casino/aggapplayngo-aztec-warrior-princess",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AztecWarriorPrincess.webp",
      alt: "aztec warrior princess",
      name: "Aztec Warrior Princess",
    },
    BakersTreat: {
      href: "/casino/aggapplayngo-bakers-treat",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BakersTreat.webp",
      alt: "bakers treat",
      name: "Baker's Treat",
    },
    BananaRock: {
      href: "/casino/aggapplayngo-banana-rock",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BananaRock.webp",
      alt: "banana rock",
      name: "Banana Rock",
    },
    BattleRoyal: {
      href: "/casino/aggapplayngo-battle-royal",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BattleRoyal.webp",
      alt: "battle royal",
      name: "Battle Royal",
    },
    BeastsOfFire: {
      href: "/casino/aggapplayngo-beasts-of-fire",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BeastsOfFire.webp",
      alt: "beasts of fire",
      name: "Beasts Of Fire",
    },
    BigWin777: {
      href: "/casino/aggapplayngo-big-win-777",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BigWin777.webp",
      alt: "big win 777",
      name: "Big Win 777",
    },
    BigWinCat: {
      href: "/casino/aggapplayngo-big-win-cat",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BigWinCat.webp",
      alt: "big win cat",
      name: "Big Win Cat",
    },
    BlackMamba: {
      href: "/casino/aggapplayngo-black-mamba",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BlackMamba.webp",
      alt: "black mamba",
      name: "Black Mamba",
    },
    BlazinBullfrog: {
      href: "/casino/aggapplayngo-blazin-bullfrog",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BlazinBullfrog.webp",
      alt: "blazin bullfrog",
      name: "Blazin' Bullfrog",
    },
    Blinged: {
      href: "/casino/aggapplayngo-blinged",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Blinged.webp",
      alt: "blinged",
      name: "Blinged",
    },
    BoatBonanza: {
      href: "/casino/aggapplayngo-boat-bonanza",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BoatBonanza.webp",
      alt: "boat bonanza",
      name: "Boat Bonanza",
    },
    BookOfDead: {
      href: "/casino/aggapplayngo-book-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BookofDead.webp",
      alt: "book of dead",
      name: "Book of Dead",
    },
    BullInAChinaShop: {
      href: "/casino/aggapplayngo-bull-in-a-china-shop",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BullinaChinaShop.webp",
      alt: "bull in a china shop",
      name: "Bull in a China Shop",
    },
    BullInARodeo: {
      href: "/casino/aggapplayngo-bull-in-a-rodeo",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BullinaRodeo.webp",
      alt: "bull in a rodeo",
      name: "Bull in a Rodeo",
    },
    CandyIslandPrincess: {
      href: "/casino/aggapplayngo-candy-island-princess",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CandyIslandPrincess.webp",
      alt: "candy island princess",
      name: "Candy Island Princess",
    },
    CanineCarnage: {
      href: "/casino/aggapplayngo-canine-carnage",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CanineCarnage.webp",
      alt: "canine carnage",
      name: "Canine Carnage",
    },
    CaptainGlumPirateHunter: {
      href: "/casino/aggapplayngo-captain-glum-pirate-hunter",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CaptainGlumPirateHunter.webp",
      alt: "captain glum pirate hunter",
      name: "Captain Glum: Pirate Hunter",
    },
    CaptainXenosEarthAdventure: {
      href: "/casino/aggapplayngo-captain-xenos-earth-adventure",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CaptainXenosEarthAdventure.webp",
      alt: "captain xenos earth adventure",
      name: "Captain Xeno's Earth Adventure",
    },
    CashACabana: {
      href: "/casino/aggapplayngo-cash-a-cabana",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CashaCabana.webp",
      alt: "cash a cabana",
      name: "Cash-a-Cabana",
    },
    CashOfCommand: {
      href: "/casino/aggapplayngo-cash-of-command",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CashofCommand.webp",
      alt: "cash of command",
      name: "Cash of Command",
    },
    CashPump: {
      href: "/casino/aggapplayngo-cash-pump",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CashPump.webp",
      alt: "cash pump",
      name: "Cash Pump",
    },
    CashVandal: {
      href: "/casino/aggapplayngo-cash-vandal",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CashVandal.webp",
      alt: "cash vandal",
      name: "Cash Vandal",
    },
    CatWildeAndTheDoomOfDead: {
      href: "/casino/aggapplayngo-cat-wilde-and-the-doom-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CatWildeandtheDoomofDead.webp",
      alt: "cat wilde and the doom of dead",
      name: "Cat Wilde and the Doom of Dead",
    },
    CatWildeAndTheLostChapter: {
      href: "/casino/aggapplayngo-cat-wilde-and-the-lost-chapter",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CatWildeandtheLostChapter.webp",
      alt: "cat wilde and the lost chapter",
      name: "Cat Wilde and the Lost Chapter",
    },
    CatWildeAndThePyramidsOfDead: {
      href: "/casino/aggapplayngo-cat-wilde-and-the-pyramids-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CatWildeandthePyramidsofDead.webp",
      alt: "cat wilde and the pyramids of dead",
      name: "Cat Wilde and the Pyramids of Dead",
    },
    CatWildeInTheEclipseOfTheSunGod: {
      href: "/casino/aggapplayngo-cat-wilde-in-the-eclipse-of-the-sun-god",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "/images/slots/new/play-n-go/CatWildeintheEclipseoftheSunGod.webp",
      alt: "cat wilde in the eclipse of the sun god",
      name: "Cat Wilde in the Eclipse of the Sun God",
    },
    CatsAndCash: {
      href: "/casino/aggapplayngo-cats-and-cash",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CatsandCash.webp",
      alt: "cats and cash",
      name: "Cats and Cash",
    },
    ChampionsOfMithrune: {
      href: "/casino/aggapplayngo-champions-of-mithrune",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ChampionsofMithrune.webp",
      alt: "champions of mithrune",
      name: "Champions of Mithrune",
    },
    CharlieChance: {
      href: "/casino/aggapplayngo-charlie-chance",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CharlieChance.webp",
      alt: "charlie chance",
      name: "Charlie Chance",
    },
    CharlieChanceAndTheCurseOfCleopatra: {
      href: "/casino/aggapplayngo-charlie-chance-and-the-curse-of-cleopatra",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "/images/slots/new/play-n-go/CharlieChanceandTheCurseofCleopatra.webp",
      alt: "charlie chance and the curse of cleopatra",
      name: "Charlie Chance and The Curse of Cleopatra",
    },
    // CharlieChanceInHellToPay: {
    //   href: "/casino/qtechplayngo-charlie-chance-in-hell-to-pay",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/CharlieChanceinHelltoPay.webp",
    //   alt: "charlie chance in hell to pay",
    //   name: "Charlie Chance in Hell to Pay",
    // },
    ChineseNewYear: {
      href: "/casino/aggapplayngo-chinese-new-year",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ChineseNewYear.webp",
      alt: "chinese new year",
      name: "Chinese New Year",
    },
    ChronosJoker: {
      href: "/casino/aggapplayngo-chronos-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ChronosJoker.webp",
      alt: "chronos joker",
      name: "Chronos Joker",
    },
    ClashOfCamelot: {
      href: "/casino/aggapplayngo-clash-of-camelot",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ClashofCamelot.webp",
      alt: "clash of camelot",
      name: "Clash of Camelot",
    },
    CloudQuest: {
      href: "/casino/aggapplayngo-cloud-quest",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CloudQuest.webp",
      alt: "cloud quest",
      name: "Cloud Quest",
    },
    CoilsOfCash: {
      href: "/casino/aggapplayngo-coils-of-cash",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CoilsofCash.webp",
      alt: "coils of cash",
      name: "Coils of Cash",
    },
    ColtLightning: {
      href: "/casino/aggapplayngo-colt-lightning",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ColtLightning.webp",
      alt: "colt lightning",
      name: "Colt Lightning",
    },
    Contact: {
      href: "/casino/aggapplayngo-contact",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Contact.webp",
      alt: "contact",
      name: "Contact",
    },
    CopsNRobbers: {
      href: "/casino/aggapplayngo-copsnrobbers",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CopsnRobbers.webp",
      alt: "copsnrobbers",
      name: "Cops'n'Robbers",
    },
    CountJokula: {
      href: "/casino/aggapplayngo-count-jokula",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CountJokula.webp",
      alt: "count jokula",
      name: "Count Jokula",
    },
    CourtOfHearts: {
      href: "/casino/aggapplayngo-court-of-hearts",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CourtofHearts.webp",
      alt: "court of hearts",
      name: "Court of Hearts",
    },
    CoywolfCash: {
      href: "/casino/aggapplayngo-coywolf-cash",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CoywolfCash.webp",
      alt: "coywolf cash",
      name: "Coywolf Cash",
    },
    CrazyCows: {
      href: "/casino/aggapplayngo-crazy-cows",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CrazyCows.webp",
      alt: "crazy cows",
      name: "Crazy Cows",
    },
    CrystalSun: {
      href: "/casino/aggapplayngo-crystal-sun",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CrystalSun.webp",
      alt: "crystal sun",
      name: "Crystal Sun",
    },
    DawnOfEgypt: {
      href: "/casino/aggapplayngo-dawn-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DawnofEgypt.webp",
      alt: "dawn of egypt",
      name: "Dawn of Egypt",
    },
    Demon: {
      href: "/casino/aggapplayngo-demon",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Demon.webp",
      alt: "demon",
      name: "Demon",
    },
    DerbyWheel: {
      href: "/casino/aggapplayngo-derby-wheel",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DerbyWheel.webp",
      alt: "derby wheel",
      name: "Derby Wheel",
    },
    DiamondsOfTheRealm: {
      href: "/casino/aggapplayngo-diamonds-of-the-realm",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DiamondsoftheRealm.webp",
      alt: "diamonds of the realm",
      name: "Diamonds of the Realm",
    },
    DiamondVortex: {
      href: "/casino/aggapplayngo-diamond-vortex",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DiamondVortex.webp",
      alt: "diamond-vortex",
      name: "Diamond Vortex",
    },
    DiscoDiamonds: {
      href: "/casino/aggapplayngo-disco-diamonds",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DiscoDiamonds.webp",
      alt: "disco diamonds",
      name: "Disco Diamonds",
    },
    DivineShowdown: {
      href: "/casino/aggapplayngo-divine-showdown",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DivineShowdown.webp",
      alt: "divine showdown",
      name: "Divine Showdown",
    },
    DrToonz: {
      href: "/casino/aggapplayngo-dr-toonz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DrToonz.webp",
      alt: "dr toonz",
      name: "Dr Toonz",
    },
    DoomOfEgypt: {
      href: "/casino/aggapplayngo-doom-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DoomofEgypt.webp",
      alt: "doom of egypt",
      name: "Doom of Egypt",
    },
    DragonMaiden: {
      href: "/casino/aggapplayngo-dragon-maiden",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DragonMaiden.webp",
      alt: "Dragon Maiden",
      name: "Dragon Maiden",
    },
    DragonShip: {
      href: "/casino/aggapplayngo-dragon-ship",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DragonShip.webp",
      alt: "Dragon Ship",
      name: "Dragon Ship",
    },
    EasterEggs: {
      href: "/casino/aggapplayngo-easter-eggs",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EasterEggs.webp",
      alt: "Easter Eggs",
      name: "Easter Eggs",
    },
    EnchantedCrystals: {
      href: "/casino/aggapplayngo-enchanted-crystals",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EnchantedCrystals.webp",
      alt: "Enchanted Crystals",
      name: "Enchanted Crystals",
    },
    EnchantedMeadow: {
      href: "/casino/aggapplayngo-enchanted-meadow",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EnchantedMeadow.webp",
      alt: "Enchanted Meadow",
      name: "Enchanted Meadow",
    },
    Energoonz: {
      href: "/casino/aggapplayngo-energoonz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Energoonz.webp",
      alt: "Energoonz",
      name: "Energoonz",
    },
    EyeOfAtum: {
      href: "/casino/aggapplayngo-eye-of-atum",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EyeOfAtum.webp",
      alt: "Eye Of Atum",
      name: "Eye Of Atum",
    },
    EyeOfTheKraken: {
      href: "/casino/aggapplayngo-eye-of-the-kraken",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EyeOfTheKraken.webp",
      alt: "Eye of the Kraken",
      name: "Eye of the Kraken",
    },
    FatFrankies: {
      href: "/casino/aggapplayngo-fat-frankies",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FatFrankies.webp",
      alt: "Fat Frankies",
      name: "Fat Frankies",
    },
    FelineFury: {
      href: "/casino/aggapplayngo-feline-fury",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FelineFury.webp",
      alt: "Feline Fury",
      name: "Feline Fury",
    },
    FireJoker: {
      href: "/casino/aggapplayngo-fire-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FireJoker.webp",
      alt: "Fire Joker",
      name: "Fire Joker",
    },
    FireJokerFreeze: {
      href: "/casino/aggapplayngo-fire-joker-freeze",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FireJokerFreeze.webp",
      alt: "Fire Joker Freeze",
      name: "Fire Joker Freeze",
    },
    FireflyFrenzy: {
      href: "/casino/aggapplayngo-firefly-frenzy",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FireflyFrenzy.webp",
      alt: "Firefly Frenzy",
      name: "Firefly Frenzy",
    },

    ForgeOfFortunes: {
      href: "/casino/aggapplayngo-forge-of-fortunes",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ForgeOfFortunes.webp",
      alt: "Forge of Fortunes",
      name: "Forge of Fortunes",
    },
    ForgeOfGems: {
      href: "/casino/aggapplayngo-forge-of-gems",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ForgeOfGems.webp",
      alt: "Forge Of Gems",
      name: "Forge Of Gems",
    },
    FortuneRewind: {
      href: "/casino/aggapplayngo-fortune-rewind",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FortuneRewind.webp",
      alt: "Fortune Rewind",
      name: "Fortune Rewind",
    },
    FortunesOfAliBaba: {
      href: "/casino/aggapplayngo-fortunes-of-ali-baba",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FortunesOfAliBaba.webp",
      alt: "Fortunes of Ali Baba",
      name: "Fortunes of Ali Baba",
    },
    FreeReelinJoker1000: {
      href: "/casino/aggapplayngo-free-reelin-joker-1000",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FreeReelinJoker1000.webp",
      alt: "Free Reelin' Joker 1000",
      name: "Free Reelin' Joker 1000",
    },
    FreeReelinJoker: {
      href: "/casino/aggapplayngo-free-reelin-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FreeReelinJoker.webp",
      alt: "Free Reelin' Joker",
      name: "Free Reelin' Joker",
    },
    FrozenGems: {
      href: "/casino/aggapplayngo-frozen-gems",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FrozenGems.webp",
      alt: "Frozen Gems",
      name: "Frozen Gems",
    },
    FUERDAI: {
      href: "/casino/aggapplayngo-fu-er-dai",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/FUERDAI.webp",
      alt: "FU ER DAI",
      name: "FU ER DAI",
    },
    GameOfGladiators: {
      href: "/casino/aggapplayngo-game-of-gladiators",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GameOfGladiators.webp",
      alt: "Game of Gladiators",
      name: "Game of Gladiators",
    },
    GameOfGladiatorsUprising: {
      href: "/casino/aggapplayngo-game-of-gladiators",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GameOfGladiatorsUprising.webp",
      alt: "Game of Gladiators: Uprising",
      name: "Game of Gladiators: Uprising",
    },
    GatesOfTroy: {
      href: "/casino/aggapplayngo-gates-of-troy",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GatesOfTroy.webp",
      alt: "Gates of Troy",
      name: "Gates of Troy",
    },
    Gemix: {
      href: "/casino/aggapplayngo-gemix",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Gemix.webp",
      alt: "Gemix",
      name: "Gemix",
    },
    Gemix2: {
      href: "/casino/aggapplayngo-gemix-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Gemix2.webp",
      alt: "Gemix 2",
      name: "Gemix 2",
    },
    GerardsGambit: {
      href: "/casino/aggapplayngo-gerards-gambit",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GerardsGambit.webp",
      alt: "Gerard's Gambit",
      name: "Gerard's Gambit",
    },
    GhostOfDead: {
      href: "/casino/aggapplayngo-ghost-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GhostOfDead.webp",
      alt: "Ghost of Dead",
      name: "Ghost of Dead",
    },
    Gigantoonz: {
      href: "/casino/aggapplayngo-gigantoonz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Gigantoonz.webp",
      alt: "Gigantoonz",
      name: "Gigantoonz",
    },
    GoldKing: {
      href: "/casino/aggapplayngo-gold-king",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldKing.webp",
      alt: "Gold King",
      name: "Gold King",
    },
    GoldTrophy2: {
      href: "/casino/aggapplayngo-gold-trophy-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldTrophy2.webp",
      alt: "Gold Trophy 2",
      name: "Gold Trophy 2",
    },
    GoldVolcano: {
      href: "/casino/aggapplayngo-gold-volcano",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldVolcano.webp",
      alt: "Gold Volcano",
      name: "Gold Volcano",
    },
    GoldenCaravan: {
      href: "/casino/aggapplayngo-golden-caravan",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldenCaravan.webp",
      alt: "Golden Caravan",
      name: "Golden Caravan",
    },
    GoldenColts: {
      href: "/casino/aggapplayngo-golden-colts",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldenColts.webp",
      alt: "Golden Colts",
      name: "Golden Colts",
    },
    GoldenLegend: {
      href: "/casino/aggapplayngo-golden-legend",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldenLegend.webp",
      alt: "Golden Legend",
      name: "Golden Legend",
    },
    GoldenOsiris: {
      href: "/casino/aggapplayngo-golden-osiris",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldenOsiris.webp",
      alt: "Golden Osiris",
      name: "Golden Osiris",
    },
    GoldenTicket: {
      href: "/casino/aggapplayngo-golden-ticket",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldenTicket.webp",
      alt: "Golden Ticket",
      name: "Golden Ticket",
    },
    GoldenTicket2: {
      href: "/casino/aggapplayngo-golden-ticket-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldenTicket2.webp",
      alt: "Golden Ticket 2",
      name: "Golden Ticket 2",
    },
    GrimMuerto: {
      href: "/casino/aggapplayngo-grim-muerto",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GrimMuerto.webp",
      alt: "Grim Muerto",
      name: "Grim Muerto",
    },
    HappyHalloween: {
      href: "/casino/aggapplayngo-happy-halloween",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HappyHalloween.webp",
      alt: "Happy Halloween",
      name: "Happy Halloween",
    },
    HighwayLegends: {
      href: "/casino/aggapplayngo-highway-legends",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HighwayLegends.webp",
      alt: "Highway Legends",
      name: "Highway Legends",
    },
    HolidaySeason: {
      href: "/casino/aggapplayngo-holiday-season",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HolidaySeason.webp",
      alt: "Holiday Season",
      name: "Holiday Season",
    },
    HolidaySpirits: {
      href: "/casino/aggapplayngo-holiday-spirits",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HolidaySpirits.webp",
      alt: "Holiday Spirits",
      name: "Holiday Spirits",
    },
    HoneyRush: {
      href: "/casino/aggapplayngo-honey-rush",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HoneyRush.webp",
      alt: "Honey Rush",
      name: "Honey Rush",
    },
    HooliganHustle: {
      href: "/casino/aggapplayngo-hooligan-hustle",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HooliganHustle.webp",
      alt: "Hooligan Hustle",
      name: "Hooligan Hustle",
    },
    HotelYetiWay: {
      href: "/casino/aggapplayngo-hotel-yeti-way",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HotelYetiWay.webp",
      alt: "Hotel Yeti-Way",
      name: "Hotel Yeti-Way",
    },
    HouseOfDoom: {
      href: "/casino/aggapplayngo-house-of-doom",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HouseofDoom.webp",
      alt: "House of Doom",
      name: "House of Doom",
    },
    HouseOfDoom2TheCrypt: {
      href: "/casino/aggapplayngo-house-of-doom-2-the-crypt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HouseofDoom2TheCrypt.webp",
      alt: "House of Doom 2 The Crypt",
      name: "House of Doom 2 The Crypt",
    },
    IceJoker: {
      href: "/casino/aggapplayngo-ice-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/IceJoker.webp",
      alt: "Ice Joker",
      name: "Ice Joker",
    },
    IdolOfFortune: {
      href: "/casino/aggapplayngo-idol-of-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/IdolofFortune.webp",
      alt: "Idol of Fortune",
      name: "Idol of Fortune",
    },
    ImmorTailsOfEgypt: {
      href: "/casino/aggapplayngo-immortails-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ImmorTailsOfEgypt.webp",
      alt: "ImmorTails of Egypt",
      name: "ImmorTails of Egypt",
    },
    // ImperialOpera: {
    //   href: "/casino/qtechplayngo-imperial-opera",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/ImperialOpera.webp",
    //   alt: "Imperial Opera",
    //   name: "Imperial Opera",
    // },
    InfernoJoker: {
      href: "/casino/aggapplayngo-inferno-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/InfernoJoker.webp",
      alt: "Inferno Joker",
      name: "Inferno Joker",
    },
    InvadingVegas: {
      href: "/casino/aggapplayngo-invading-vegas",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/InvadingVegas.webp",
      alt: "Invading Vegas",
      name: "Invading Vegas",
    },
    InfernoStar: {
      href: "/casino/aggapplayngo-inferno-star",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/InfernoStar.webp",
      alt: "Inferno Star",
      name: "Inferno Star",
    },
    IrishGold: {
      href: "/casino/aggapplayngo-irish-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/IrishGold.webp",
      alt: "Irish Gold",
      name: "Irish Gold",
    },
    IronGirl: {
      href: "/casino/aggapplayngo-iron-girl",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/IronGirl.webp",
      alt: "Iron Girl",
      name: "Iron Girl",
    },
    JadeMagician: {
      href: "/casino/aggapplayngo-jade-magician",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JadeMagician.webp",
      alt: "Jade Magician",
      name: "Jade Magician",
    },
    JewelBox: {
      href: "/casino/aggapplayngo-jewel-box",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JewelBox.webp",
      alt: "Jewel Box",
      name: "Jewel Box",
    },
    // JollyRoger: {
    //   href: "/casino/qtechplayngo-jolly-roger",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/JollyRoger.webp",
    //   alt: "Jolly Roger",
    //   name: "Jolly Roger",
    // },
    JollyRoger2: {
      href: "/casino/aggapplayngo-jolly-roger-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JollyRoger2.webp",
      alt: "Jolly Roger 2",
      name: "Jolly Roger 2",
    },
    KingsMask: {
      href: "/casino/aggapplayngo-kings-mask",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/KingsMask.webp",
      alt: "King's Mask",
      name: "King's Mask",
    },
    LadyOfFortune: {
      href: "/casino/aggapplayngo-lady-of-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LadyOfFortune.webp",
      alt: "Lady of Fortune",
      name: "Lady of Fortune",
    },
    LegacyOfDead: {
      href: "/casino/aggapplayngo-legacy-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegacyOfDead.webp",
      alt: "Legacy of Dead",
      name: "Legacy of Dead",
    },
    LegacyOfEgypt: {
      href: "/casino/aggapplayngo-legacy-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegacyOfEgypt.webp",
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
    },
    LegacyOfInca: {
      href: "/casino/aggapplayngo-legacy-of-inca",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegacyOfInca.webp",
      alt: "Legacy of Inca",
      name: "Legacy of Inca",
    },
    LegendOfTheIceDragon: {
      href: "/casino/aggapplayngo-legend-of-the-ice-dragon",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegendOfTheIceDragon.webp",
      alt: "Legend Of The Ice Dragon",
      name: "Legend Of The Ice Dragon",
    },
    LegionGold: {
      href: "/casino/aggapplayngo-legion-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegionGold.webp",
      alt: "Legion Gold",
      name: "Legion Gold",
    },
    LeprechaunGoesEgypt: {
      href: "/casino/aggapplayngo-leprechaun-goes-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LeprechaunGoesEgypt.webp",
      alt: "Leprechaun goes Egypt",
      name: "Leprechaun goes Egypt",
    },
    LeprechaunGoesWild: {
      href: "/casino/aggapplayngo-leprechaun-goes-wild",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LeprechaunGoesWild.webp",
      alt: "Leprechaun Goes Wild",
      name: "Leprechaun Goes Wild",
    },
    LeprechaunsVault: {
      href: "/casino/aggapplayngo-leprechauns-vault",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LeprechaunsVault.webp",
      alt: "Leprechaun's Vault",
      name: "Leprechaun's Vault",
    },
    LordMerlinAndTheLadyOfTheLake: {
      href: "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
      alt: "Lord Merlin and The Lady of The Lake",
      name: "Lord Merlin and The Lady of The Lake",
    },
    LoveJoker: {
      href: "/casino/aggapplayngo-love-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LoveJoker.webp",
      alt: "Love Joker",
      name: "Love Joker",
    },
    Luchamigos: {
      href: "/casino/aggapplayngo-luchamigos",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Luchamigos.webp",
      alt: "Luchamigos",
      name: "Luchamigos",
    },
    LuckyDiamonds: {
      href: "/casino/aggapplayngo-lucky-diamonds",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LuckyDiamonds.webp",
      alt: "Lucky Diamonds",
      name: "Lucky Diamonds",
    },
    MadameInk: {
      href: "/casino/aggapplayngo-madame-ink",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MadameInk.webp",
      alt: "Madame Ink",
      name: "Madame Ink",
    },
    MegaDon: {
      href: "/casino/aggapplayngo-mega-don",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MegaDon.webp",
      alt: "Mega Don",
      name: "Mega Don",
    },
    Mahjong88: {
      href: "/casino/aggapplayngo-mahjong-88",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Mahjong88.webp",
      alt: "Mahjong 88",
      name: "Mahjong 88",
    },
    Matsuri: {
      href: "/casino/aggapplayngo-matsuri",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Matsuri.webp",
      alt: "Matsuri",
      name: "Matsuri",
    },
    MerlinAndIceQueenMorgana: {
      href: "/casino/aggapplayngo-merlin-and-ice-queen-morgana",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MerlinAndTheIceQueenMorgana.webp",
      alt: "Merlin and Ice Queen Morgana",
      name: "Merlin and Ice Queen Morgana",
    },
    MerlinsGrimoire: {
      href: "/casino/aggapplayngo-merlins-grimoire",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MerlinsGrimoire.webp",
      alt: "Merlin's Grimoire",
      name: "Merlin's Grimoire",
    },
    MermaidsDiamond: {
      href: "/casino/aggapplayngo-mermaids-diamond",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MermaidsDiamond.webp",
      alt: "Mermaid's Diamond",
      name: "Mermaid's Diamond",
    },
    MerryXmas: {
      href: "/casino/aggapplayngo-merry-xmas",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MerryXmas.webp",
      alt: "Merry Xmas",
      name: "Merry Xmas",
    },
    MinerDonkeyTrouble: {
      href: "/casino/aggapplayngo-miner-donkey-trouble",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MinerDonkeyTrouble.webp",
      alt: "Miner Donkey Trouble",
      name: "Miner Donkey Trouble",
    },
    MissionCash: {
      href: "/casino/aggapplayngo-mission-cash",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MissionCash.webp",
      alt: "Mission Cash",
      name: "Mission Cash",
    },
    MoonPrincess100: {
      href: "/casino/aggapplayngo-moon-princess-100",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MoonPrincess100.webp",
      alt: "Moon Princess 100",
      name: "Moon Princess 100",
    },
    MoonPrincess: {
      href: "/casino/aggapplayngo-moon-princess",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MoonPrincess.webp",
      alt: "Moon Princess",
      name: "Moon Princess",
    },
    MoonPrincessChristmasKingdom: {
      href: "/casino/aggapplayngo-moon-princess-christmas-kingdom",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MoonPrincessChristmasKingdom.webp",
      alt: "Moon Princess Christmas Kingdom",
      name: "Moon Princess Christmas Kingdom",
    },
    MoonPrincessTrinity: {
      href: "/casino/aggapplayngo-moon-princess-trinity",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MoonPrincessTrinity.webp",
      alt: "Moon Princess Trinity",
      name: "Moon Princess Trinity",
    },
    MountM: {
      href: "/casino/aggapplayngo-mount-m",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MountM.webp",
      alt: "Mount M",
      name: "Mount M",
    },
    MuertoEnMictlán: {
      href: "/casino/aggapplayngo-muerto-en-mictlan",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MuertoEnMictlán.webp",
      alt: "Muerto en Mictlán",
      name: "Muerto en Mictlán",
    },
    // MultiFruit81: {
    //   href: "/casino/qtechplayngo-multifruit-81",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/MultiFruit81.webp",
    //   alt: "MultiFruit 81",
    //   name: "MultiFruit 81",
    // },
    MysteryJoker: {
      href: "/casino/aggapplayngo-mystery-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MysteryJoker.webp",
      alt: "Mystery Joker",
      name: "Mystery Joker",
    },
    MysteryJoker6000: {
      href: "/casino/aggapplayngo-mystery-joker-6000",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MysteryJoker6000.webp",
      alt: "Mystery Joker 6000",
      name: "Mystery Joker 6000",
    },
    Myth: {
      href: "/casino/aggapplayngo-myth",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Myth.webp",
      alt: "Myth",
      name: "Myth",
    },
    NaughtyNicksBook: {
      href: "/casino/aggapplayngo-naughty-nicks-book",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/NaughtyNicksBook.webp",
      alt: "Naughty Nick's Book",
      name: "Naughty Nick's Book",
    },
    NewYearRiches: {
      href: "/casino/aggapplayngo-new-year-riches",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/NewYearRiches.webp",
      alt: "New Year Riches",
      name: "New Year Riches",
    },
    NinjaFruits: {
      href: "/casino/aggapplayngo-ninja-fruits",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/NinjaFruits.webp",
      alt: "Ninja Fruits",
      name: "Ninja Fruits",
    },
    OctopusTreasure: {
      href: "/casino/aggapplayngo-octopus-treasure",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/OctopusTreasure.webp",
      alt: "Octopus Treasure",
      name: "Octopus Treasure",
    },
    OdinProtectorOfRealms: {
      href: "/casino/aggapplayngo-odin-protector-of-realms",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/OdinProtectorOfRealms.webp",
      alt: "Odin: Protector of Realms",
      name: "Odin: Protector of Realms",
    },
    PackAndCash: {
      href: "/casino/aggapplayngo-pack-and-cash",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PackAndCash.webp",
      alt: "Pack & Cash",
      name: "Pack & Cash",
    },
    PandorasBoxOfEvil: {
      href: "/casino/aggapplayngo-pandoras-box-of-evil",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PandorasBoxOfEvil.webp",
      alt: "Pandora's Box of Evil",
      name: "Pandora's Box of Evil",
    },
    PearlLagoon: {
      href: "/casino/aggapplayngo-pearl-lagoon",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PearlLagoon.webp",
      alt: "Pearl Lagoon",
      name: "Pearl Lagoon",
    },
    PearlsOfIndia: {
      href: "/casino/aggapplayngo-pearls-of-india",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PearlsOfIndia.webp",
      alt: "Pearls of India",
      name: "Pearls of India",
    },
    PerfectGems: {
      href: "/casino/aggapplayngo-perfect-gems",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PerfectGems.webp",
      alt: "Perfect Gems",
      name: "Perfect Gems",
    },
    PhoenixReborn: {
      href: "/casino/aggapplayngo-phoenix-reborn",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PhoenixReborn.webp",
      alt: "Phoenix Reborn",
      name: "Phoenix Reborn",
    },
    PhotoSafari: {
      href: "/casino/aggapplayngo-photo-safari",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PhotoSafari.webp",
      alt: "Photo Safari",
      name: "Photo Safari",
    },
    PiggyBankFarm: {
      href: "/casino/aggapplayngo-piggy-bank-farm",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PiggyBankFarm.webp",
      alt: "Piggy Bank Farm",
      name: "Piggy Bank Farm",
    },
    PilgrimOfDead: {
      href: "/casino/aggapplayngo-pilgrim-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PilgrimOfDead.webp",
      alt: "Pilgrim of Dead",
      name: "Pilgrim of Dead",
    },
    Pimped: {
      href: "/casino/aggapplayngo-pimped",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Pimped.webp",
      alt: "Pimped",
      name: "Pimped",
    },
    PlanetFortune: {
      href: "/casino/aggapplayngo-planet-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PlanetFortune.webp",
      alt: "Planet Fortune",
      name: "Planet Fortune",
    },
    PrismOfGems: {
      href: "/casino/aggapplayngo-prism-of-gems",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PrismOfGems.webp",
      alt: "Prism of Gems",
      name: "Prism of Gems",
    },
    PrissyPrincess: {
      href: "/casino/aggapplayngo-prissy-princess",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PrissyPrincess.webp",
      alt: "Prissy Princess",
      name: "Prissy Princess",
    },
    ProsperityPalace: {
      href: "/casino/aggapplayngo-prosperity-palace",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ProsperityPalace.webp",
      alt: "Prosperity Palace",
      name: "Prosperity Palace",
    },
    PueblaParade: {
      href: "/casino/aggapplayngo-puebla-parade",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PueblaParade.webp",
      alt: "Puebla Parade",
      name: "Puebla Parade",
    },
    QueensDayTilt: {
      href: "/casino/aggapplayngo-queens-day-tilt",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/QueensDayTilt.webp",
      alt: "Queens Day Tilt",
      name: "Queens Day Tilt",
    },
    RabbitHoleRiches: {
      href: "/casino/aggapplayngo-rabbit-hole-riches",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RabbitHoleRiches.webp",
      alt: "Rabbit Hole Riches",
      name: "Rabbit Hole Riches",
    },
    RageToRiches: {
      href: "/casino/aggapplayngo-rage-to-riches",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RageToRiches.webp",
      alt: "Rage to Riches",
      name: "Rage to Riches",
    },
    RagingRex: {
      href: "/casino/aggapplayngo-raging-rex",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RagingRex.webp",
      alt: "Raging Rex",
      name: "Raging Rex",
    },
    RagingRex2: {
      href: "/casino/aggapplayngo-raging-rex-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RagingRex2.webp",
      alt: "Raging Rex 2",
      name: "Raging Rex 2",
    },
    RainforestMagic: {
      href: "/casino/aggapplayngo-rainforest-magic",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RainforestMagic.webp",
      alt: "Rainforest Magic",
      name: "Rainforest Magic",
    },
    Rally4Riches: {
      href: "/casino/aggapplayngo-rally-4-riches",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Rally4Riches.webp",
      alt: "Rally 4 Riches",
      name: "Rally 4 Riches",
    },
    Reactoonz: {
      href: "/casino/aggapplayngo-reactoonz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Reactoonz.webp",
      alt: "Reactoonz",
      name: "Reactoonz",
    },
    Reactoonz2: {
      href: "/casino/aggapplayngo-reactoonz-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Reactoonz2.webp",
      alt: "Reactoonz 2",
      name: "Reactoonz 2",
    },
    RichWildeAndTheWanderingCity: {
      href: "/casino/aggapplayngo-rich-wilde-and-the-wandering-city",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichWildeAndTheWanderingCity.webp",
      alt: "Rich Wilde And The Wandering City",
      name: "Rich Wilde And The Wandering City",
    },
    RichWildeAndTheShieldOfAthena: {
      href: "/casino/aggapplayngo-rich-wilde-and-the-shield-of-athena",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichWildeAndTheShieldOfAthena.webp",
      alt: "Rich Wilde and the Shield of Athena",
      name: "Rich Wilde and the Shield of Athena",
    },
    RichesOfRA: {
      href: "/casino/aggapplayngo-riches-of-ra",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichesOfRA.webp",
      alt: "Riches of RA",
      name: "Riches of RA",
    },
    RichesOfRobin: {
      href: "/casino/aggapplayngo-riches-of-robin",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichesOfRobin.webp",
      alt: "Riches of Robin",
      name: "Riches of Robin",
    },
    RiddleReelsACaseOfRiches: {
      href: "/casino/aggapplayngo-riddle-reels-a-case-of-riches",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiddleReelsACaseOfRiches.webp",
      alt: "Riddle Reels a case of riches",
      name: "Riddle Reels a case of riches",
    },
    RingOfOdin: {
      href: "/casino/aggapplayngo-ring-of-odin",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RingOfOdin.webp",
      alt: "Ring of Odin",
      name: "Ring of Odin",
    },
    RiseOfAthena: {
      href: "/casino/aggapplayngo-rise-of-athena",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfAthena.webp",
      alt: "Rise of Athena",
      name: "Rise of Athena",
    },
    RiseOfDead: {
      href: "/casino/aggapplayngo-rise-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfDead.webp",
      alt: "Rise of Dead",
      name: "Rise of Dead",
    },
    RiseOfGodsReckoning: {
      href: "/casino/aggapplayngo-rise-of-gods-reckoning",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfGodsReckoning.webp",
      alt: "Rise of Gods Reckoning",
      name: "Rise of Gods Reckoning",
    },
    RiseOfMerlin: {
      href: "/casino/aggapplayngo-rise-of-merlin",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfMerlin.webp",
      alt: "Rise of Merlin",
      name: "Rise of Merlin",
    },
    RiseOfOlympus: {
      href: "/casino/aggapplayngo-rise-of-olympus",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfOlympus.webp",
      alt: "Rise of Olympus",
      name: "Rise of Olympus",
    },
    RiseOfOlympus100: {
      href: "/casino/aggapplayngo-rise-of-olympus-100",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfOlympus100.webp",
      alt: "Rise of Olympus 100",
      name: "Rise of Olympus 100",
    },
    RoccoGallo: {
      href: "/casino/aggapplayngo-rocco-gallo",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RoccoGallo.webp",
      alt: "Rocco Gallo",
      name: "Rocco Gallo",
    },
    RoninsHonour: {
      href: "/casino/aggapplayngo-ronins-honour",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RoninsHonour.webp",
      alt: "Ronin's Honour",
      name: "Ronin's Honour",
    },
    Rotiki: {
      href: "/casino/aggapplayngo-rotiki",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Rotiki.webp",
      alt: "Rotiki",
      name: "Rotiki",
    },
    RoyalMasquerade: {
      href: "/casino/aggapplayngo-royal-masquerade",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RoyalMasquerade.webp",
      alt: "Royal Masquerade",
      name: "Royal Masquerade",
    },
    Sabaton: {
      href: "/casino/aggapplayngo-sabaton",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Sabaton.webp",
      alt: "Sabaton",
      name: "Sabaton",
    },
    SafariOfWealth: {
      href: "/casino/aggapplayngo-safari-of-wealth",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SafariOfWealth.webp",
      alt: "Safari Of Wealth",
      name: "Safari Of Wealth",
    },
    SailsOfGold: {
      href: "/casino/aggapplayngo-sails-of-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SailsOfGold.webp",
      alt: "Sails of Gold",
      name: "Sails of Gold",
    },
    SambaCarnival: {
      href: "/casino/aggapplayngo-samba-carnival",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SambaCarnival.webp",
      alt: "Samba Carnival",
      name: "Samba Carnival",
    },
    ScrollOfDead: {
      href: "/casino/aggapplayngo-scroll-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ScrollOfDead.webp",
      alt: "Scroll of Dead",
      name: "Scroll of Dead",
    },
    SeaHunter: {
      href: "/casino/aggapplayngo-sea-hunter",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SeaHunter.webp",
      alt: "Sea Hunter",
      name: "Sea Hunter",
    },
    SecretOfDead: {
      href: "/casino/aggapplayngo-secret-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SecretOfDead.webp",
      alt: "Secret Of Dead",
      name: "Secret Of Dead",
    },
    ShamrockMiner: {
      href: "/casino/aggapplayngo-shamrock-miner",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ShamrockMiner.webp",
      alt: "Shamrock Miner",
      name: "Shamrock Miner",
    },
    SistersOfTheSun: {
      href: "/casino/aggapplayngo-sisters-of-the-sun",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SistersOfTheSun.webp",
      alt: "Sisters of The Sun",
      name: "Sisters of The Sun",
    },
    SizzlingSpins: {
      href: "/casino/aggapplayngo-sizzling-spins",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SizzlingSpins.webp",
      alt: "Sizzling Spins",
      name: "Sizzling Spins",
    },
    Slashimi: {
      href: "/casino/aggapplayngo-slashimi",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Slashimi.webp",
      alt: "Slashimi",
      name: "Slashimi",
    },
    SpaceRace: {
      href: "/casino/aggapplayngo-space-race",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SpaceRace.webp",
      alt: "Space Race",
      name: "Space Race",
    },
    SparkyAndShortz: {
      href: "/casino/aggapplayngo-sparky-and-shortz",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SparkyAndShortz.webp",
      alt: "Sparky & Shortz",
      name: "Sparky & Shortz",
    },
    SpinParty: {
      href: "/casino/aggapplayngo-spin-party",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SpinParty.webp",
      alt: "Spin Party",
      name: "Spin Party",
    },
    StarJoker: {
      href: "/casino/aggapplayngo-star-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/StarJoker.webp",
      alt: "Star Joker",
      name: "Star Joker",
    },
    StickyJoker: {
      href: "/casino/aggapplayngo-sticky-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/StickyJoker.webp",
      alt: "Sticky Joker",
      name: "Sticky Joker",
    },
    StreetMagic: {
      href: "/casino/aggapplayngo-street-magic",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/StreetMagic.webp",
      alt: "Street Magic",
      name: "Street Magic",
    },
    SuperFlip: {
      href: "/casino/aggapplayngo-super-flip",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SuperFlip.webp",
      alt: "Super Flip",
      name: "Super Flip",
    },
    Sweet27: {
      href: "/casino/aggapplayngo-sweet-27",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Sweet27.webp",
      alt: "Sweet 27",
      name: "Sweet 27",
    },
    SweetAlchemy: {
      href: "/casino/aggapplayngo-sweet-alchemy",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SweetAlchemy.webp",
      alt: "Sweet Alchemy",
      name: "Sweet Alchemy",
    },
    TaleOfKyubiko: {
      href: "/casino/aggapplayngo-tale-of-kyubiko",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TaleOfKyubiko.webp",
      alt: "Tale Of Kyubiko",
      name: "Tale Of Kyubiko",
    },
    TalesOfAsgardFreyasWedding: {
      href: "/casino/aggapplayngo-tales-of-asgard-freyas-wedding",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TalesOfAsgardFreyasWedding.webp",
      alt: "Tales of Asgard Freya's Wedding",
      name: "Tales of Asgard Freya's Wedding",
    },
    TalesOfAsgardLokisFortune: {
      href: "/casino/aggapplayngo-tales-of-asgard-lokis-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TalesOfAsgardLokisFortune.webp",
      alt: "Tales Of Asgard Loki's Fortune",
      name: "Tales Of Asgard Loki's Fortune",
    },
    Testament: {
      href: "/casino/aggapplayngo-testament",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Testament.webp",
      alt: "Testament",
      name: "Testament",
    },
    ThatsRich: {
      href: "/casino/aggapplayngo-thats-rich",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ThatsRich.webp",
      alt: "That's Rich",
      name: "That's Rich",
    },
    TheFacesOfFreya: {
      href: "/casino/aggapplayngo-the-faces-of-freya",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheFacesOfFreya.webp",
      alt: "The Faces of Freya",
      name: "The Faces of Freya",
    },
    TheGreenKnight: {
      href: "/casino/aggapplayngo-the-green-knight",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheGreenKnight.webp",
      alt: "The Green Knight",
      name: "The Green Knight",
    },
    TheLastSundown: {
      href: "/casino/aggapplayngo-the-last-sundown",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheLastSundown.webp",
      alt: "The Last Sundown",
      name: "The Last Sundown",
    },
    ThePayingPianoClub: {
      href: "/casino/aggapplayngo-the-paying-piano-club",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ThePayingPianoClub.webp",
      alt: "The Paying Piano Club",
      name: "The Paying Piano Club",
    },
    ShimmeringWoods: {
      href: "/casino/aggapplayngo-shimmering-woods",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheShimmeringWoods.webp",
      alt: "Shimmering Woods",
      name: "Shimmering Woods",
    },
    TheSwordAndTheGrail: {
      href: "/casino/aggapplayngo-the-sword-and-the-grail",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheSwordAndTheGrail.webp",
      alt: "The Sword and The Grail",
      name: "The Sword and The Grail",
    },
    TheWildClass: {
      href: "/casino/aggapplayngo-the-wild-class",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheWildClass.webp",
      alt: "The Wild Class",
      name: "The Wild Class",
    },
    ThunderScreech: {
      href: "/casino/aggapplayngo-thunder-screech",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ThunderScreech.webp",
      alt: "Thunder Screech",
      name: "Thunder Screech",
    },
    // TomeOfMadness: {
    //   href: "/casino/qtechplayngo-tome-of-madness",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/TomeOfMadness.webp",
    //   alt: "Tome of Madness",
    //   name: "Tome of Madness",
    // },
    TrollHunters: {
      href: "/casino/aggapplayngo-troll-hunters",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TrollHunters.webp",
      alt: "Troll Hunters",
      name: "Troll Hunters",
    },
    TrollHunters2: {
      href: "/casino/aggapplayngo-troll-hunters-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TrollHunters2.webp",
      alt: "Troll Hunters 2",
      name: "Troll Hunters 2",
    },
    USAFlip: {
      href: "/casino/aggapplayngo-usa-flip",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/USAFlip.webp",
      alt: "USA Flip",
      name: "USA Flip",
    },
    VikingRunecraft: {
      href: "/casino/aggapplayngo-viking-runecraft",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/VikingRunecraft.webp",
      alt: "Viking Runecraft",
      name: "Viking Runecraft",
    },
    WildBandolier: {
      href: "/casino/aggapplayngo-wild-bandolier",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildBandolier.webp",
      alt: "Wild Bandolier",
      name: "Wild Bandolier",
    },
    WildBlood: {
      href: "/casino/aggapplayngo-wild-blood",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildBlood.webp",
      alt: "Wild Blood",
      name: "Wild Blood",
    },
    WildBlood2: {
      href: "/casino/aggapplayngo-wild-blood-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildBlood2.webp",
      alt: "Wild Blood 2",
      name: "Wild Blood 2",
    },
    WildFalls: {
      href: "/casino/aggapplayngo-wild-falls",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildFalls.webp",
      alt: "Wild Falls",
      name: "Wild Falls",
    },
    WildFalls2: {
      href: "/casino/aggapplayngo-wild-falls-2",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildFalls2.webp",
      alt: "Wild Falls 2",
      name: "Wild Falls 2",
    },
    WildFrames: {
      href: "/casino/aggapplayngo-wild-frames",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildFrames.webp",
      alt: "Wild Frames",
      name: "Wild Frames",
    },
    WildMelon: {
      href: "/casino/aggapplayngo-wild-melon",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildMelon.webp",
      alt: "Wild Melon",
      name: "Wild Melon",
    },
    WildNorth: {
      href: "/casino/aggapplayngo-wild-north",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildNorth.webp",
      alt: "Wild North",
      name: "Wild North",
    },
    WildRails: {
      href: "/casino/aggapplayngo-wild-rails",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildRails.webp",
      alt: "Wild Rails",
      name: "Wild Rails",
    },
    WildTrigger: {
      href: "/casino/aggapplayngo-wild-trigger",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildTrigger.webp",
      alt: "Wild Trigger",
      name: "Wild Trigger",
    },
    WildhoundDerby: {
      href: "/casino/aggapplayngo-wildhound-derby",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildhoundDerby.webp",
      alt: "Wildhound Derby",
      name: "Wildhound Derby",
    },
    WinABeest: {
      href: "/casino/aggapplayngo-win-a-beest",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WinABeest.webp",
      alt: "Win-A-Beest",
      name: "Win-A-Beest",
    },
    WizardOfGems: {
      href: "/casino/aggapplayngo-wizard-of-gems",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WizardOfGems.webp",
      alt: "Wizard of Gems",
      name: "Wizard of Gems",
    },
    XmasJoker: {
      href: "/casino/aggapplayngo-xmas-joker-3-reel",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/XmasJoker.webp",
      alt: "Xmas Joker",
      name: "Xmas Joker",
    },
    XmasMagic: {
      href: "/casino/aggapplayngo-xmas-magic",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/XmasMagic.webp",
      alt: "Xmas Magic",
      name: "Xmas Magic",
    },
    Hand3CasinoHoldem: {
      href: "/casino/aggapplayngo-3-hand-casino-holdem",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/3HandCasinoHoldem.webp",
      alt: "3-Hand Casino Hold'em",
      name: "3-Hand Casino Hold'em",
    },
    BlackJackMH: {
      href: "/casino/aggapplayngo-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BlackJackMH.webp",
      alt: "BlackJack MH",
      name: "BlackJack MH",
    },
    DeucesWild: {
      href: "/casino/aggapbetsoft-deuces-wild",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DeucesWild.webp",
      alt: "Deuces Wild",
      name: "Deuces Wild",
    },
    DoubleExposureBlackJackMH: {
      href: "/casino/aggapplayngo-double-exposure-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DoubleExposureBlackJackMH.webp",
      alt: "Double Exposure BlackJack MH",
      name: "Double Exposure BlackJack MH",
    },
    EuropeanBlackJackMH: {
      href: "/casino/aggapplayngo-european-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EuropeanBlackJackMH.webp",
      alt: "European BlackJack MH",
      name: "European BlackJack MH",
    },
    EuropeanRoulette: {
      href: "/casino/aggapplayngo-european-roulette",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EuropeanRoulettePro.webp",
      alt: "European Roulette",
      name: "European Roulette",
    },
    JacksOrBetterMH: {
      href: "/casino/aggapplayngo-jacks-or-better-mh",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JacksOrBetterMH.webp",
      alt: "Jacks or Better MH",
      name: "Jacks or Better MH",
    },
    JokerPokerMH: {
      href: "/casino/aggapplayngo-joker-poker-mh",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JokerPokerMH.webp",
      alt: "Joker Poker MH",
      name: "Joker Poker MH",
    },
    // Keno: {
    //   href: "/casino/qtechplayngo-keno",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/Keno.webp",
    //   alt: "Keno",
    //   name: "Keno",
    // },
    // MiniBaccarat: {
    //   href: "/casino/qtechplayngo-mini-baccarat",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/play-n-go/MiniBaccarat.webp",
    //   alt: "Mini Baccarat",
    //   name: "Mini Baccarat",
    // },
    SingleDeckBlackJackMH: {
      href: "/casino/aggapplayngo-single-deck-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SingleDeckBlackJackMH.webp",
      alt: "Single Deck BlackJack MH",
      name: "Single Deck BlackJack MH",
    },
    MoonPrincessPowerOfLove: {
      href: "/casino/aggapplayngo-moon-princess-power-of-love",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MoonPrincessPowerOfLove.webp",
      alt: "Moon Princess - Power of Love",
      name: "Moon Princess - Power of Love",
    },
    LoveIsInTheFair: {
      href: "/casino/aggapplayngo-love-is-in-the-fair",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LoveIsInTheFair.webp",
      alt: "Love is in the Fair",
      name: "Love is in the Fair",
    },
    CatWildeAndTheIncanQuest: {
      href: "/casino/aggapplayngo-cat-wilde-and-the-incan-quest",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CatWildeAndTheIncanQuest.webp",
      alt: "Cat Wilde and the Incan Quest",
      name: "Cat Wilde and the Incan Quest",
    },
    BoatBonanzaDownUnder: {
      href: "/casino/aggapplayngo-boat-bonanza-down-under",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BoatBonanzaDownUnder.webp",
      alt: "Boat Bonanza Down Under",
      name: "Boat Bonanza Down Under",
    },
    HugoCarts: {
      href: "/casino/aggapplayngo-hugo-carts",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HugoCarts.webp",
      alt: "Hugo Carts",
      name: "Hugo Carts",
    },
    AliceCooperAndTheTomeOfMadness: {
      href: "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/slots/new/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
      alt: "Alice Cooper And The Tome Of Madness",
      name: "Alice Cooper And The Tome Of Madness",
    },
    Snakebite: {
      href: "/casino/qt-snakebite",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Snakebite.webp",
      alt: "Snakebite",
      name: "Snakebite",
    },
    kissReelsOfRock: {
      href: "/casino/aggapplayngo-kiss-reels-of-rock",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/kissReelsOfRock.webp",
      alt: "kiss Reels Of Rock",
      name: "kiss Reels Of Rock",
    },
    DefLeppardHysteria: {
      href: "/casino/aggapplayngo-def-leppard-hysteria",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DefleppardHysteria.webp",
      alt: "Def Leppard Hysteria",
      name: "Def Leppard Hysteria",
    },
    DioKillingTheDragon: {
      href: "/casino/aggapplayngo-dio-killing-the-dragon",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DioKillingTheDragon.webp",
      alt: "DIO Killing the Dragon",
      name: "DIO Killing the Dragon",
    },
    DivineDivas: {
      href: "/casino/aggapplayngo-divine-divas",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DivineDivas.webp",
      alt: "Divine Divas",
      name: "Divine Divas",
    },
    Gemix100: {
      href: "/casino/aggapplayngo-gemix-100",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Gemix100.webp",
      alt: "Gemix 100",
      name: "Gemix 100",
    },
    KingdomBelow: {
      href: "/casino/aggapplayngo-kingdom-below",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/KingdomBelow.webp",
      alt: "Kingdom Below",
      name: "Kingdom Below",
    },
    MirrorJoker: {
      href: "/casino/aggapplayngo-mirror-joker",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MirrorJoker.webp",
      alt: "Mirror Joker",
      name: "Mirror Joker",
    },
    BuildinBucks: {
      href: "/casino/aggapplayngo-buildin-bucks",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BuildinBucks.webp",
      alt: "Buildin' Bucks",
      name: "Buildin' Bucks",
    },
    AnkhOfAnubisAwakening: {
      href: "/casino/aggapplayngo-ankh-of-anubis-awakening",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/AnkhOfAnubisAwakening.webp",
      alt: "Ankh of Anubis Awakening",
      name: "Ankh of Anubis Awakening",
    },
    ScourgeOfRome: {
      href: "/casino/aggapplayngo-scourge-of-rome",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ScourgeOfRome.webp",
      alt: "Scourge of Rome",
      name: "Scourge of Rome",
    },
    MafiaGold: {
      href: "/casino/aggapplayngo-mafia-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MafiaGold.webp",
      alt: "Mafia Gold",
      name: "Mafia Gold",
    },
    RiseOfOlympusOrigin: {
      href: "/casino/aggapplayngo-rise-of-olympus-origin",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RiseOfOlympusOrigins.webp",
      alt: "Rise of Olympus Origin",
      name: "Rise of Olympus Origin",
    },
    KingsMaskEclipseOfGods: {
      href: "/casino/aggapplayngo-kings-mask-eclipse-of-gods",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/KingsMaskEclipseOfGods.webp",
      alt: "King’s Mask Eclipse of Gods",
      name: "King’s Mask Eclipse of Gods",
    },
    WhisperingWinds: {
      href: "/casino/aggapplayngo-whispering-winds",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WhisperingWinds.webp",
      alt: "Whispering Winds",
      name: "Whispering Winds",
    },
    DansbandPaTurne: {
      href: "/casino/aggapplayngo-dansband-pa-turne",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/DansbandPaTurne.webp",
      alt: "Dansband Pa Turne",
      name: "Dansband Pa Turne",
    },
    OasisOfDead: {
      href: "/casino/aggapplayngo-oasis-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/OasisOfDead.webp",
      alt: "Oasis of Dead",
      name: "Oasis of Dead",
    },
    JourneyToParis: {
      href: "/casino/aggapplayngo-journey-to-paris",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JourneyToParis.webp",
      alt: "Journey to Paris",
      name: "Journey to Paris",
    },
    TempleOfTollan: {
      href: "/casino/aggapplayngo-temple-of-tollan",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TempleOfTollan.webp",
      alt: "Temple of Tollan",
      name: "Temple of Tollan",
    },
    MerlinRealmOfCharm: {
      href: "/casino/aggapplayngo-merlin-realm-of-charm",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MerlinRealmOfCharm.webp",
      alt: "Merlin Realm of Charm",
      name: "Merlin Realm of Charm",
    },
    GoldOfFortuneGod: {
      href: "/casino/aggapplayngo-gold-of-fortune-god",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/GoldOfFortuneGod.webp",
      alt: "Gold of Fortune God",
      name: "Gold of Fortune God",
    },
    RichWildeAndTheTomeOfInsanity: {
      href: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-insanity",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichWildeAndTheTomeOfInsanity.webp",
      alt: "Rich Wilde and the Tome of Insanity",
      name: "Rich Wilde and the Tome of Insanity",
    },
    ColtLightningFirestorm: {
      href: "/casino/aggapplayngo-colt-lightning-firestorm",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ColtLightningFirestorm.webp",
      alt: "Colt Lightning Firestorm",
      name: "Colt Lightning Firestorm",
    },
    SparkOfGenius: {
      href: "/casino/aggapplayngo-spark-of-genius",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SparkOfGenius.webp",
      alt: "Spark of Genius",
      name: "Spark of Genius",
    },
    WildSurvivor: {
      href: "/casino/aggapplayngo-wild-survivor",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildSurvivor.webp",
      alt: "Wild Survivor",
      name: "Wild Survivor",
    },
    Fulong88: {
      href: "/casino/aggapplayngo-fulong-88",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/Fulong88.webp",
      alt: "Fulong 88",
      name: "Fulong 88",
    },
    TheSwordAndTheGrailExcalibur: {
      href: "/casino/aggapplayngo-the-sword-and-the-grail-excalibur",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TheSwordAndTheGrailExcalibur.webp",
      alt: "The Sword and the Grail Excalibur",
      name: "The Sword and the Grail Excalibur",
    },
    BoatBonanzaDownUnder: {
      href: "/casino/aggapplayngo-boat-bonanza-down-under",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BoatBonanzaDownUnder.webp",
      alt: "Boat Bonanza Down Under",
      name: "Boat Bonanza Down Under",
    },
    TombOfGold: {
      href: "/casino/aggapplayngo-tomb-of-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TombOfGold.webp",
      alt: "Tomb of Gold",
      name: "Tomb of Gold",
    },
    MysteryGenieFortunesOfTheLamp: {
      href: "/casino/aggapplayngo-mystery-genie-fortunes-of-the-lamp",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MysteryGenieFortunesOfTheLamp.webp",
      alt: "Mystery Genie Fortunes of the Lamp",
      name: "Mystery Genie Fortunes of the Lamp",
    },
    EasterEggspedition: {
      href: "/casino/aggapplayngo-easter-eggspedition",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/EasterEggspedition.webp",
      alt: "Easter Eggspedition",
      name: "Easter Eggspedition",
    },
    PiranhaPays: {
      href: "/casino/aggapplayngo-piranha-pays",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PiranhaPays.webp",
      alt: "Piranha Pays",
      name: "Piranha Pays",
    },
    ChambersOfAncients: {
      href: "/casino/aggapplayngo-chambers-of-ancients",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/ChambersOfAncients.webp",
      alt: "Chambers of Ancients",
      name: "Chambers of Ancients",
    },
    BanquetOfDead: {
      href: "/casino/aggapplayngo-banquet-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BanquetOfDead.webp",
      alt: "Banquet of Dead",
      name: "Banquet of Dead",
    },
    LegionGoldUnleashed: {
      href: "/casino/aggapplayngo-legion-gold-unleashed",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegionGoldUnleashed.webp",
      alt: "Legion Gold Unleashed",
      name: "Legion Gold Unleashed",
    },
    UndefeatedXerxes: {
      href: "/casino/aggapplayngo-undefeated-xerxes",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/UndefeatedXerxes.webp",
      alt: "Undefeated Xerxes",
      name: "Undefeated Xerxes",
    },
    LadyOfFortuneRemastered: {
      href: "/casino/aggapplayngo-lady-of-fortune-remastered",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LadyOfFortuneRemastered.webp",
      alt: "Lady of Fortune Remastered",
      name: "Lady of Fortune Remastered",
    },
    SteppingDiamonds: {
      href: "/casino/aggapplayngo-stepping-diamonds",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/SteppingDiamonds.webp",
      alt: "Stepping Diamonds",
      name: "Stepping Diamonds",
    },
    BaronLordOfSaturday: {
      href: "/casino/aggapplayngo-baron-lord-of-saturday",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BaronLordOfSaturday.webp",
      alt: "Baron Lord of Saturday",
      name: "Baron Lord of Saturday",
    },
    BeastsOfFireMaximum: {
      href: "/casino/aggapplayngo-beasts-of-fire-maximum",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BeastsOfFireMaximum.webp",
      alt: "Beasts of Fire Maximum",
      name: "Beasts of Fire Maximum",
    },
    LegionGoldAndTheSphinxOfDead: {
      href: "/casino/aggapplayngo-legion-gold-and-the-sphinx-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegionGoldAndTheSphinxOfDead.webp",
      alt: "Legion Gold and the Sphinx of Dead",
      name: "Legion Gold and the Sphinx of Dead",
    },
    PiggyBlitzDiscoGold: {
      href: "/casino/aggapplayngo-piggy-blitz-disco-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PiggyBlitzDiscoGold.webp",
      alt: "Piggy Blitz Disco Gold",
      name: "Piggy Blitz Disco Gold",
    },
    RichWildeAndThePearlsOfVishnu: {
      href: "/casino/aggapplayngo-rich-wilde-and-the-pearls-of-vishnu",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/RichWildeAndThePearlsOfVishnu.webp",
      alt: "Rich Wilde and the Pearls of Vishnu",
      name: "Rich Wilde and the Pearls of Vishnu",
    },
    BoatBonanzaChristmas: {
      href: "/casino/aggapplayngo-boat-bonanza-christmas",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/BoatBonanzaChristmas.webp",
      alt: "Boat Bonanza Christmas",
      name: "Boat Bonanza Christmas",
    },
    WildestGambit: {
      href: "/casino/aggapplayngo-wildest-gambit",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/WildestGambit.webp",
      alt: "Wildest Gambit",
      name: "Wildest Gambit",
    },
    LionSagaOdyssey: {
      href: "/casino/aggapplayngo-lion-saga-odyssey",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LionSagaOdyssey.webp",
      alt: "Lion Saga Odyssey",
      name: "Lion Saga Odyssey",
    },
    HotDogHeist: {
      href: "/casino/aggapplayngo-hot-dog-heist",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/HotDogHeist.webp",
      alt: "Hot Dog Heist",
      name: "Hot Dog Heist",
    },
    JollyRogerWildKraken: {
      href: "/casino/aggapplayngo-jolly-roger-wild-kraken",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/JollyRogerWildKraken.webp",
      alt: "Jolly Roger Wild Kraken",
      name: "Jolly Roger Wild Kraken",
    },
    MidnightGold: {
      href: "/casino/aggapplayngo-midnight-gold",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MidnightGold.webp",
      alt: "Midnight Gold",
      name: "Midnight Gold",
    },
    TreasuresOfKongar: {
      href: "/casino/aggapplayngo-treasures-of-kongar",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TreasuresOfKongar.webp",
      alt: "Treasures of Kongar",
      name: "Treasures of Kongar",
    },
    TowerQuestLegacy: {
      href: "/casino/aggapplayngo-tower-quest-legacy",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/TowerQuestLegacy.webp",
      alt: "Tower Quest Legacy",
      name: "Tower Quest Legacy",
    },
    LegacyOfGemsBlitzways: {
      href: "/casino/aggapplayngo-legacy-of-gems-blitzways",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegacyOfGemsBlitzways.webp",
      alt: "Legacy of Gems Blitzways",
      name: "Legacy of Gems Blitzways",
    },
    PotionOfMadness: {
      href: "/casino/aggapplayngo-potion-of-madness",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/PotionOfMadness.webp",
      alt: "Potion of Madness",
      name: "Potion of Madness",
    },
    InvadingVegasRevengeOnMars: {
      href: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/InvadingVegasRevengeOnMars.webp",
      alt: "Invading Vegas Revenge on Mars",
      name: "Invading Vegas Revenge on Mars",
    },
    CrystalHall: {
      href: "/casino/aggapplayngo-crystal-hall",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/CrystalHall.webp",
      alt: "Crystal Hall",
      name: "Crystal Hall",
    },
    MythOfDead: {
      href: "/casino/aggapplayngo-myth-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/MythOfDead.webp",
      alt: "Myth of Dead",
      name: "Myth of Dead",
    },
    LegionGoldVictory: {
      href: "/casino/aggapplayngo-legion-gold-victory",
      code: "",
      casino: "Play'n GO",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/play-n-go/LegionGoldVictory.webp",
      alt: "Legion Gold Victory",
      name: "Legion Gold Victory",
    },
  },

  relaxGaming: {
    BillAndCoin: {
      href: "/casino/qt-bill-and-coin",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/BillAndCoin.webp",
      alt: "bill and coin",
      name: "Bill & Coin",
    },
    LureOfFortune: {
      href: "/casino/qt-lure-of-fortune",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/LureOfFortune.webp",
      alt: "lure of fortune",
      name: "Lure Of Fortune",
    },
    TitanStrike: {
      href: "/casino/qt-titan-strike",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TitanStrike.webp",
      alt: "titan strike",
      name: "Titan Strike",
    },
    MoneyTrain4: {
      href: "/casino/qt-money-train-4",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyTrain4.webp",
      alt: "money train 4",
      name: "Money Train 4",
    },
    JokerSplit: {
      href: "/casino/qt-joker-split",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/JokerSplit.webp",
      alt: "joker split",
      name: "Joker Split",
    },
    ToriiTumble: {
      href: "/casino/qt-torii-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/ToriiTumble.webp",
      alt: "torii tumble",
      name: "Torii Tumble",
    },
    SlothTumble: {
      href: "/casino/qt-sloth-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SlothTumble.webp",
      alt: "sloth tumble",
      name: "Sloth Tumble",
    },
    SharkWash: {
      href: "/casino/qt-shark-wash",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SharkWash.webp",
      alt: "shark wash",
      name: "Shark Wash",
    },
    BananaTown: {
      href: "/casino/qt-banana-town",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/BananaTown.webp",
      alt: "banana town",
      name: "Banana Town",
    },
    BeastMode: {
      href: "/casino/qt-beast-mode",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/BeastMode.webp",
      alt: "beast mode",
      name: "Beast Mode",
    },
    BlenderBlitz: {
      href: "/casino/qt-blender-blitz",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/BlenderBlitz.webp",
      alt: "blender blitz",
      name: "Blender Blitz",
    },
    BookOf99: {
      href: "/casino/qt-book-of-99",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/Bookof99.webp",
      alt: "book of 99",
      name: "Book of 99",
    },
    BookOfPower: {
      href: "/casino/qt-book-of-power",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/BookOfPower.webp",
      alt: "book of power",
      name: "Book Of Power",
    },
    CavemanBob: {
      href: "/casino/qt-caveman-bob",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/CavemanBob.webp",
      alt: "caveman bob",
      name: "Caveman Bob",
    },
    ChipSpin: {
      href: "/casino/qt-chip-spin",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/ChipSpin.webp",
      alt: "chip spin",
      name: "Chip Spin",
    },
    ClusterTumble: {
      href: "/casino/qt-cluster-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/ClusterTumble.webp",
      alt: "cluster tumble",
      name: "Cluster Tumble",
    },
    DeadMansTrail: {
      href: "/casino/qt-dead-mans-trail",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/DeadMansTrail.webp",
      alt: "dead mans trail",
      name: "Dead Man's Trail",
    },
    DeadRidersTrail: {
      href: "/casino/qt-dead-riders-trail",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/DeadRidersTrail.webp",
      alt: "dead riders trail",
      name: "Dead Riders Trail",
    },
    DeepDescent: {
      href: "/casino/qt-deep-descent",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/DeepDescent.webp",
      alt: "deep descent",
      name: "Deep Descent",
    },
    DragonsAwakening: {
      href: "/casino/qt-dragons-awakening",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/DragonsAwakening.webp",
      alt: "dragons awakening",
      name: "Dragons Awakening",
    },
    EmeraldsInfinityReels: {
      href: "/casino/qt-emeralds-infinity-reels",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/EmeraldsInfinityReels.webp",
      alt: "emeralds infinity reels",
      name: "Emerald's Infinity Reels",
    },
    ErikTheRed: {
      href: "/casino/qt-erik-the-red",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/EriktheRed.webp",
      alt: "erik the red",
      name: "Erik the Red",
    },
    EpicJoker: {
      href: "/casino/qt-epic-joker",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/EpicJoker.webp",
      alt: "epic joker",
      name: "Epic Joker",
    },
    FrequentFlyer: {
      href: "/casino/qt-frequent-flyer",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/FrequentFlyer.webp",
      alt: "frequent flyer",
      name: "Frequent Flyer",
    },
    HazakuraWays: {
      href: "/casino/qt-hazakura-ways",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/HazakuraWays.webp",
      alt: "hazakura ways",
      name: "Hazakura Ways",
    },
    HeliosFury: {
      href: "/casino/qt-helios-fury",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/HeliosFury.webp",
      alt: "helios fury",
      name: "Helios' Fury",
    },
    Hellcatraz: {
      href: "/casino/qt-hellcatraz",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/Hellcatraz.webp",
      alt: "hellcatraz",
      name: "Hellcatraz",
    },
    HeroesGathering: {
      href: "/casino/qt-heroes-gathering",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/HeroesGathering.webp",
      alt: "heroes gathering",
      name: "Heroes Gathering",
    },
    Hex: {
      href: "/casino/qt-hex",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/Hex.webp",
      alt: "hex",
      name: "Hex",
    },
    HorrorHotel: {
      href: "/casino/qt-horror-hotel",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/HorrorHotel.webp",
      alt: "horror hotel",
      name: "Horror Hotel",
    },
    HotRodRacers: {
      href: "/casino/qt-hot-rod-racers",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/HotRodRacers.webp",
      alt: "hot rod racers",
      name: "Hot Rod Racers",
    },
    IgniteTheNight: {
      href: "/casino/qt-ignite-the-night",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/IgniteTheNight.webp",
      alt: "ignite the night",
      name: "Ignite The Night",
    },
    IronBank: {
      href: "/casino/qt-iron-bank",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/IronBank.webp",
      alt: "iron bank",
      name: "Iron Bank",
    },
    ItsTime: {
      href: "/casino/qt-its-time",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/ItsTime.webp",
      alt: "its time",
      name: "It's Time",
    },
    JurassicParty: {
      href: "/casino/qt-jurassic-party",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/JurassicParty.webp",
      alt: "jurassic party",
      name: "Jurassic Party",
    },
    KingOfKings: {
      href: "/casino/qt-king-of-kings",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/KingofKings.webp",
      alt: "king of kings",
      name: "King of Kings",
    },
    KlusterKrystalsMegaclusters: {
      href: "/casino/qt-kluster-krystals-megaclusters",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/slots/new/relax-gaming/KlusterKrystalsMegaclusters.webp",
      alt: "kluster krystals megaclusters",
      name: "Kluster Krystals Megaclusters",
    },
    LaFiesta: {
      href: "/casino/qt-la-fiesta",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/LaFiesta.webp",
      alt: "la fiesta",
      name: "La Fiesta",
    },
    LetsGetReadyToRumble: {
      href: "/casino/qt-lets-get-ready-to-rumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/LetsgetreadytoRumble.webp",
      alt: "lets get ready to rumble",
      name: "Let's get ready to Rumble",
    },
    MarchingLegions: {
      href: "/casino/qt-marching-legions",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MarchingLegions.webp",
      alt: "marching legions",
      name: "Marching Legions",
    },
    MegaFlip: {
      href: "/casino/qt-mega-flip",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MegaFlip.webp",
      alt: "mega flip",
      name: "Mega Flip",
    },
    MegaHeist: {
      href: "/casino/qt-mega-heist",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MegaHeist.webp",
      alt: "mega heist",
      name: "Mega Heist",
    },
    MegaMasks: {
      href: "/casino/qt-mega-masks",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MegaMasks.webp",
      alt: "mega masks",
      name: "Mega Masks",
    },
    MegaMine: {
      href: "/casino/qt-mega-mine",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MegaMine.webp",
      alt: "mega mine",
      name: "Mega Mine",
    },
    MidnightMarauder: {
      href: "/casino/qt-midnight-marauder",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MidnightMarauder.webp",
      alt: "midnight marauder",
      name: "Midnight Marauder",
    },
    MoneyCart: {
      href: "/casino/qt-money-cart",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyCart.webp",
      alt: "money cart",
      name: "Money Cart",
    },
    MoneyCart2: {
      href: "/casino/qt-money-cart-2",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyCart2.webp",
      alt: "money cart 2",
      name: "Money Cart 2",
    },
    MoneyCart3: {
      href: "/casino/qt-money-cart-3",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyCart3.webp",
      alt: "money cart 3",
      name: "Money Cart 3",
    },
    MoneyTrain: {
      href: "/casino/qt-money-train",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyTrain.webp",
      alt: "money train",
      name: "Money Train",
    },
    MoneyTrain2: {
      href: "/casino/qt-money-train-2",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyTrain2.webp",
      alt: "money train 2",
      name: "Money Train 2",
    },
    MoneyTrain3: {
      href: "/casino/qt-money-train-3",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MoneyTrain3.webp",
      alt: "money train 3",
      name: "Money Train 3",
    },
    MultiplierOdyssey: {
      href: "/casino/qt-multiplier-odyssey",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MultiplierOdyssey.webp",
      alt: "multiplier odyssey",
      name: "Multiplier Odyssey",
    },
    NetGains: {
      href: "/casino/qt-net-gains",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/NetGains.webp",
      alt: "net gains",
      name: "Net Gains",
    },
    Plunderland: {
      href: "/casino/qt-plunderland",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/Plunderland.webp",
      alt: "plunderland",
      name: "Plunderland",
    },
    Powerspin: {
      href: "/casino/qt-powerspin",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/Powerspin.webp",
      alt: "powerspin",
      name: "Powerspin",
    },
    RamsesRevenge: {
      href: "/casino/qt-ramses-revenge",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/RamsesRevenge.webp",
      alt: "ramses revenge",
      name: "Ramses Revenge",
    },
    SailsOfFortune: {
      href: "/casino/qt-sails-of-fortune",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SailsOfFortune.webp",
      alt: "sails of fortune",
      name: "Sails Of Fortune",
    },
    SnakeArena: {
      href: "/casino/qt-snake-arena",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SnakeArena.webp",
      alt: "snake arena",
      name: "Snake Arena",
    },
    SantasStack: {
      href: "/casino/qt-santas-stack",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SantasStack.webp",
      alt: "santas stack",
      name: "Santa's Stack",
    },
    SpaceMiners: {
      href: "/casino/qt-space-miners",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SpaceMiners.webp",
      alt: "space miners",
      name: "Space Miners",
    },
    TemplarTumble: {
      href: "/casino/qt-templar-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TemplarTumble.webp",
      alt: "templar tumble",
      name: "Templar Tumble",
    },
    SpiritOfTheBeast: {
      href: "/casino/qt-spirit-of-the-beast",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SpiritoftheBeast.webp",
      alt: "spirit of the beast",
      name: "Spirit of the Beast",
    },
    TempleTumble: {
      href: "/casino/qt-temple-tumble-megaways",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TempleTumbleMegaways.webp",
      alt: "temple tumble",
      name: "Temple Tumble",
    },
    TheGreatPigsbyMegaways: {
      href: "/casino/qt-the-great-pigsby-megaways",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TheGreatPigsbyMegaways.webp",
      alt: "the great pigsby megaways",
      name: "The Great Pigsby Megaways",
    },
    TheGreatPigsby: {
      href: "/casino/qt-the-great-pigsby",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TheGreatPigsby.webp",
      alt: "the great pigsby",
      name: "The Great Pigsby",
    },
    TigerKingdomInfinityReels: {
      href: "/casino/qt-tiger-kingdom-infinity-reels",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TigerKingdomInfinityReels.webp",
      alt: "tiger kingdom infinity reels",
      name: "Tiger Kingdom Infinity Reels",
    },
    TNTTumble: {
      href: "/casino/qt-tnt-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TNTTumble.webp",
      alt: "tnt tumble",
      name: "TNT Tumble",
    },
    TopDawgs: {
      href: "/casino/qt-top-dawgdollar",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TopDawg.webp",
      alt: "top dawg$",
      name: "Top Dawg$",
    },
    TowerTumble: {
      href: "/casino/qt-tower-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TowerTumble.webp",
      alt: "tower tumble",
      name: "Tower Tumble",
    },
    TrollsGold: {
      href: "/casino/qt-trolls-gold",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TrollsGold.webp",
      alt: "trolls gold",
      name: "Troll's Gold",
    },
    VolatileVikings: {
      href: "/casino/qt-volatile-vikings",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/VolatileVikings.webp",
      alt: "volatile vikings",
      name: "Volatile Vikings",
    },
    WildChapo: {
      href: "/casino/qt-wild-chapo",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/WildChapo.webp",
      alt: "wild chapo",
      name: "Wild Chapo",
    },
    WildChapo2: {
      href: "/casino/qt-wild-chapo-2",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/WildChapo2.webp",
      alt: "wild chapo-2",
      name: "Wild Chapo 2",
    },
    Wildchemy: {
      href: "/casino/qt-wildchemy",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/Wildchemy.webp",
      alt: "wildchemy",
      name: "Wildchemy",
    },
    WildHike: {
      href: "/casino/qt-wild-hike",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/WildHike.webp",
      alt: "wild hike",
      name: "Wild Hike",
    },
    WildYield: {
      href: "/casino/qt-wild-yield",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/WildYield.webp",
      alt: "wild yield",
      name: "Wild Yield",
    },
    ZombieCircus: {
      href: "/casino/qt-zombie-circus",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/ZombieCircus.webp",
      alt: "zombie circus",
      name: "Zombie Circus",
    },
    BlackjackNeo: {
      href: "/casino/qt-blackjack-neo",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/BlackjackNeo.webp",
      alt: "blackjack neo",
      name: "Blackjack Neo",
    },
    RouletteNouveau: {
      href: "/casino/qt-roulette-nouveau",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/RouletteNouveau.webp",
      alt: "roulette nouveau",
      name: "Roulette Nouveau",
    },
    MONEYCART4: {
      href: "/casino/qt-money-cart-4",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/MONEYCART4.webp",
      alt: "money cart 4",
      name: "MONEY CART 4",
    },
    SWEETOPIAROYALE: {
      href: "/casino/qt-sweetopia-royale",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SWEETOPIAROYALE.webp",
      alt: "sweetopia royale",
      name: "SWEETOPIA ROYALE",
    },
    FIREWINSFACTORY: {
      href: "/casino/qt-firewins-factory",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/FIREWINSFACTORY.webp",
      alt: "firewins factory",
      name: "Firewins Factory",
    },
    HeroesHunt2MegawaysXmasVersion: {
      href: "/casino/qt-heroes-hunt-2-megaways-xmas-version",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/slots/new/relax-gaming/HeroesHunt2MegawaysXmasVersion.webp",
      alt: "heroes hunt 2 megaways - xmas version",
      name: "Heroes Hunt 2 Megaways - Xmas Version",
    },
    TheGreatPigsbyMegapays: {
      href: "/casino/qt-the-great-pigsby-megapays",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TheGreatPigsbyMegapays.webp",
      alt: "the great pigsby megapays",
      name: "The Great Pigsby Megapays",
    },
    SnakeArenaDreamDrop: {
      href: "/casino/qt-snake-arena-dream-drop",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/SnakeArenaDreamDrop.webp",
      alt: "snake arena dream drop",
      name: "Snake Arena Dream Drop",
    },
    VolatileVikings2DreamDrop: {
      href: "/casino/qt-volatile-vikings-2-dream-drop",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/VolatileVikings2DreamDrop.webp",
      alt: "volatile vikings 2 dream drop",
      name: "Volatile Vikings 2 Dream Drop",
    },
    TntTumbleDreamDrop: {
      href: "/casino/qt-tnt-tumble-dream-drop",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/TntTumbleDreamDrop.webp",
      alt: "tnt tumble dream drop",
      name: "Tnt Tumble Dream Drop",
    },
    NekoNightDreamDrop: {
      href: "/casino/qt-neko-night-dream-drop",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/NekoNightDreamDrop.webp",
      alt: "neko night dream drop",
      name: "Neko Night Dream Drop",
    },
    WildChapoDreamDrop: {
      href: "/casino/qt-wild-chapo-dream-drop",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/WildChapoDreamDrop.webp",
      alt: "wild chapo dream drop",
      name: "Wild Chapo Dream Drop",
    },
    // TheTumbles: {
    //   href: "/casino/qtechrelaxgaming-the-tumbles",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/TheTumbles.webp",
    //   alt: "the tumbles",
    //   name: "The Tumbles",
    // },
    // BoneRaiders: {
    //   href: "/casino/qtechrelaxgaming-bone-raiders",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/BoneRaiders.webp",
    //   alt: "bone raiders",
    //   name: "Bone Raiders",
    // },
    AtlantisCrush: {
      href: "/casino/qt-atlantis-crush",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/AtlantisCrush.webp",
      alt: "atlantis crush",
      name: "Atlantis Crush",
    },
    AncientTumble: {
      href: "/casino/qt-ancient-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/relax-gaming/AncientTumble.webp",
      alt: "ancient tumble",
      name: "Ancient Tumble",
    },
    // EpicDreams: {
    //   href: "/casino/qtechrelaxgaming-epic-dreams",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/EpicDreams.webp",
    //   alt: "epic dreams",
    //   name: "Epic Dreams",
    // },
    // SultanSpins: {
    //   href: "/casino/qtechrelaxgaming-sultan-spins",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/SultanSpins.webp",
    //   alt: "sultan spins",
    //   name: "Sultan Spins",
    // },
    // QuackinReels: {
    //   href: "/casino/qtechrelaxgaming-quackin-reels",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/QuackinReels.webp",
    //   alt: "quackin reels",
    //   name: "Quackin' Reels",
    // },
    // FeatherFury: {
    //   href: "/casino/qtechrelaxgaming-feather-fury",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/FeatherFury.webp",
    //   alt: "feather fury",
    //   name: "Feather Fury",
    // },
    // MoneySleigh: {
    //   href: "/casino/qtechrelaxgaming-money-sleigh",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/MoneySleigh.webp",
    //   alt: "money sleigh",
    //   name: "Money Sleigh",
    // },
    // WinterChampions: {
    //   href: "/casino/qtechrelaxgaming-winter-champions",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/WinterChampions.webp",
    //   alt: "winter champions",
    //   name: "Winter Champions",
    // },
    // Immortal5: {
    //   href: "/casino/qtechrelaxgaming-immortal-5",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/Immortal5.webp",
    //   alt: "immortal 5",
    //   name: "Immortal 5",
    // },
    // KrakensCove: {
    //   href: "/casino/qtechrelaxgaming-krakens-cove",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/KrakensCove.webp",
    //   alt: "krakens cove",
    //   name: "Kraken's Cove",
    // },
    // CamelotCash: {
    //   href: "/casino/qtechrelaxgaming-camelot-cash",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/CamelotCash.webp",
    //   alt: "camelot cash",
    //   name: "Camelot Cash",
    // },
    // GiantsAndSheep: {
    //   href: "/casino/qtechrelaxgaming-giants-and-sheep",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/GiantsAndSheep.webp",
    //   alt: "giants and sheep",
    //   name: "Giants & Sheep",
    // },
    // GlyphOfGods: {
    //   href: "/casino/qtechrelaxgaming-glyph-of-gods",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/relax-gaming/GlyphofGods.webp",
    //   alt: "glyph of gods",
    //   name: "Glyph of Gods",
    // },
  },

  habanero: {
    FruityMayan: {
      href: "/casino/qt-fruity-mayan",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FruityMayan.webp",
      alt: "Fruity Mayan",
      name: "Fruity Mayan",
    },
    SantasInn: {
      href: "/casino/qt-santas-inn",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SantasInn.webp",
      alt: "Santa's Inn",
      name: "Santa's Inn",
    },
    ZeusDeluxe: {
      href: "/casino/qt-zeus-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ZeusDeluxe.webp",
      alt: "Zeus Deluxe",
      name: "Zeus Deluxe",
    },
    FruityHalloween: {
      href: "/casino/qt-fruity-halloween",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FruityHalloween.webp",
      alt: "Fruity Halloween",
      name: "Fruity Halloween",
    },
    SlimeParty: {
      href: "/casino/qt-slime-party",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SlimeParty.webp",
      alt: "Slime Party",
      name: "Slime Party",
    },
    MeowJanken: {
      href: "/casino/qt-meow-janken",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MeowJanken.webp",
      alt: "Meow Janken",
      name: "Meow Janken",
    },
    BikiniIslandDeluxe: {
      href: "/casino/qt-bikini-island-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/BikiniIslandDeluxe.webp",
      alt: "Bikini Island Deluxe",
      name: "Bikini Island Deluxe",
    },
    AtomicKittens: {
      href: "/casino/qt-atomic-kittens",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/AtomicKittens.webp",
      alt: "Atomic Kittens",
      name: "Atomic Kittens",
    },

    WitchesTome: {
      href: "/casino/qt-witches-tome",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WitchesTome.webp",
      alt: "Witches Tome",
      name: "Witches Tome",
    },
    LegendOfNezha: {
      href: "/casino/qt-legend-of-nezha",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LegendOfNezha.webp",
      alt: "Legend Of Nezha",
      name: "Legend Of Nezha",
    },
    TootyFruityFruits: {
      href: "/casino/qt-tooty-fruity-fruits",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TootyFruityFruits.webp",
      alt: "Tooty Fruity Fruits",
      name: "Tooty Fruity Fruits",
    },
    SirensSpell: {
      href: "/casino/qt-sirenaeurotms-spell",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SirensSpell.webp",
      alt: "Siren’s Spell",
      name: "Siren’s Spell",
    },
    Crystopia: {
      href: "/casino/qt-crystopia",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Crystopia.webp",
      alt: "Crystopia",
      name: "Crystopia",
    },
    Mariachis5: {
      href: "/casino/qt-5-mariachis",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/5Mariachis.webp",
      alt: "5 Mariachis",
      name: "5 Mariachis",
    },
    Lucky5Lions: {
      href: "/casino/qt-5-lucky-lions",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/5LuckyLions.webp",
      alt: "5 Lucky Lions",
      name: "5 Lucky Lions",
    },
    Zodiacs12: {
      href: "/casino/qt-12-zodiacs",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/12Zodiacs.webp",
      alt: "12 Zodiacs",
      name: "12 Zodiacs",
    },
    ArcaneElements: {
      href: "/casino/qt-arcane-elements",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ArcaneElements.webp",
      alt: "Arcane Elements",
      name: "Arcane Elements",
    },
    BeforeTimeRunsOut: {
      href: "/casino/qt-before-time-runs-out",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/BeforeTimeRunsOut.webp",
      alt: "Before Time Runs Out",
      name: "Before Time Runs Out",
    },
    BirdOfThunder: {
      href: "/casino/qt-bird-of-thunder",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/BirdofThunder.webp",
      alt: "Bird of Thunder",
      name: "Bird of Thunder",
    },
    BombRunner: {
      href: "/casino/qt-bomb-runner",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/BombRunner.webp",
      alt: "Bomb Runner",
      name: "Bomb Runner",
    },
    BombsAway: {
      href: "/casino/qt-bombs-away",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/BombsAway.webp",
      alt: "Bombs Away",
      name: "Bombs Away",
    },
    CalaverasExplosivas: {
      href: "/casino/qt-calaveras-explosivas",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/CalaverasExplosivas.webp",
      alt: "Calaveras Explosivas",
      name: "Calaveras Explosivas",
    },
    CakeValley: {
      href: "/casino/qt-cake-valley",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/CakeValley.webp",
      alt: "Cake Valley",
      name: "Cake Valley",
    },
    CandyTower: {
      href: "/casino/qt-candy-tower",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/CandyTower.webp",
      alt: "Candy Tower",
      name: "Candy Tower",
    },
    ChristmasGiftRush: {
      href: "/casino/qt-christmas-gift-rush",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ChristmasGiftRush.webp",
      alt: "Christmas Gift Rush",
      name: "Christmas Gift Rush",
    },
    ColossalGems: {
      href: "/casino/qt-colossal-gems",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ColossalGems.webp",
      alt: "Colossal Gems",
      name: "Colossal Gems",
    },
    CoyoteCrash: {
      href: "/casino/qt-coyote-crash",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/CoyoteCrash.webp",
      alt: "Coyote Crash",
      name: "Coyote Crash",
    },
    DiscoBeats: {
      href: "/casino/qt-disco-beats",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/DiscoBeats.webp",
      alt: "Disco Beats",
      name: "Disco Beats",
    },
    DragonCastle: {
      href: "/casino/qt-dragon-castle",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/DragonCastle.webp",
      alt: "Dragon Castle",
      name: "Dragon Castle",
    },
    DragonsRealm: {
      href: "/casino/qt-dragons-realm",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/DragonsRealm.webp",
      alt: "Dragon's Realm",
      name: "Dragon's Realm",
    },
    DragonsThrone: {
      href: "/casino/qt-dragons-throne",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/DragonsThrone.webp",
      alt: "Dragon’s Throne",
      name: "Dragon’s Throne",
    },
    DragonTigerGate: {
      href: "/casino/qt-dragon-tiger-gate",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/DragonTigerGate.webp",
      alt: "Dragon Tiger Gate",
      name: "Dragon Tiger Gate",
    },
    EgyptianDreamsDeluxe: {
      href: "/casino/qt-egyptian-dreams-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/EgyptianDreamsDeluxe.webp",
      alt: "Egyptian Dreams Deluxe",
      name: "Egyptian Dreams Deluxe",
    },
    FaCaiShen: {
      href: "/casino/qt-fa-cai-shen",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FaCaiShen.webp",
      alt: "Fa Cai Shen",
      name: "Fa Cai Shen",
    },
    FaCaiShenDeluxe: {
      href: "/casino/qt-fa-cai-shen-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FaCaiShenDeluxe.webp",
      alt: "Fa Cai Shen Deluxe",
      name: "Fa Cai Shen Deluxe",
    },
    Fenghuang: {
      href: "/casino/qt-fenghuang",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Fenghuang.webp",
      alt: "Fenghuang",
      name: "Fenghuang",
    },
    FireRooster: {
      href: "/casino/qt-fire-rooster",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FireRooster.webp",
      alt: "Fire Rooster",
      name: "Fire Rooster",
    },
    Fly: {
      href: "/casino/qt-fly-jet",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Fly.webp",
      alt: "Fly",
      name: "Fly",
    },
    FortuneDogs: {
      href: "/casino/qt-fortune-dogs",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FortuneDogs.webp",
      alt: "Fortune Dogs",
      name: "Fortune Dogs",
    },
    FourDivineBeasts: {
      href: "/casino/qt-four-divine-beasts",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/FourDivineBeasts.webp",
      alt: "Four Divine Beasts",
      name: "Four Divine Beasts",
    },
    Gangsters: {
      href: "/casino/qt-gangsters",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Gangsters.webp",
      alt: "Gangsters",
      name: "Gangsters",
    },
    GoldenUnicornDeluxe: {
      href: "/casino/qt-golden-unicorn-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/GoldenUnicornDeluxe.webp",
      alt: "Golden Unicorn Deluxe",
      name: "Golden Unicorn Deluxe",
    },
    GoldRush: {
      href: "/casino/qt-gold-rush",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/GoldRush.webp",
      alt: "Gold Rush",
      name: "Gold Rush",
    },
    HappiestChristmasTree: {
      href: "/casino/qt-happiest-christmas-tree",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/HappiestChristmasTree.webp",
      alt: "Happiest Christmas Tree",
      name: "Happiest Christmas Tree",
    },
    HappyApe: {
      href: "/casino/qt-happy-ape",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/HappyApe.webp",
      alt: "Happy Ape",
      name: "Happy Ape",
    },
    HeySushi: {
      href: "/casino/qt-hey-sushi",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/HeySushi.webp",
      alt: "Hey Sushi",
      name: "Hey Sushi",
    },
    HotHotFruit: {
      href: "/casino/qt-hot-hot-fruit",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/HotHotFruit.webp",
      alt: "Hot Hot Fruit",
      name: "Hot Hot Fruit",
    },
    HotHotHalloween: {
      href: "/casino/qt-hot-hot-halloween",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/HotHotHalloween.webp",
      alt: "Hot Hot Halloween",
      name: "Hot Hot Halloween",
    },
    IndianCashCatcher: {
      href: "/casino/qt-indian-cash-catcher",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/IndianCashCatcher.webp",
      alt: "Indian Cash Catcher",
      name: "Indian Cash Catcher",
    },
    JellyfishFlow: {
      href: "/casino/qt-jellyfish-flow",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/JellyfishFlow.webp",
      alt: "Jellyfish Flow",
      name: "Jellyfish Flow",
    },
    JellyFishFlowUltra: {
      href: "/casino/qt-jellyfish-flow-ultra",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/JellyFishFlowUltra.webp",
      alt: "JellyFish Flow Ultra",
      name: "JellyFish Flow Ultra",
    },
    Jugglenaut: {
      href: "/casino/qt-jugglenaut",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Jugglenaut.webp",
      alt: "Jugglenaut",
      name: "Jugglenaut",
    },
    Jump: {
      href: "/casino/qt-jump",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Jump.webp",
      alt: "Jump",
      name: "Jump",
    },
    KnockoutFootball: {
      href: "/casino/qt-knockout-football",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/KnockoutFootball.webp",
      alt: "Knockout Football",
      name: "Knockout Football",
    },
    KnockoutFootballRush: {
      href: "/casino/qt-knockout-football-rush",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/KnockoutFootballRush.webp",
      alt: "Knockout Football Rush",
      name: "Knockout Football Rush",
    },
    KoiGate: {
      href: "/casino/qt-koi-gate",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/KoiGate.webp",
      alt: "Koi Gate",
      name: "Koi Gate",
    },
    LanternLuck: {
      href: "/casino/qt-lantern-luck",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LanternLuck.webp",
      alt: "Lantern Luck",
      name: "Lantern Luck",
    },
    LaughingBuddha: {
      href: "/casino/qt-laughing-buddha",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LaughingBuddha.webp",
      alt: "Laughing Buddha",
      name: "Laughing Buddha",
    },
    LegendaryBeasts: {
      href: "/casino/qt-legendary-beasts",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LegendaryBeasts.webp",
      alt: "Legendary Beasts",
      name: "Legendary Beasts",
    },
    LondonHunter: {
      href: "/casino/qt-london-hunter",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LondonHunter.webp",
      alt: "London Hunter",
      name: "London Hunter",
    },
    LoonyBlox: {
      href: "/casino/qt-loony-blox",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LoonyBlox.webp",
      alt: "Loony Blox",
      name: "Loony Blox",
    },
    LuckyDurian: {
      href: "/casino/qt-lucky-durian",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LuckyDurian.webp",
      alt: "Lucky Durian",
      name: "Lucky Durian",
    },
    LuckyFortuneCat: {
      href: "/casino/qt-lucky-fortune-cat",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LuckyFortuneCat.webp",
      alt: "Lucky Fortune Cat",
      name: "Lucky Fortune Cat",
    },
    LuckyLucky: {
      href: "/casino/qt-lucky-lucky",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/LuckyLucky.webp",
      alt: "Lucky Lucky",
      name: "Lucky Lucky",
    },
    MagicOak: {
      href: "/casino/qt-magic-oak",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MagicOak.webp",
      alt: "Magic Oak",
      name: "Magic Oak",
    },
    MarvelousFurlongs: {
      href: "/casino/qt-marvelous-furlongs",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MarvelousFurlongs.webp",
      alt: "Marvelous Furlongs",
      name: "Marvelous Furlongs",
    },
    MightyMedusa: {
      href: "/casino/qt-mighty-medusa",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MightyMedusa.webp",
      alt: "Mighty Medusa",
      name: "Mighty Medusa",
    },
    MonsterMashCash: {
      href: "/casino/qt-monster-mash-cash",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MonsterMashCash.webp",
      alt: "Monster Mash Cash",
      name: "Monster Mash Cash",
    },
    MountMazuma: {
      href: "/casino/qt-mount-mazuma",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MountMazuma.webp",
      alt: "Mount Mazuma",
      name: "Mount Mazuma",
    },
    MysticFortune: {
      href: "/casino/qt-mystic-fortune",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MysticFortune.webp",
      alt: "Mystic Fortune",
      name: "Mystic Fortune",
    },
    MysticFortuneDeluxe: {
      href: "/casino/qt-mystic-fortune-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MysticFortuneDeluxe.webp",
      alt: "Mystic Fortune Deluxe",
      name: "Mystic Fortune Deluxe",
    },
    NaughtySanta: {
      href: "/casino/qt-naughty-santa",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/NaughtySanta.webp",
      alt: "Naughty Santa",
      name: "Naughty Santa",
    },
    NaughtyWukong: {
      href: "/casino/qt-naughty-wukong",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/NaughtyWukong.webp",
      alt: "Naughty Wukong",
      name: "Naughty Wukong",
    },
    NewYearsBash: {
      href: "/casino/qt-new-years-bash",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/NewYearsBash.webp",
      alt: "New Year's Bash",
      name: "New Year's Bash",
    },
    NineTails: {
      href: "/casino/qt-nine-tails",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/NineTails.webp",
      alt: "Nine Tails",
      name: "Nine Tails",
    },
    Nuwa: {
      href: "/casino/qt-nuwa",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Nuwa.webp",
      alt: "Nuwa",
      name: "Nuwa",
    },
    OrbsOfAtlantis: {
      href: "/casino/qt-orbs-of-atlantis",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/OrbsOfAtlantis.webp",
      alt: "Orbs Of Atlantis",
      name: "Orbs Of Atlantis",
    },
    OceansCall: {
      href: "/casino/qt-oceans-call",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/OceansCall.webp",
      alt: "Ocean's Call",
      name: "Ocean's Call",
    },
    PandaPanda: {
      href: "/casino/qt-panda-panda",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/PandaPanda.webp",
      alt: "Panda Panda",
      name: "Panda Panda",
    },
    PoolShark: {
      href: "/casino/qt-pool-shark",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/PoolShark.webp",
      alt: "Pool Shark",
      name: "Pool Shark",
    },
    Presto: {
      href: "/casino/qt-presto",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Presto.webp",
      alt: "Presto",
      name: "Presto",
    },
    Prost: {
      href: "/casino/qt-prost",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Prost.webp",
      alt: "Prost",
      name: "Prost",
    },
    PuckerUpPrince: {
      href: "/casino/qt-pucker-up-prince",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/PuckerUpPrince.webp",
      alt: "Pucker Up Prince",
      name: "Pucker Up Prince",
    },
    PumpkinPatch: {
      href: "/casino/qt-pumpkin-patch",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/PumpkinPatch.webp",
      alt: "Pumpkin Patch",
      name: "Pumpkin Patch",
    },
    RainbowMania: {
      href: "/casino/qt-rainbow-mania",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/RainbowMania.webp",
      alt: "Rainbow Mania",
      name: "Rainbow Mania",
    },
    ReturnToTheFeature: {
      href: "/casino/qt-return-to-the-feature",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ReturnToTheFeature.webp",
      alt: "Return To The Feature",
      name: "Return To The Feature",
    },
    RollingRoger: {
      href: "/casino/qt-rolling-roger",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/RollingRoger.webp",
      alt: "Rolling Roger",
      name: "Rolling Roger",
    },
    RomanEmpire: {
      href: "/casino/qt-roman-empire",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/RomanEmpire.webp",
      alt: "Roman Empire",
      name: "Roman Empire",
    },
    RuffledUp: {
      href: "/casino/qt-ruffled-up",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/RuffledUp.webp",
      alt: "Ruffled Up",
      name: "Ruffled Up",
    },
    SantasVillage: {
      href: "/casino/qt-santas-village",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SantasVillage.webp",
      alt: "Santa’s Village",
      name: "Santa’s Village",
    },
    Scopa: {
      href: "/casino/qt-scopa",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Scopa.webp",
      alt: "Scopa",
      name: "Scopa",
    },
    ScruffyScallywags: {
      href: "/casino/qt-scruffy-scallywags",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ScruffyScallywags.webp",
      alt: "Scruffy Scallywags",
      name: "Scruffy Scallywags",
    },
    ShaolinFortunes: {
      href: "/casino/qt-shaolin-fortunes",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ShaolinFortunes.webp",
      alt: "Shaolin Fortunes",
      name: "Shaolin Fortunes",
    },
    SojuBomb: {
      href: "/casino/qt-soju-bomb",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SojuBomb.webp",
      alt: "Soju Bomb",
      name: "Soju Bomb",
    },
    SOS: {
      href: "/casino/qt-sos",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SOS.webp",
      alt: "S.O.S!",
      name: "S.O.S!",
    },
    SpaceGoonz: {
      href: "/casino/qt-space-goonz",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SpaceGoonz.webp",
      alt: "Space Goonz",
      name: "Space Goonz",
    },
    Sparta: {
      href: "/casino/qt-sparta",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Sparta.webp",
      alt: "Sparta",
      name: "Sparta",
    },
    SuperStrike: {
      href: "/casino/qt-super-strike",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SuperStrike.webp",
      alt: "Super Strike",
      name: "Super Strike",
    },
    SuperTwister: {
      href: "/casino/qt-super-twister",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/SuperTwister.webp",
      alt: "Super Twister",
      name: "Super Twister",
    },
    TabernaDeLosMuertos: {
      href: "/casino/qt-taberna-de-los-muertos",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TabernaDeLosMuertos.webp",
      alt: "Taberna De Los Muertos",
      name: "Taberna De Los Muertos",
    },
    TabernaDeLosMuertosUltra: {
      href: "/casino/qt-taberna-de-los-muertos-ultra",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TabernaDeLosMuertosUltra.webp",
      alt: "Taberna De Los Muertos Ultra",
      name: "Taberna De Los Muertos Ultra",
    },
    TaikoBeats: {
      href: "/casino/qt-taiko-beats",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TaikoBeats.webp",
      alt: "Taiko Beats",
      name: "Taiko Beats",
    },
    TechnoTumble: {
      href: "/casino/qt-techno-tumble",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TechnoTumble.webp",
      alt: "Techno Tumble",
      name: "Techno Tumble",
    },
    TheBigDealDeluxe: {
      href: "/casino/qt-the-big-deal-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TheBigDealDeluxe.webp",
      alt: "The Big Deal Deluxe",
      name: "The Big Deal Deluxe",
    },
    TheDeadEscape: {
      href: "/casino/qt-the-dead-escape",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TheDeadEscape.webp",
      alt: "The Dead Escape",
      name: "The Dead Escape",
    },
    TotemTowers: {
      href: "/casino/qt-totem-towers",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TotemTowers.webp",
      alt: "Totem Towers",
      name: "Totem Towers",
    },
    TukTukThailand: {
      href: "/casino/qt-tuk-tuk-thailand",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TukTukThailand.webp",
      alt: "Tuk Tuk Thailand",
      name: "Tuk Tuk Thailand",
    },
    WaysOfFortune: {
      href: "/casino/qt-ways-of-fortune",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WaysOfFortune.webp",
      alt: "Ways Of Fortune",
      name: "Ways Of Fortune",
    },
    WealthInn: {
      href: "/casino/qt-wealth-inn",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WealthInn.webp",
      alt: "Wealth Inn",
      name: "Wealth Inn",
    },
    WickedWitch: {
      href: "/casino/qt-wicked-witch",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WickedWitch.webp",
      alt: "Wicked Witch",
      name: "Wicked Witch",
    },
    WildTrucks: {
      href: "/casino/qt-wild-trucks",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WildTrucks.webp",
      alt: "Wild Trucks",
      name: "Wild Trucks",
    },
    WizardsWantWar: {
      href: "/casino/qt-wizards-want-war",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WizardsWantWar.webp",
      alt: "Wizards Want War",
      name: "Wizards Want War",
    },
    Zeus: {
      href: "/casino/qt-zeus",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Zeus.webp",
      alt: "Zeus",
      name: "Zeus",
    },
    Hand3Blackjack: {
      href: "/casino/qt-3-hand-blackjack",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/3HandBlackjack.webp",
      alt: "3 Hand Blackjack",
      name: "3 Hand Blackjack",
    },
    Hand3BlackjackDoubleExposure: {
      href: "/casino/qt-3-hand-blackjack-double-exposure",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/3HandBlackjackDoubleExposure.webp",
      alt: "3 Hand Blackjack Double Exposure",
      name: "3 Hand Blackjack Double Exposure",
    },
    AmericanBlackjack: {
      href: "/casino/qt-american-blackjack",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/AmericanBlackjack.webp",
      alt: "American Blackjack",
      name: "American Blackjack",
    },
    Baccarat: {
      href: "/casino/qt-baccarat",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
    },
    BaccaratZeroCommission: {
      href: "/casino/qt-baccarat-zero-commission",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/BaccaratZeroCommission.webp",
      alt: "Baccarat Zero Commission",
      name: "Baccarat Zero Commission",
    },
    CaribbeanHoldem: {
      href: "/casino/qt-caribbean-holdem",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/CaribbeanHoldem.webp",
      alt: "Caribbean Holdem",
      name: "Caribbean Holdem",
    },
    CaribbeanStud: {
      href: "/casino/qt-caribbean-stud",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/CaribbeanStud.webp",
      alt: "Caribbean Stud",
      name: "Caribbean Stud",
    },
    DragonTiger: {
      href: "/casino/qt-dragon-tiger",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    EuropeanRoulette: {
      href: "/casino/qt-european-roulette",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/EuropeanRoulette.webp",
      alt: "European Roulette",
      name: "European Roulette",
    },
    SicBo: {
      href: "/casino/qt-sic-bo",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Sicbo.webp",
      alt: "Sic Bo",
      name: "Sic Bo",
    },
    ThreeCardPoker: {
      href: "/casino/qt-three-card-poker",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ThreeCardPoker.webp",
      alt: "Three Card Poker",
      name: "Three Card Poker",
    },
    ThreeCardPokerDeluxe: {
      href: "/casino/qt-three-card-poker-deluxe",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ThreeCardPokerDeluxe.webp",
      alt: "Three Card Poker Deluxe",
      name: "Three Card Poker Deluxe",
    },
    War: {
      href: "/casino/qt-war",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/War.webp",
      alt: "War",
      name: "War",
    },
    ValentineMonchy: {
      href: "/casino/qt-valentine-monchy",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ValentineMonchy.webp",
      alt: "Valentine Monchy",
      name: "Valentine Monchy",
    },
    HotHotSummer: {
      href: "/casino/qt-hot-hot-summer",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/HotHotSummer.webp",
      alt: "Hot Hot Summer",
      name: "Hot Hot Summer",
    },
    // HauntedHarbor: {
    //   href: "/casino/aggaphabanero-haunted-harbor",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/HauntedHarbor.webp",
    //   alt: "Haunted Harbor",
    //   name: "Haunted Harbor",
    // },
    // GloryOfRome: {
    //   href: "/casino/aggaphabanero-glory-of-rome",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/GloryofRome.webp",
    //   alt: "Glory of Rome",
    //   name: "Glory of Rome",
    // },
    KoiKoiTreasure: {
      href: "/casino/qt-koi-koi-treasure",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/KoiKoiTreasure.webp",
      alt: "Koi-Koi Treasure",
      name: "Koi-Koi Treasure",
    },
    WaltzBeauty: {
      href: "/casino/qt-waltz-beauty",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WaltzBeauty.webp",
      alt: "Waltz Beauty",
      name: "Waltz Beauty",
    },
    TotemWarrior: {
      href: "/casino/qt-totem-warrior",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/TotemWarrior.webp",
      alt: "Totem Warrior",
      name: "Totem Warrior",
    },
    ArcticHunt: {
      href: "/casino/qt-arctic-hunt",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/ArcticHunt.webp",
      alt: "Arctic Hunt",
      name: "Arctic Hunt",
    },
    MooMooCow: {
      href: "/casino/qt-moo-moo-cow",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/MooMooCow.webp",
      alt: "Moo Moo Cow",
      name: "Moo Moo Cow",
    },
    GoldenTajMahal: {
      href: "/casino/qt-golden-taj-mahal",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/GoldenTajMahal.webp",
      alt: "Golden Taj Mahal",
      name: "Golden Taj Mahal",
    },
    WildFlow: {
      href: "/casino/qt-wild-flow",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/WildFlow.webp",
      alt: "Wild Flow",
      name: "Wild Flow",
    },
    VampiresFate: {
      href: "/casino/qt-vampires-fate",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/VampiresFate.webp",
      alt: "Vampire's Fate",
      name: "Vampire's Fate",
    },
    Jump2: {
      href: "/casino/qt-jump-high-2",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Jump2.webp",
      alt: "Jump! 2",
      name: "Jump! 2",
    },
    Poseidon: {
      href: "/casino/qt-poseidon",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/habanero/Poseidon.webp",
      alt: "Poseidon",
      name: "Poseidon",
    },
    // BabaYaga: {
    //   href: "/casino/aggaphabanero-baba-yaga",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/BabaYaga.webp",
    //   alt: "Baba Yaga",
    //   name: "Baba Yaga",
    // },
    // CarnivalCove: {
    //   href: "/casino/aggaphabanero-carnival-cove",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/CarnivalCove.webp",
    //   alt: "Carnival Cove",
    //   name: "Carnival Cove",
    // },
    // HyperHues: {
    //   href: "/casino/aggaphabanero-hyper-hues",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/HyperHues.webp",
    //   alt: "Hyper Hues",
    //   name: "Hyper Hues",
    // },
    // JapaneseMask: {
    //   href: "/casino/aggaphabanero-japanese-mask",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/JapaneseMask.webp",
    //   alt: "Japanese Mask",
    //   name: "Japanese Mask",
    // },
    // ShamrockQuest: {
    //   href: "/casino/aggaphabanero-shamrock-quest",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "QTECH",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/habanero/ShamrockQuest.webp",
    //   alt: "Shamrock Quest",
    //   name: "Shamrock Quest",
    // },
  },

  // gameart: {
  //   Super20Sevens: {
  //     href: "/casino/qtechgameart-20-super-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/20SuperSevens.webp",
  //     alt: "20 Super Sevens",
  //     name: "20 Super Sevens",
  //   },
  //   YellowDiver: {
  //     href: "/casino/qtechgameart-yellow-diver",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/YellowDiver.webp",
  //     alt: "Yellow Diver",
  //     name: "Yellow Diver",
  //   },
  //   ShiningRoyal100: {
  //     href: "/casino/qtechgameart-shining-royal-100",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ShiningRoyal100.webp",
  //     alt: "Shining Royal 100",
  //     name: "Shining Royal 100",
  //   },
  //   Fury7s20: {
  //     href: "/casino/qtechgameart-7s-fury-20",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/7sFury20.webp",
  //     alt: "7s Fury 20",
  //     name: "7s Fury 20",
  //   },
  //   GoldenFurong: {
  //     href: "/casino/qtechgameart-golden-furong",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GoldenFurong.webp",
  //     alt: "Golden Furong",
  //     name: "Golden Furong",
  //   },
  //   XmasExpress: {
  //     href: "/casino/qtechgameart-x-mas-express",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/XmasExpress.webp",
  //     alt: "X-mas Express",
  //     name: "X-mas Express",
  //   },
  //   Lucky5Sevens: {
  //     href: "/casino/qtechgameart-5-lucky-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/5LuckySevens.webp",
  //     alt: "5 Lucky Sevens",
  //     name: "5 Lucky Sevens",
  //   },
  //   CandyTrouble: {
  //     href: "/casino/qtechgameart-candy-trouble",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CandyTrouble.webp",
  //     alt: "Candy Trouble",
  //     name: "Candy Trouble",
  //   },
  //   RagnasRock: {
  //     href: "/casino/qtechgameart-ragnas-rock",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/RagnasRock.webp",
  //     alt: "Ragna’s Rock",
  //     name: "Ragna’s Rock",
  //   },
  //   LuckyReefs: {
  //     href: "/casino/qtechgameart-lucky-reefs",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LuckyReefs.webp",
  //     alt: "Lucky Reefs",
  //     name: "Lucky Reefs",
  //   },
  //   LuckyFruitsAndDiamonds: {
  //     href: "/casino/qtechgameart-lucky-fruits-and-diamonds",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LuckyFruitsAndDiamonds.webp",
  //     alt: "Lucky Fruits & Diamonds",
  //     name: "Lucky Fruits & Diamonds",
  //   },
  //   SafariGems: {
  //     href: "/casino/qtechgameart-safari-gems",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SafariGems.webp",
  //     alt: "Safari Gems",
  //     name: "Safari Gems",
  //   },
  //   Super40BlazingSevens: {
  //     href: "/casino/qtechgameart-40-super-blazing-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/40SuperBlazingSevens.webp",
  //     alt: "40 Super Blazing Sevens",
  //     name: "40 Super Blazing Sevens",
  //   },
  //   PixelInvaders: {
  //     href: "/casino/qtechgameart-pixel-invaders",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PixelInvaders.webp",
  //     alt: "Pixel Invaders",
  //     name: "Pixel Invaders",
  //   },
  //   Lucky40Sevens: {
  //     href: "/casino/qtechgameart-40-lucky-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/40LuckySevens.webp",
  //     alt: "40 Lucky Sevens",
  //     name: "40 Lucky Sevens",
  //   },
  //   Riches88: {
  //     href: "/casino/qtechgameart-88-riches",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/88Riches.webp",
  //     alt: "88 Riches",
  //     name: "88 Riches",
  //   },
  //   Lucky100Sevens: {
  //     href: "/casino/qtechgameart-100-lucky-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/100LuckySevens.webp",
  //     alt: "100 Lucky Sevens",
  //     name: "100 Lucky Sevens",
  //   },
  //   AfricanSunset2: {
  //     href: "/casino/qtechgameart-african-sunset-2",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AfricanSunset2.webp",
  //     alt: "African Sunset 2",
  //     name: "African Sunset 2",
  //   },
  //   AladdinsQuest: {
  //     href: "/casino/qtechgameart-aladdins-quest",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AladdinsQuest.webp",
  //     alt: "Aladdin's Quest",
  //     name: "Aladdin's Quest",
  //   },
  //   AliBabasRiches: {
  //     href: "/casino/qtechgameart-ali-babas-riches",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AliBabasRiches.webp",
  //     alt: "Ali Baba's Riches",
  //     name: "Ali Baba's Riches",
  //   },
  //   AngryDragons: {
  //     href: "/casino/qtechgameart-angry-dragons",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AngryDragons.webp",
  //     alt: "Angry Dragons",
  //     name: "Angry Dragons",
  //   },
  //   ApocalypseQuest: {
  //     href: "/casino/qtechgameart-apocalypse-quest",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ApocalypseQuest.webp",
  //     alt: "Apocalypse Quest",
  //     name: "Apocalypse Quest",
  //   },
  //   AtlantisWorld: {
  //     href: "/casino/qtechgameart-atlantis-world",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AtlantisWorld.webp",
  //     alt: "Atlantis World",
  //     name: "Atlantis World",
  //   },
  //   AzrabahWishes: {
  //     href: "/casino/qtechgameart-azrabah-wishes",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AzrabahWishes.webp",
  //     alt: "Azrabah Wishes",
  //     name: "Azrabah Wishes",
  //   },
  //   Awesome7s: {
  //     href: "/casino/qtechgameart-awesome-7s",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Awesome7s.webp",
  //     alt: "Awesome 7's",
  //     name: "Awesome 7's",
  //   },
  //   BattleForAtlantis: {
  //     href: "/casino/qtechgameart-battle-for-atlantis",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BattleforAtlantis.webp",
  //     alt: "Battle for Atlantis",
  //     name: "Battle for Atlantis",
  //   },
  //   BattleForCosmos: {
  //     href: "/casino/qtechgameart-battle-for-cosmos",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BattleforCosmos.webp",
  //     alt: "Battle for Cosmos",
  //     name: "Battle for Cosmos",
  //   },
  //   BookOfAlchemy: {
  //     href: "/casino/qtechgameart-book-of-alchemy",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BookofAlchemy.webp",
  //     alt: "Book of Alchemy",
  //     name: "Book of Alchemy",
  //   },
  //   BookOfCupigs: {
  //     href: "/casino/qtechgameart-book-of-cupigs",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BookofCupigs.webp",
  //     alt: "Book of Cupigs",
  //     name: "Book of Cupigs",
  //   },
  //   BookOfOziris: {
  //     href: "/casino/qtechgameart-book-of-oziris",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BookofOziris.webp",
  //     alt: "Book of Oziris",
  //     name: "Book of Oziris",
  //   },
  //   BubbleFruits: {
  //     href: "/casino/qtechgameart-bubble-fruits",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BubbleFruits.webp",
  //     alt: "Bubble Fruits",
  //     name: "Bubble Fruits",
  //   },
  //   BuffaloSunset: {
  //     href: "/casino/qtechgameart-buffalo-sunset",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BuffaloSunset.webp",
  //     alt: "Buffalo Sunset",
  //     name: "Buffalo Sunset",
  //   },
  //   BurningFlame: {
  //     href: "/casino/qtechgameart-burning-flame",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BurningFlame.webp",
  //     alt: "Burning Flame",
  //     name: "Burning Flame",
  //   },
  //   Caligula: {
  //     href: "/casino/qtechgameart-caligula",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Caligula.webp",
  //     alt: "Caligula",
  //     name: "Caligula",
  //   },
  //   // CaptainCandy: {
  //   //   href: "/casino/qtechgameart-captain-candy",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/CaptainCandy.webp",
  //   //   alt: "Captain Candy",
  //   //   name: "Captain Candy",
  //   // },
  //   CastleBlood: {
  //     href: "/casino/qtechgameart-castle-blood",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CastleBlood.webp",
  //     alt: "Castle Blood",
  //     name: "Castle Blood",
  //   },
  //   ChiliQuest: {
  //     href: "/casino/qtechgameart-chili-quest",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ChiliQuest.webp",
  //     alt: "Chili Quest",
  //     name: "Chili Quest",
  //   },
  //   ChineseZodiac: {
  //     href: "/casino/qtechgameart-chinese-zodiac",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ChineseZodiac.webp",
  //     alt: "Chinese Zodiac",
  //     name: "Chinese Zodiac",
  //   },
  //   CircusOfHorror: {
  //     href: "/casino/qtechgameart-circus-of-horror",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CircusofHorror.webp",
  //     alt: "Circus of Horror",
  //     name: "Circus of Horror",
  //   },
  //   CleopatraJewels: {
  //     href: "/casino/qtechgameart-cleopatra-jewels",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CleopatraJewels.webp",
  //     alt: "Cleopatra Jewels",
  //     name: "Cleopatra Jewels",
  //   },
  //   // CrystalMystery: {
  //   //   href: "/casino/qtechgameart-crystal-mystery",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/CrystalMystery.webp",
  //   //   alt: "Crystal Mystery",
  //   //   name: "Crystal Mystery",
  //   // },
  //   DaVinciCodex: {
  //     href: "/casino/qtechgameart-davinci-codex",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DaVinciCodex.webp",
  //     alt: "DaVinci Codex",
  //     name: "DaVinci Codex",
  //   },
  //   DawnOfOlympus: {
  //     href: "/casino/qtechgameart-dawn-of-olympus",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DawnofOlympus.webp",
  //     alt: "Dawn of Olympus",
  //     name: "Dawn of Olympus",
  //   },
  //   DiamondMagicDeluxe: {
  //     href: "/casino/qtechgameart-diamond-magic-deluxe",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DiamondMagicDeluxe.webp",
  //     alt: "Diamond Magic Deluxe",
  //     name: "Diamond Magic Deluxe",
  //   },
  //   DolphinsDream: {
  //     href: "/casino/qtechgameart-dolphins-dream",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DolphinsDream.webp",
  //     alt: "Dolphin's Dream",
  //     name: "Dolphin's Dream",
  //   },
  //   DragonLady: {
  //     href: "/casino/qtechgameart-dragon-lady",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DragonLady.webp",
  //     alt: "Dragon Lady",
  //     name: "Dragon Lady",
  //   },
  //   DragonWhisperer: {
  //     href: "/casino/qtechgameart-dragon-whisperer",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DragonWhisperer.webp",
  //     alt: "Dragon Whisperer",
  //     name: "Dragon Whisperer",
  //   },
  //   DynamiteFruits: {
  //     href: "/casino/qtechgameart-dynamite-fruits",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DynamiteFruits.webp",
  //     alt: "Dynamite Fruits",
  //     name: "Dynamite Fruits",
  //   },
  //   ElToreo: {
  //     href: "/casino/qtechgameart-el-toreo",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ElToreo.webp",
  //     alt: "El Toreo",
  //     name: "El Toreo",
  //   },
  //   EmperorsWealth: {
  //     href: "/casino/qtechgameart-emperors-wealth",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/EmperorsWealth.webp",
  //     alt: "Emperors Wealth",
  //     name: "Emperors Wealth",
  //   },
  //   FiveStarLuxury: {
  //     href: "/casino/qtechgameart-five-star-luxury",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/FiveStarLuxury.webp",
  //     alt: "Five Star Luxury",
  //     name: "Five Star Luxury",
  //   },
  //   FlamingReels: {
  //     href: "/casino/qtechgameart-flaming-reels",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/FlamingReels.webp",
  //     alt: "Flaming Reels",
  //     name: "Flaming Reels",
  //   },
  //   FortuneLions: {
  //     href: "/casino/qtechgameart-fortune-lions",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/FortuneLions.webp",
  //     alt: "Fortune Lions",
  //     name: "Fortune Lions",
  //   },
  //   // FourSymbols: {
  //   //   href: "/casino/qtechgameart-four-symbols",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/FourSymbols.webp",
  //   //   alt: "Four Symbols",
  //   //   name: "Four Symbols",
  //   // },
  //   FrozenJoker: {
  //     href: "/casino/qtechgameart-frozen-joker",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/FrozenJoker.webp",
  //     alt: "Frozen Joker",
  //     name: "Frozen Joker",
  //   },
  //   GemsElevator: {
  //     href: "/casino/qtechgameart-gems-elevator",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GemsElevator.webp",
  //     alt: "Gems Elevator",
  //     name: "Gems Elevator",
  //   },
  //   GoldenDragon: {
  //     href: "/casino/qtechgameart-golden-dragon",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GoldenDragon.webp",
  //     alt: "Golden Dragon",
  //     name: "Golden Dragon",
  //   },
  //   HawaiianChristmas: {
  //     href: "/casino/qtechgameart-hawaiian-christmas",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/HawaiianChristmas.webp",
  //     alt: "Hawaiian Christmas",
  //     name: "Hawaiian Christmas",
  //   },
  //   HawaiianFruits: {
  //     href: "/casino/qtechgameart-hawaiian-fruits",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/HawaiianFruits.webp",
  //     alt: "Hawaiian Fruits",
  //     name: "Hawaiian Fruits",
  //   },
  //   Hollywoof: {
  //     href: "/casino/qtechgameart-hollywoof",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Hollywoof.webp",
  //     alt: "Hollywoof",
  //     name: "Hollywoof",
  //   },
  //   HotFruitDelights: {
  //     href: "/casino/qtechgameart-hot-fruit-delights",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/HotFruitDelights.webp",
  //     alt: "Hot Fruit Delights",
  //     name: "Hot Fruit Delights",
  //   },
  //   JadeTreasure: {
  //     href: "/casino/qtechgameart-jade-treasure",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JadeTreasure.webp",
  //     alt: "Jade Treasure",
  //     name: "Jade Treasure",
  //   },
  //   JingleJokers: {
  //     href: "/casino/qtechgameart-jingle-jokers",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JingleJokers.webp",
  //     alt: "Jingle Jokers",
  //     name: "Jingle Jokers",
  //   },
  //   JoanOfArc: {
  //     href: "/casino/qtechgameart-joan-of-arc",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JoanofArc.webp",
  //     alt: "Joan of Arc",
  //     name: "Joan of Arc",
  //   },
  //   // KingOfMonkeys: {
  //   //   href: "/casino/qtechgameart-king-of-monkeys",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/KingOfMonkeys.webp",
  //   //   alt: "King Of Monkeys",
  //   //   name: "King Of Monkeys",
  //   // },
  //   KingOfMonkeys2: {
  //     href: "/casino/qtechgameart-king-of-monkeys-2",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/KingofMonkeys2.webp",
  //     alt: "King of Monkeys 2",
  //     name: "King of Monkeys 2",
  //   },
  //   // KingOfWealth: {
  //   //   href: "/casino/qtechgameart-king-of-wealth",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/KingOfWealth.webp",
  //   //   alt: "King of Wealth",
  //   //   name: "King of Wealth",
  //   // },
  //   KittyTwins: {
  //     href: "/casino/qtechgameart-kitty-twins",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/KittyTwins.webp",
  //     alt: "Kitty Twins",
  //     name: "Kitty Twins",
  //   },
  //   KukulkansQueen: {
  //     href: "/casino/qtechgameart-kukulkans-queen",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/KukulkansQueen.webp",
  //     alt: "Kukulkan’s Queen",
  //     name: "Kukulkan’s Queen",
  //   },
  //   // LuckyBabies: {
  //   //   href: "/casino/qtechgameart-lucky-babies",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/LuckyBabies.webp",
  //   //   alt: "Lucky Babies",
  //   //   name: "Lucky Babies",
  //   // },
  //   LuckyCoins: {
  //     href: "/casino/qtechgameart-lucky-coins",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LuckyCoins.webp",
  //     alt: "Lucky Coins",
  //     name: "Lucky Coins",
  //   },
  //   LunarRabbit: {
  //     href: "/casino/qtechgameart-lunar-rabbit",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LunarRabbit.webp",
  //     alt: "Lunar Rabbit",
  //     name: "Lunar Rabbit",
  //   },
  //   MagicDragon: {
  //     href: "/casino/qtechgameart-magic-dragon",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MagicDragon.webp",
  //     alt: "Magic Dragon",
  //     name: "Magic Dragon",
  //   },
  //   MariachiFiesta: {
  //     href: "/casino/qtechgameart-mariachi-fiesta",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MariachiFiesta.webp",
  //     alt: "Mariachi Fiesta",
  //     name: "Mariachi Fiesta",
  //   },
  //   MoneyFarm: {
  //     href: "/casino/qtechgameart-money-farm",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MoneyFarm.webp",
  //     alt: "Money Farm",
  //     name: "Money Farm",
  //   },
  //   MoneyFarm2: {
  //     href: "/casino/qtechgameart-money-farm-2",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MoneyFarm2.webp",
  //     alt: "Money Farm 2",
  //     name: "Money Farm 2",
  //   },
  //   MoneyFarmMegaways: {
  //     href: "/casino/qtechgameart-money-farm-megaways",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MoneyFarmMegaways.webp",
  //     alt: "Money Farm Megaways",
  //     name: "Money Farm Megaways",
  //   },
  //   MonkeyPirates: {
  //     href: "/casino/qtechgameart-monkey-pirates",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MonkeyPirates.webp",
  //     alt: "Monkey Pirates",
  //     name: "Monkey Pirates",
  //   },
  //   MoreCash: {
  //     href: "/casino/qtechgameart-more-cash",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MoreCash.webp",
  //     alt: "More Cash",
  //     name: "More Cash",
  //   },
  //   NefertitisNile: {
  //     href: "/casino/qtechgameart-nefertitis-nile",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/NefertitisNile.webp",
  //     alt: "Nefertiti's Nile",
  //     name: "Nefertiti's Nile",
  //   },
  //   NightAtKTV: {
  //     href: "/casino/qtechgameart-night-at-ktv",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/NightatKTV.webp",
  //     alt: "Night at KTV",
  //     name: "Night at KTV",
  //   },
  //   NornsFate: {
  //     href: "/casino/qtechgameart-norns-fate",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/NornsFate.webp",
  //     alt: "Norns' Fate",
  //     name: "Norns' Fate",
  //   },
  //   PetersUniverse: {
  //     href: "/casino/qtechgameart-peters-universe",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PetersUniverse.webp",
  //     alt: "Peter's Universe",
  //     name: "Peter's Universe",
  //   },
  //   PiggyBjornMuspelheimsTreasure: {
  //     href: "/casino/qtechgameart-piggy-bjorn-muspelheims-treasure",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PiggyBjornMuspelheimsTreasure.webp",
  //     alt: "Piggy Bjorn - Muspelheim's Treasure",
  //     name: "Piggy Bjorn - Muspelheim's Treasure",
  //   },
  //   PiggyBjorn2WinterIsComing: {
  //     href: "/casino/qtechgameart-piggy-bjorn-2-winter-is-coming",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PiggyBjorn2WinterisComing.webp",
  //     alt: "Piggy Bjorn 2 - Winter is Coming",
  //     name: "Piggy Bjorn 2 - Winter is Coming",
  //   },
  //   PiggyHolmes: {
  //     href: "/casino/qtechgameart-piggy-holmes",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PiggyHolmes.webp",
  //     alt: "Piggy Holmes",
  //     name: "Piggy Holmes",
  //   },
  //   PiratesPearlMegaways: {
  //     href: "/casino/qtechgameart-pirates-pearl-megaways",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PiratesPearlMegaways.webp",
  //     alt: "Pirate's Pearl Megaways",
  //     name: "Pirate's Pearl Megaways",
  //   },
  //   QueenOfTheSeas: {
  //     href: "/casino/qtechgameart-queen-of-the-seas",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/QueenOfTheSeas.webp",
  //     alt: "Queen Of The Seas",
  //     name: "Queen Of The Seas",
  //   },
  //   RamsesTreasure: {
  //     href: "/casino/qtechgameart-ramses-treasure",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/RamsesTreasure.webp",
  //     alt: "Ramses Treasure",
  //     name: "Ramses Treasure",
  //   },
  //   RoyalGems: {
  //     href: "/casino/qtechgameart-royal-gems",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/RoyalGems.webp",
  //     alt: "Royal Gems",
  //     name: "Royal Gems",
  //   },
  //   SantasFactory: {
  //     href: "/casino/qtechgameart-santas-factory",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SantasFactory.webp",
  //     alt: "Santa's Factory",
  //     name: "Santa's Factory",
  //   },
  //   SantasFarm: {
  //     href: "/casino/qtechgameart-santas-farm",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SantasFarm.webp",
  //     alt: "Santa's Farm",
  //     name: "Santa's Farm",
  //   },
  //   // SlotOfMoney: {
  //   //   href: "/casino/qtechgameart-slot-of-money",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/SlotOfMoney.webp",
  //   //   alt: "Slot Of Money",
  //   //   name: "Slot Of Money",
  //   // },
  //   SpartansLegacy: {
  //     href: "/casino/qtechgameart-spartans-legacy",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SpartansLegacy.webp",
  //     alt: "Spartans Legacy",
  //     name: "Spartans Legacy",
  //   },
  //   Spookygraves: {
  //     href: "/casino/qtechgameart-spooky-graves",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Spookygraves.webp",
  //     alt: "Spooky graves",
  //     name: "Spooky graves",
  //   },
  //   // StarCash: {
  //   //   href: "/casino/qtechgameart-star-cash",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/StarCash.webp",
  //   //   alt: "Star Cash",
  //   //   name: "Star Cash",
  //   // },
  //   StormingFlame: {
  //     href: "/casino/qtechgameart-storming-flame",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/StormingFlame.webp",
  //     alt: "Storming Flame",
  //     name: "Storming Flame",
  //   },
  //   SummerJam: {
  //     href: "/casino/qtechgameart-summer-jam",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SummerJam.webp",
  //     alt: "Summer Jam",
  //     name: "Summer Jam",
  //   },
  //   SuperHeatedsevens: {
  //     href: "/casino/qtechgameart-super-heated-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SuperHeatedsevens.webp",
  //     alt: "Super Heated sevens",
  //     name: "Super Heated sevens",
  //   },
  //   SushiYatta: {
  //     href: "/casino/qtechgameart-sushi-yatta",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SushiYatta.webp",
  //     alt: "Sushi Yatta",
  //     name: "Sushi Yatta",
  //   },
  //   Tesla: {
  //     href: "/casino/qtechgameart-tesla",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Tesla.webp",
  //     alt: "Tesla",
  //     name: "Tesla",
  //   },
  //   TexasRangersReward: {
  //     href: "/casino/qtechgameart-texas-rangers-reward",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/TexasRangersReward.webp",
  //     alt: "Texas Rangers Reward",
  //     name: "Texas Rangers Reward",
  //   },
  //   ThreeKings: {
  //     href: "/casino/qtechgameart-three-kings",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ThreeKings.webp",
  //     alt: "Three Kings",
  //     name: "Three Kings",
  //   },
  //   ThunderBird: {
  //     href: "/casino/qtechgameart-thunder-bird",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ThunderBird.webp",
  //     alt: "Thunder Bird",
  //     name: "Thunder Bird",
  //   },
  //   TigerHeart: {
  //     href: "/casino/qtechgameart-tiger-heart",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/TigerHeart.webp",
  //     alt: "Tiger Heart",
  //     name: "Tiger Heart",
  //   },
  //   WildWildQuest: {
  //     href: "/casino/qtechgameart-wild-wild-quest",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/WildWildQuest.webp",
  //     alt: "Wild Wild Quest",
  //     name: "Wild Wild Quest",
  //   },
  //   WolfHunt: {
  //     href: "/casino/qtechgameart-wolf-hunt",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/WolfHunt.webp",
  //     alt: "Wolf Hunt",
  //     name: "Wolf Hunt",
  //   },
  //   Blackjack: {
  //     href: "/casino/qtechgameart-blackjack",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Blackjack.webp",
  //     alt: "Blackjack",
  //     name: "Blackjack",
  //   },
  //   CaribbeanStudPoker: {
  //     href: "/casino/qtechgameart-caribbean-stud-poker",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CaribbeanStudPoker.webp",
  //     alt: "Caribbean Stud Poker",
  //     name: "Caribbean Stud Poker",
  //   },
  //   EuropeanRoulette: {
  //     href: "/casino/qtechgameart-european-roulette",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Europeanroulette.webp",
  //     alt: "European roulette",
  //     name: "European roulette",
  //   },
  //   AfricanSunset: {
  //     href: "/casino/qtechgameart-african-sunset-u4555",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AfricanSunset.webp",
  //     alt: "African Sunset",
  //     name: "African Sunset",
  //   },
  //   AncientGong: {
  //     href: "/casino/qtechgameart-ancient-gong-u5142",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AncientGong.webp",
  //     alt: "Ancient Gong",
  //     name: "Ancient Gong",
  //   },
  //   DancingLions: {
  //     href: "/casino/qtechgameart-dancing-lions-u1126",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DancingLions.webp",
  //     alt: "Dancing Lions",
  //     name: "Dancing Lions",
  //   },
  //   DragonKing: {
  //     href: "/casino/qtechgameart-dragon-king-u9033",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DragonKing.webp",
  //     alt: "Dragon King",
  //     name: "Dragon King",
  //   },
  //   // ExplosiveReels: {
  //   //   href: "/casino/qtechgameart-explosive-reels-u2503",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/ExplosiveReels.webp",
  //   //   alt: "Explosive Reels",
  //   //   name: "Explosive Reels",
  //   // },
  //   FortunePanda: {
  //     href: "/casino/qtechgameart-fortune-panda-u7026",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/FortunePanda.webp",
  //     alt: "Fortune Panda",
  //     name: "Fortune Panda",
  //   },
  //   GoldOfRa: {
  //     href: "/casino/qtechgameart-gold-of-ra-u8512",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GoldOfRa.webp",
  //     alt: "Gold Of Ra",
  //     name: "Gold Of Ra",
  //   },
  //   JumpinPot: {
  //     href: "/casino/qtechgameart-jumpin-pot-u1757",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JumpinPot.webp",
  //     alt: "Jumpin Pot",
  //     name: "Jumpin Pot",
  //   },
  //   LadyLuck: {
  //     href: "/casino/qtechgameart-lady-luck-u9928",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LadyLuck.webp",
  //     alt: "Lady Luck",
  //     name: "Lady Luck",
  //   },
  //   MagicUnicorn: {
  //     href: "/casino/qtechgameart-magic-unicorn-u5299",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MagicUnicorn.webp",
  //     alt: "Magic Unicorn",
  //     name: "Magic Unicorn",
  //   },
  //   PhoenixPrincess: {
  //     href: "/casino/qtechgameart-phoenix-princess-u3859",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PhoenixPrincess.webp",
  //     alt: "Phoenix Princess",
  //     name: "Phoenix Princess",
  //   },
  //   PowerDragon: {
  //     href: "/casino/qtechgameart-power-dragon-u5977",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/PowerDragon.webp",
  //     alt: "Power Dragon",
  //     name: "Power Dragon",
  //   },
  //   Venetia: {
  //     href: "/casino/qtechgameart-venetia-u1320",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Venetia.webp",
  //     alt: "Venetia",
  //     name: "Venetia",
  //   },
  //   WildDolphin: {
  //     href: "/casino/qtechgameart-wild-dolphin-u3317",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/WildDolphin.webp",
  //     alt: "Wild Dolphin",
  //     name: "Wild Dolphin",
  //   },
  //   WolfQuest: {
  //     href: "/casino/qtechgameart-wolf-quest-u9182",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/WolfQuest.webp",
  //     alt: "Wolf Quest",
  //     name: "Wolf Quest",
  //   },
  //   RoshImmortalityCubeMegaways: {
  //     href: "/casino/qtechgameart-rosh-immortality-cube-megaways-u8095",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/RoshImmortalityCubeMegaways.webp",
  //     alt: "Rosh Immortality Cube Megaways",
  //     name: "Rosh Immortality Cube Megaways",
  //   },
  //   DiegoElPibeDeOro: {
  //     href: "/casino/qtechgameart-diego-el-pibe-de-oro-u6011",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DiegoelPibedeOro.webp",
  //     alt: "Diego el Pibe de Oro",
  //     name: "Diego el Pibe de Oro",
  //   },
  //   MaradonaHyperWays: {
  //     href: "/casino/qtechgameart-maradona-hyperways-u9983",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MaradonaHyperWays.webp",
  //     alt: "Maradona HyperWays",
  //     name: "Maradona HyperWays",
  //   },
  //   DiegoMaradonaCampione: {
  //     href: "/casino/qtechgameart-diego-maradona-campione-u7384",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DiegoMaradonaCampione.webp",
  //     alt: "Diego Maradona Campione",
  //     name: "Diego Maradona Campione",
  //   },
  //   CloverGoesWild: {
  //     href: "/casino/qtechgameart-clover-goes-wild-u1572",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CloverGoesWild.webp",
  //     alt: "Clover Goes Wild",
  //     name: "Clover Goes Wild",
  //   },
  //   UltraClusterKingdom: {
  //     href: "/casino/qtechgameart-ultra-cluster-kingdom",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/UltraClusterKingdom.webp",
  //     alt: "Ultra Cluster Kingdom",
  //     name: "Ultra Cluster Kingdom",
  //   },
  //   TractorFrenzy40: {
  //     href: "/casino/qtechgameart-tractor-frenzy-40",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/TractorFrenzy40.webp",
  //     alt: "Tractor Frenzy 40",
  //     name: "Tractor Frenzy 40",
  //   },
  //   JazzJamJackpots: {
  //     href: "/casino/qtechgameart-jazz-jam-jackpots",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JazzJamJackpots.webp",
  //     alt: "Jazz Jam Jackpots",
  //     name: "Jazz Jam Jackpots",
  //   },
  //   SafariCubsGoWild: {
  //     href: "/casino/qtechgameart-safari-cubs-go-wild",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SafariCubsGoWild.webp",
  //     alt: "Safari Cubs Go Wild",
  //     name: "Safari Cubs Go Wild",
  //   },
  //   LuxorSecretsHoldnWin: {
  //     href: "/casino/qtechgameart-luxor-secrets-holdn-win",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LuxorSecretsHoldnWin.webp",
  //     alt: "Luxor Secrets Hold’n Win",
  //     name: "Luxor Secrets Hold’n Win",
  //   },
  //   OneHandBlackjack: {
  //     href: "/casino/qtechgameart-one-hand-blackjack",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/OneHandBlackjack.webp",
  //     alt: "One-Hand Blackjack",
  //     name: "One-Hand Blackjack",
  //   },
  //   LuckyPups: {
  //     href: "/casino/qtechgameart-lucky-pups",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LuckyPups.webp",
  //     alt: "Lucky Pups",
  //     name: "Lucky Pups",
  //   },
  //   ShiningRoyal5: {
  //     href: "/casino/qtechgameart-shining-royal-5",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ShiningRoyal5.webp",
  //     alt: "Shining Royal 5",
  //     name: "Shining Royal 5",
  //   },
  //   Plinko: {
  //     href: "/casino/qtechgameart-plinko",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Plinko.webp",
  //     alt: "Plinko",
  //     name: "Plinko",
  //   },
  //   JaguarRiches: {
  //     href: "/casino/qtechgameart-jaguar-riches",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JaguarRiches.webp",
  //     alt: "Jaguar Riches",
  //     name: "Jaguar Riches",
  //   },
  //   // ShiningRoyal20: {
  //   //   href: "/casino/qtechgameart-shining-royal-20",
  //   //   code: "",
  //   //   casino: "Slots",
  //   //   provider: "Game Art",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/slots/new/gameart/ShiningRoyal20.webp",
  //   //   alt: "Shining Royal 20",
  //   //   name: "Shining Royal 20",
  //   // },
  //   VulcanoRoulette: {
  //     href: "/casino/qtechgameart-vulcano-roulette",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/VulcanoRoulette.webp",
  //     alt: "Vulcano Roulette",
  //     name: "Vulcano Roulette",
  //   },
  //   XtremeHot: {
  //     href: "/casino/qtechgameart-xtreme-hot",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/XtremeHot.webp",
  //     alt: "Xtreme Hot",
  //     name: "Xtreme Hot",
  //   },
  //   Hot20FruitDelights: {
  //     href: "/casino/qtechgameart-20-hot-fruit-delights",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/20HotFruitDelights.webp",
  //     alt: "20 Hot Fruit Delights",
  //     name: "20 Hot Fruit Delights",
  //   },
  //   DiamondMagic: {
  //     href: "/casino/qtechgameart-diamond-magic",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DiamondMagic.webp",
  //     alt: "Diamond Magic",
  //     name: "Diamond Magic",
  //   },
  //   LillyPalmer: {
  //     href: "/casino/qtechgameart-lilly-palmer",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LillyPalmer.webp",
  //     alt: "Lilly Palmer",
  //     name: "Lilly Palmer",
  //   },
  //   GreatBuffaloMegaways: {
  //     href: "/casino/qtechgameart-great-buffalo-megaways",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GreatBuffaloMegaways.webp",
  //     alt: "Great Buffalo Megaways",
  //     name: "Great Buffalo Megaways",
  //   },
  //   AngryDogs: {
  //     href: "/casino/qtechgameart-angry-dogs",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/AngryDogs.webp",
  //     alt: "Angry Dogs",
  //     name: "Angry Dogs",
  //   },
  //   DynamiteFruitsDeluxe: {
  //     href: "/casino/qtechgameart-dynamite-fruits-deluxe",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DynamiteFruitsDeluxe.webp",
  //     alt: "Dynamite Fruits Deluxe",
  //     name: "Dynamite Fruits Deluxe",
  //   },
  //   Super40HeatedSevens: {
  //     href: "/casino/qtechgameart-40-super-heated-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/40SuperHeatedSevens.webp",
  //     alt: "40 Super Heated Sevens",
  //     name: "40 Super Heated Sevens",
  //   },
  //   BookOfMuseum: {
  //     href: "/casino/qtechgameart-book-of-museum",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BookofMuseum.webp",
  //     alt: "Book of Museum",
  //     name: "Book of Museum",
  //   },
  //   StrikingJoker: {
  //     href: "/casino/qtechgameart-striking-joker",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/StrikingJoker.webp",
  //     alt: "Striking Joker",
  //     name: "Striking Joker",
  //   },
  //   WildMarmelade: {
  //     href: "/casino/qtechgameart-wild-marmelade",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/WildMarmelade.webp",
  //     alt: "Wild Marmelade",
  //     name: "Wild Marmelade",
  //   },
  //   WildWildFruit: {
  //     href: "/casino/qtechgameart-wild-wild-fruit",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/WildWildFruit.webp",
  //     alt: "Wild Wild Fruit",
  //     name: "Wild Wild Fruit",
  //   },
  //   SurfinJoker: {
  //     href: "/casino/qtechgameart-surfin-joker",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SurfinJoker.webp",
  //     alt: "Surfin’ Joker",
  //     name: "Surfin’ Joker",
  //   },
  //   XtremeSummerHot: {
  //     href: "/casino/qtechgameart-xtreme-summer-hot",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/XtremeSummerHot.webp",
  //     alt: "Xtreme Summer Hot",
  //     name: "Xtreme Summer Hot",
  //   },
  //   Fury7s40: {
  //     href: "/casino/qtechgameart-7s-fury-40",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/7sFury40.webp",
  //     alt: "7s Fury 40",
  //     name: "7s Fury 40",
  //   },
  //   RaidersOfTheLostBook: {
  //     href: "/casino/qtechgameart-raiders-of-the-lost-book",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/RaidersoftheLostBook.webp",
  //     alt: "Raiders of the Lost Book",
  //     name: "Raiders of the Lost Book",
  //   },
  //   VideoPoker: {
  //     href: "/casino/qtechgameart-video-poker",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/VideoPoker.webp",
  //     alt: "Video Poker",
  //     name: "Video Poker",
  //   },
  //   BlackJackSideBets: {
  //     href: "/casino/qtechgameart-blackjack-side-bets",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BlackJackSideBets.webp",
  //     alt: "BlackJack Side Bets",
  //     name: "BlackJack Side Bets",
  //   },
  //   GreekPantheonMegaways: {
  //     href: "/casino/qtechgameart-greek-pantheon-megaways",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GreekPantheonMegaways.webp",
  //     alt: "Greek Pantheon Megaways",
  //     name: "Greek Pantheon Megaways",
  //   },
  //   Hot20SuperFruits: {
  //     href: "/casino/qtechgameart-20-hot-super-fruits",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/20HotSuperFruits.webp",
  //     alt: "20 Hot Super Fruits",
  //     name: "20 Hot Super Fruits",
  //   },
  //   HalloweenFarm: {
  //     href: "/casino/qtechgameart-halloween-farm",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/HalloweenFarm.webp",
  //     alt: "Halloween Farm",
  //     name: "Halloween Farm",
  //   },
  //   Lucky10Sevens: {
  //     href: "/casino/qtechgameart-10-lucky-sevens",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/10LuckySevens.webp",
  //     alt: "10 Lucky Sevens",
  //     name: "10 Lucky Sevens",
  //   },
  //   FatesFury: {
  //     href: "/casino/qtechgameart-fates-fury",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/FatesFury.webp",
  //     alt: "Fate’s Fury",
  //     name: "Fate’s Fury",
  //   },
  //   Baccarat: {
  //     href: "/casino/qtechgameart-baccarat",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/Baccarat.webp",
  //     alt: "Baccarat",
  //     name: "Baccarat",
  //   },
  //   DragonKingMegaways: {
  //     href: "/casino/qtechgameart-dragon-king-megaways",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/DragonKingMegaways.webp",
  //     alt: "Dragon King Megaways",
  //     name: "Dragon King Megaways",
  //   },
  //   HotGlowingFruits: {
  //     href: "/casino/qtechgameart-hot-glowing-fruits",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/HotGlowingFruits.webp",
  //     alt: "Hot Glowing Fruits",
  //     name: "Hot Glowing Fruits",
  //   },
  //   ShiningRoyal40: {
  //     href: "/casino/qtechgameart-shining-royal-40",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/ShiningRoyal40.webp",
  //     alt: "Shining Royal 40",
  //     name: "Shining Royal 40",
  //   },
  //   BigFruitShow: {
  //     href: "/casino/qtechgameart-big-fruit-show",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BigFruitShow.webp",
  //     alt: "Big Fruit Show",
  //     name: "Big Fruit Show",
  //   },
  //   GreatBuffaloHoldnWin: {
  //     href: "/casino/qtechgameart-great-buffalo-holdn-win",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/GreatBuffaloHoldnWin.webp",
  //     alt: "Great Buffalo Hold'n Win",
  //     name: "Great Buffalo Hold'n Win",
  //   },
  //   MegaWildSpin: {
  //     href: "/casino/qtechgameart-mega-wild-spin",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MegaWildSpin.webp",
  //     alt: "Mega Wild Spin",
  //     name: "Mega Wild Spin",
  //   },
  //   OlympusMajesty: {
  //     href: "/casino/qtechgameart-olympus-majesty",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/OlympusMajesty.webp",
  //     alt: "Olympus Majesty",
  //     name: "Olympus Majesty",
  //   },
  //   LuckyLoser: {
  //     href: "/casino/qtechgameart-lucky-loser",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/LuckyLoser.webp",
  //     alt: "Lucky Loser",
  //     name: "Lucky Loser",
  //   },
  //   JungleRave: {
  //     href: "/casino/qtechgameart-jungle-rave",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/JungleRave.webp",
  //     alt: "Jungle Rave",
  //     name: "Jungle Rave",
  //   },
  //   CandyTreats: {
  //     href: "/casino/qtechgameart-candy-treats",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/CandyTreats.webp",
  //     alt: "Candy Treats",
  //     name: "Candy Treats",
  //   },
  //   SantasDownfall: {
  //     href: "/casino/qtechgameart-santas-downfall",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/SantasDownfall.webp",
  //     alt: "Santa’s Downfall",
  //     name: "Santa’s Downfall",
  //   },
  //   TotemToken: {
  //     href: "/casino/qtechgameart-totem-token",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/TotemToken.webp",
  //     alt: "Totem Token",
  //     name: "Totem Token",
  //   },
  //   EmpireofWealth: {
  //     href: "/casino/qtechgameart-empire-of-wealth",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/EmpireofWealth.webp",
  //     alt: "Empire of Wealth",
  //     name: "Empire of Wealth",
  //   },
  //   TalesOfTheSerpentMaiden: {
  //     href: "/casino/qtechgameart-tales-of-the-serpent-maiden",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/TalesoftheSerpentMaiden.webp",
  //     alt: "Tales of the Serpent Maiden",
  //     name: "Tales of the Serpent Maiden",
  //   },
  //   TheWayOfTheDead: {
  //     href: "/casino/qtechgameart-the-way-of-the-dead",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/TheWayoftheDead.webp",
  //     alt: "The Way of the Dead",
  //     name: "The Way of the Dead",
  //   },
  //   BrokenBallerina: {
  //     href: "/casino/qtechgameart-broken-ballerina",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/BrokenBallerina.webp",
  //     alt: "Broken Ballerina",
  //     name: "Broken Ballerina",
  //   },
  //   MidgardsFortuneMegaways: {
  //     href: "/casino/qtechgameart-midgards-fortune-megaways",
  //     code: "",
  //     casino: "Slots",
  //     provider: "Game Art",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/slots/new/gameart/MidgardsFortuneMegaways.webp",
  //     alt: "Midgard’s Fortune Megaways",
  //     name: "Midgard’s Fortune Megaways",
  //   },
  // },

  dragoonSoft: {
    Phoenix: {
      href: "/casino/aggapdrgs-phoenix",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Phoenix1.webp",
      alt: "Phoenix",
      name: "Phoenix",
    },
    GetMoney: {
      href: "/casino/aggapdrgs-get-money",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GetMoney.webp",
      alt: "Get Money",
      name: "Get Money",
    },
    CoinCat: {
      href: "/casino/aggapdrgs-coin-cat",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CoinCat.webp",
      alt: "Coin Cat",
      name: "Coin Cat",
    },
    AceyDeucey: {
      href: "/casino/aggapdrgs-acey-deucey",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/AceyDeucey.webp",
      alt: "Acey Deucey",
      name: "Acey Deucey",
    },
    DragonOrCrash: {
      href: "/casino/aggapdrgs-dragon-or-crash",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/DragonOrCrash.webp",
      alt: "Dragon or Crash",
      name: "Dragon or Crash",
    },
    FlyingPhoenix: {
      href: "/casino/aggapdrgs-flying-phoenix",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/FlyingPhoenix.webp",
      alt: "Flying Phoenix",
      name: "Flying Phoenix",
    },
    JumpAndJump: {
      href: "/casino/aggapdrgs-jump-and-jump",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/JumpAndJump.webp",
      alt: "Jump & Jump",
      name: "Jump & Jump",
    },
    LadderGame: {
      href: "/casino/aggapdrgs-ladder-game",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/LadderGame.webp",
      alt: "Ladder Game",
      name: "Ladder Game",
    },
    LetsEnhance: {
      href: "/casino/aggapdrgs-lets-enhance",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/LetsEnhance.webp",
      alt: "Let's Enhance",
      name: "Let's Enhance",
    },
    // LionsOrb: {
    //   href: "/casino/qtechdragoonsoft-lions-orb",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/LionsOrb.webp",
    //   alt: "Lion's Orb",
    //   name: "Lion's Orb",
    // },
    // NinjaFishing: {
    //   href: "/casino/qtechdragoonsoft-ninja-fishing",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/NinjaFishing.webp",
    //   alt: "Ninja Fishing",
    //   name: "Ninja Fishing",
    // },
    // WonderfulChristmas: {
    //   href: "/casino/qtechdragoonsoft-wonderful-christmas",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/WonderfulChristmas.webp",
    //   alt: "Wonderful Christmas",
    //   name: "Wonderful Christmas",
    // },
    // Golf2: {
    //   href: "/casino/qtechdragoonsoft-golf-2",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/Golf2.webp",
    //   alt: "Golf 2",
    //   name: "Golf 2",
    // },
    // DessertParty: {
    //   href: "/casino/qtechdragoonsoft-dessert-party",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/Dessertparty.webp",
    //   alt: "Dessert Party",
    //   name: "Dessert Party",
    // },
    PartyNight: {
      href: "/casino/qtechdragoonsoft-party-night",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/PartyNight.webp",
      alt: "Party Night",
      name: "Party Night",
    },
    // KingsSword: {
    //   href: "/casino/qtechdragoonsoft-kings-sword",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/KingsSword.webp",
    //   alt: "King's Sword",
    //   name: "King's Sword",
    // },
    CatFishing: {
      href: "/casino/aggapdrgs-cat-fishing",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CatFishing.webp",
      alt: "Cat Fishing",
      name: "Cat Fishing",
    },
    OverlordAndConcubine: {
      href: "/casino/aggapdrgs-overlord-and-concubine",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/OverlordAndConcubine.webp",
      alt: "Overlord & Concubine",
      name: "Overlord & Concubine",
    },
    Gods3Fishing: {
      href: "/casino/aggapdrgs-3-gods-fishing",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/3GodsFishing.webp",
      alt: "3 Gods Fishing",
      name: "3 Gods Fishing",
    },
    BigHammer: {
      href: "/casino/aggapdrgs-big-hammer",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BigHammer.webp",
      alt: "Big Hammer",
      name: "Big Hammer",
    },
    BingoFishing: {
      href: "/casino/aggapdrgs-bingo-fishing",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BingoFishing.webp",
      alt: "Bingo Fishing",
      name: "Bingo Fishing",
    },
    CrazyOrb: {
      href: "/casino/aggapdrgs-crazy-orb",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CrazyOrb.webp",
      alt: "Crazy Orb",
      name: "Crazy Orb",
    },
    DemonConquered: {
      href: "/casino/aggapdrgs-demon-conquered",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/DemonConquered.webp",
      alt: "Demon Conquered",
      name: "Demon Conquered",
    },
    DinoHunter: {
      href: "/casino/aggapdrgs-dino-hunter",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/DinoHunter.webp",
      alt: "Dino Hunter",
      name: "Dino Hunter",
    },
    GodsSlashFish: {
      href: "/casino/aggapdrgs-gods-slash-fish",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GodsSlashFish.webp",
      alt: "Gods Slash Fish",
      name: "Gods Slash Fish",
    },
    GoldenZuma: {
      href: "/casino/aggapdrgs-golden-zuma",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GoldenZuma.webp",
      alt: "Golden Zuma",
      name: "Golden Zuma",
    },
    LetsShoot: {
      href: "/casino/aggapdrgs-lets-shoot",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/LetsShoot.webp",
      alt: "Let's Shoot",
      name: "Let's Shoot",
    },
    OceanLord: {
      href: "/casino/aggapdrgs-ocean-lord",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/OceanLord.webp",
      alt: "Ocean Lord",
      name: "Ocean Lord",
    },
    PlantsVsDinos: {
      href: "/casino/aggapdrgs-plants-vs-dinos",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/PlantsVsDinos.webp",
      alt: "Plants vs. Dinos",
      name: "Plants vs. Dinos",
    },
    God5Beast: {
      href: "/casino/aggapdrgs-5-god-beast",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/5GodBeast.webp",
      alt: "5 God Beast",
      name: "5 God Beast",
    },
    777: {
      href: "/casino/aggapdrgs-777",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/777.webp",
      alt: "777",
      name: "777",
    },
    Alice: {
      href: "/casino/aggapdrgs-alice",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Alice.webp",
      alt: "Alice",
      name: "Alice",
    },
    Arab: {
      href: "/casino/aggapdrgs-arab",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Arab.webp",
      alt: "Arab",
      name: "Arab",
    },
    BakufuShogun: {
      href: "/casino/aggapdrgs-bakufu-shogun",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BakufuShogun.webp",
      alt: "Bakufu Shogun",
      name: "Bakufu Shogun",
    },
    BengalTiger: {
      href: "/casino/aggapdrgs-bengal-tiger",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BengalTiger.webp",
      alt: "Bengal Tiger",
      name: "Bengal Tiger",
    },
    BigDiamond: {
      href: "/casino/aggapdrgs-big-diamond",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BigDiamond.webp",
      alt: "Big Diamond",
      name: "Big Diamond",
    },
    BonusCat: {
      href: "/casino/aggapdrgs-bonus-cat",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BonusCat.webp",
      alt: "Bonus Cat",
      name: "Bonus Cat",
    },
    BoomingGems: {
      href: "/casino/aggapdrgs-booming-gems",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BoomingGems.webp",
      alt: "Booming Gems",
      name: "Booming Gems",
    },
    BuffaloBurst: {
      href: "/casino/aggapdrgs-buffalo-burst",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BuffaloBurst.webp",
      alt: "Buffalo Burst",
      name: "Buffalo Burst",
    },
    BustTreasury: {
      href: "/casino/aggapdrgs-bust-treasury",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/BustTreasury.webp",
      alt: "Bust Treasury",
      name: "Bust Treasury",
    },
    CaishenComing: {
      href: "/casino/aggapdrgs-caishen-coming",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CaishenComing.webp",
      alt: "Caishen Coming",
      name: "Caishen Coming",
    },
    CandyDynasty: {
      href: "/casino/aggapdrgs-candy-dynasty",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CandyDynasty.webp",
      alt: "Candy Dynasty",
      name: "Candy Dynasty",
    },
    ChefLady: {
      href: "/casino/aggapdrgs-chef-lady",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/ChefLady.webp",
      alt: "Chef Lady",
      name: "Chef Lady",
    },
    CoinRat: {
      href: "/casino/aggapdrgs-coin-rat",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CoinRat.webp",
      alt: "Coin Rat",
      name: "Coin Rat",
    },
    CrystalFruits: {
      href: "/casino/aggapdrgs-crystal-fruits",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/CrystalFruits.webp",
      alt: "Crystal Fruits",
      name: "Crystal Fruits",
    },
    Diamond7: {
      href: "/casino/aggapdrgs-diamond-7",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Diamond7.webp",
      alt: "Diamond 7",
      name: "Diamond 7",
    },
    DiamondMogul: {
      href: "/casino/aggapdrgs-diamond-mogul",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/DiamondMogul.webp",
      alt: "Diamond Mogul",
      name: "Diamond Mogul",
    },
    DoggyWealth: {
      href: "/casino/aggapdrgs-doggy-wealth",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/DoggyWealth.webp",
      alt: "Doggy Wealth",
      name: "Doggy Wealth",
    },
    Dracula: {
      href: "/casino/aggapdrgs-dracula",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Dracula.webp",
      alt: "Dracula",
      name: "Dracula",
    },
    Dragonburst: {
      href: "/casino/aggapdrgs-dragonburst",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Dragonburst.webp",
      alt: "Dragonburst",
      name: "Dragonburst",
    },
    DragonsTreasure: {
      href: "/casino/aggapdrgs-dragons-treasure",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/DragonsTreasure.webp",
      alt: "Dragon's Treasure",
      name: "Dragon's Treasure",
    },
    EgyptDynasty: {
      href: "/casino/aggapdrgs-egypt-dynasty",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/EgyptDynasty.webp",
      alt: "Egypt Dynasty",
      name: "Egypt Dynasty",
    },
    EgyptOracle: {
      href: "/casino/aggapdrgs-egypt-oracle",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/EgyptOracle.webp",
      alt: "Egypt Oracle",
      name: "Egypt Oracle",
    },
    FruitsBar: {
      href: "/casino/aggapdrgs-fruits-bar",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/FruitsBar.webp",
      alt: "Fruits Bar",
      name: "Fruits Bar",
    },
    FushenComing: {
      href: "/casino/aggapdrgs-fushen-coming",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/FushenComing.webp",
      alt: "Fushen Coming",
      name: "Fushen Coming",
    },
    GetHigh: {
      href: "/casino/aggapdrgs-get-high",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GetHigh.webp",
      alt: "Get High",
      name: "Get High",
    },
    GiveYouMoney: {
      href: "/casino/aggapdrgs-give-you-money",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GiveYouMoney.webp",
      alt: "Give You Money",
      name: "Give You Money",
    },
    Golf: {
      href: "/casino/aggapdrgs-golf",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Golf.webp",
      alt: "Golf",
      name: "Golf",
    },
    GrandSheriff: {
      href: "/casino/aggapdrgs-grand-sheriff",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GrandSheriff.webp",
      alt: "Grand Sheriff",
      name: "Grand Sheriff",
    },
    GreatLion: {
      href: "/casino/aggapdrgs-great-lion",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GreatLion.webp",
      alt: "Great Lion",
      name: "Great Lion",
    },
    GreatestCircus: {
      href: "/casino/aggapdrgs-greatest-circus",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GreatestCircus.webp",
      alt: "Greatest Circus",
      name: "Greatest Circus",
    },
    IcyBar: {
      href: "/casino/aggapdrgs-icy-bar",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/IcyBar.webp",
      alt: "Icy Bar",
      name: "Icy Bar",
    },
    ImmortalHeroes: {
      href: "/casino/aggapdrgs-immortal-heroes",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/ImmortalHeroes.webp",
      alt: "Immortal Heroes",
      name: "Immortal Heroes",
    },
    JinHouYe: {
      href: "/casino/aggapdrgs-jin-hou-ye",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/JinHouYe.webp",
      alt: "Jin Hou Ye",
      name: "Jin Hou Ye",
    },
    LuLingQi: {
      href: "/casino/aggapdrgs-lu-ling-qi",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/LuLingQi.webp",
      alt: "Lu Ling Qi",
      name: "Lu Ling Qi",
    },
    ManyBeauties: {
      href: "/casino/aggapdrgs-many-beauties",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/ManyBeauties.webp",
      alt: "Many Beauties",
      name: "Many Beauties",
    },
    MayaKing: {
      href: "/casino/aggapdrgs-maya-king",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/MayaKing.webp",
      alt: "Maya King",
      name: "Maya King",
    },
    MidasTouch: {
      href: "/casino/aggapdrgs-midas-touch",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/MidasTouch.webp",
      alt: "Midas Touch",
      name: "Midas Touch",
    },
    MonkeyKing: {
      href: "/casino/aggapdrgs-monkey-king",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/MonkeyKing.webp",
      alt: "Monkey King",
      name: "Monkey King",
    },
    OrePower: {
      href: "/casino/aggapdrgs-ore-power",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/OrePower.webp",
      alt: "Ore Power",
      name: "Ore Power",
    },
    OverDragonsGate: {
      href: "/casino/aggapdrgs-over-dragons-gate",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/OverDragonsGate.webp",
      alt: "Over Dragon's Gate",
      name: "Over Dragon's Gate",
    },
    Pandaria: {
      href: "/casino/aggapdrgs-pandaria",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Pandaria.webp",
      alt: "Pandaria",
      name: "Pandaria",
    },
    PirateKing: {
      href: "/casino/aggapdrgs-pirate-king",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/PirateKing.webp",
      alt: "Pirate King",
      name: "Pirate King",
    },
    RichDragon: {
      href: "/casino/aggapdrgs-rich-dragon",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/RichDragon.webp",
      alt: "Rich Dragon",
      name: "Rich Dragon",
    },
    RichLion: {
      href: "/casino/aggapdrgs-rich-lion",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/RichLion.webp",
      alt: "Rich Lion",
      name: "Rich Lion",
    },
    RichNow: {
      href: "/casino/aggapdrgs-rich-now",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/RichNow.webp",
      alt: "Rich Now",
      name: "Rich Now",
    },
    RollInMoney: {
      href: "/casino/aggapdrgs-roll-in-money",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/RollInMoney.webp",
      alt: "Roll in Money",
      name: "Roll in Money",
    },
    Roman: {
      href: "/casino/aggapdrgs-roman",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Roman.webp",
      alt: "Roman",
      name: "Roman",
    },
    StoneHominid: {
      href: "/casino/aggapdrgs-stone-hominid",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/StoneHominid.webp",
      alt: "Stone Hominid",
      name: "Stone Hominid",
    },
    TigerLord: {
      href: "/casino/aggapdrgs-tiger-lord",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/TigerLord.webp",
      alt: "Tiger Lord",
      name: "Tiger Lord",
    },
    TripleMonkey: {
      href: "/casino/aggapdrgs-triple-monkey",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/TripleMonkey.webp",
      alt: "Triple Monkey",
      name: "Triple Monkey",
    },
    TRex: {
      href: "/casino/aggapdrgs-t-rex",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/TRex.webp",
      alt: "T-Rex",
      name: "T-Rex",
    },
    UltraTreasure: {
      href: "/casino/aggapdrgs-ultra-treasure",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/UltraTreasure.webp",
      alt: "Ultra Treasure",
      name: "Ultra Treasure",
    },
    WolfLegend: {
      href: "/casino/aggapdrgs-wolf-legend",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/WolfLegend.webp",
      alt: "Wolf Legend",
      name: "Wolf Legend",
    },
    Worldie: {
      href: "/casino/aggapdrgs-worldie",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Worldie.webp",
      alt: "Worldie",
      name: "Worldie",
    },
    YouWillWin: {
      href: "/casino/aggapdrgs-you-will-win",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/YouWillWin.webp",
      alt: "You Will Win",
      name: "You Will Win",
    },
    Zeus: {
      href: "/casino/aggapdrgs-zeus",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/Zeus.webp",
      alt: "Zeus",
      name: "Zeus",
    },
    ZhaoYun: {
      href: "/casino/aggapdrgs-zhao-yun",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/ZhaoYun.webp",
      alt: "Zhao Yun",
      name: "Zhao Yun",
    },
    GoldenEgg: {
      href: "/casino/aggapdrgs-golden-egg",
      code: "",
      casino: "Slots",
      provider: "Dragoon Soft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/dragoon-soft/GoldenEgg.webp",
      alt: "Golden Egg",
      name: "Golden Egg",
    },
    // MahjongWin: {
    //   href: "/casino/qtechdragoonsoft-mahjong-win",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/MahjongWin.webp",
    //   alt: "Mahjong Win",
    //   name: "Mahjong Win",
    // },
    // SuperHooHeyHow: {
    //   href: "/casino/qtechdragoonsoft-super-hoo-hey-how",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/SuperHooHeyHow.webp",
    //   alt: "Super Hoo Hey How",
    //   name: "Super Hoo Hey How",
    // },
    // MuchRicher: {
    //   href: "/casino/qtechdragoonsoft-much-richer",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/MuchRicher.webp",
    //   alt: "Much Richer",
    //   name: "Much Richer",
    // },
    // GoddessOrCrash: {
    //   href: "/casino/qtechdragoonsoft-goddess-or-crash",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/GoddessOrCrash.webp",
    //   alt: "Goddess or Crash",
    //   name: "Goddess or Crash",
    // },
    // FireBallBlazePhoenix: {
    //   href: "/casino/qtechdragoonsoft-fire-ball-blaze-phoenix",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/FireBallBlazePhoenix.webp",
    //   alt: "Fire Ball Blaze Phoenix",
    //   name: "Fire Ball Blaze Phoenix",
    // },
    // MidasHand: {
    //   href: "/casino/qtechdragoonsoft-midas-hand",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/MidasHand.webp",
    //   alt: "Midas Hand",
    //   name: "Midas Hand",
    // },
    // HappyFish: {
    //   href: "/casino/qtechdragoonsoft-happy-fish",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/HappyFish.webp",
    //   alt: "Happy Fish",
    //   name: "Happy Fish",
    // },
    // DancingSamba: {
    //   href: "/casino/qtechdragoonsoft-dancing-samba",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/DancingSamba.webp",
    //   alt: "Dancing Samba",
    //   name: "Dancing Samba",
    // },
    // FortuneTwins: {
    //   href: "/casino/qtechdragoonsoft-fortune-twins",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/FortuneTwins.webp",
    //   alt: "Fortune Twins",
    //   name: "Fortune Twins",
    // },
    // AztecTreasure: {
    //   href: "/casino/qtechdragoonsoft-aztec-treasure",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/AztecTreasure.webp",
    //   alt: "Aztec Treasure",
    //   name: "Aztec Treasure",
    // },
    // OdinTerritory: {
    //   href: "/casino/qtechdragoonsoft-odin-territory",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/OdinTerritory.webp",
    //   alt: "Odin Territory",
    //   name: "Odin Territory",
    // },
    // CrazyBartender: {
    //   href: "/casino/qtechdragoonsoft-crazy-bartender",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Dragoon Soft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/dragoon-soft/CrazyBartender.webp",
    //   alt: "Crazy Bartender",
    //   name: "Crazy Bartender",
    // },
  },

  spribe: {
    aviator: {
      href: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Aviator.webp",
      alt: "aviator",
      name: "aviator",
    },
    mines: {
      href: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Mines.webp",
      alt: "mines",
      name: "mines",
    },
    goal: {
      href: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Goal.webp",
      alt: "goal",
      name: "goal",
    },
    dice: {
      href: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Dice.webp",
      alt: "dice",
      name: "dice",
    },
    plinko: {
      href: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Plinko.webp",
      alt: "plinko",
      name: "Plinko",
    },
    miniroulette: {
      href: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "",
      imgUrl: "./images/spribe/new/MiniRoulette.webp",
      alt: "mini roulette",
      name: "Mini Roulette",
    },
    hilo: {
      href: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "miniroulette",
      provider: "hi-lo",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Hilo.webp",
      alt: "hilo",
      name: "Hilo",
    },
    keno: {
      href: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Keno.webp",
      alt: "keno",
      name: "Keno",
    },
    hotline: {
      href: "/casino/spribe/hotline",
      code: "hotline",
      casino: "spribe",
      provider: "hotline",
      homeUrl: "",
      imgUrl: "./images/spribe/new/Hotline.webp",
      alt: "hotline",
      name: "Hotline",
    },
  },
};
